{
  "account-deletion": {
    "disclaimer": "Deleting your account is permanent.",
    "primaryButtonText": "Delete account",
    "subtitle": "Your profile, your offers, your needs, your data and your conversations with the members will be permanently deleted.",
    "title": "Delete account",
    "backButtonText": "Cancel"
  },
  "accordion": {
    "showMore": "Show more",
    "showLess": "Show less"
  },
  "accessibility": {
    "favourite": {
      "add": "Favorite item",
      "remove": "Unfavorite item"
    },
    "close": "Close",
    "goBack": "Go back",
    "shareListing": "Share listing",
    "resetPassword": {
      "close": "Close reset password"
    },
    "forgotPassword": {
      "close": "Close forgot password"
    },
    "request": {
      "hide": "Hide",
      "hideHint": "Hides this request from your feed",
      "restore": "Restore"
    },
    "imagePicker": {
      "addImage": "Add a photo",
      "addImageHint": "Adds another photo to your listing",
      "removeImage": "Remove photo",
      "removeImageHint": "Removes this photo from your listing",
      "openCamera": "Camera",
      "openLibrary": "Photo gallery"
    },
    "imageSwiper": {
      "previous": "Previous image",
      "next": "Next image"
    },
    "avatar": {
      "edit": "Change my photo"
    },
    "chat": {
      "minimizeConversation": "Minimize conversation",
      "messageActions": "Message actions",
      "newConversation": "New conversation",
      "moreActions": "More actions",
      "moreActionsHint": "Opens a menu with mute, unread, rename, leave, and delete actions",
      "toolbar": {
        "openCamera": "Open camera",
        "openLibrary": "Open photo library",
        "sendLike": "Send a thumbs-up",
        "sendMessage": "Send message"
      }
    },
    "list": {
      "toggleViewMode": "Toggle view mode"
    },
    "carousel": {
      "previousSlide": "Previous slide",
      "previousSlideHint": "Scrolls the list to the left",
      "nextSlide": "Next slide",
      "nextSlideHint": "Scrolls the list to the right"
    },
    "search": {
      "clearSearch": "Clear search",
      "clearSearchHint": "Clears the current search text"
    },
    "profile": {
      "moreActions": "More profile actions",
      "editUnavailabilityStatus": "Edit unavailability status",
      "viewMember": "View {{name}}'s profile"
    }
  },
  "download": {
    "download": "Download",
    "the_app": "the app"
  },
  "loginAsPrompt": {
    "title": "Log in as {{userName}}?",
    "message": "Do you want to be logged in as {{userName}}?",
    "no": "No",
    "yes": "Yes"
  },
  "all-channels": {
    "sharedListing": "{{sender}} shared a listing",
    "sharedProfile": "{{sender}} shared a profile",
    "tabBarLabel": "Messages",
    "title": "Conversations",
    "headerWithUnreadCount": "Messages ({{count}}) - Unread {{unreadCount}}",
    "archive": "Archive",
    "archived": "Archived",
    "archivedConfirmation": "Conversation archived",
    "archivedUndo": "Unarchive",
    "markAsUnreadButton": "Mark as unread",
    "archiveButton": "Archive",
    "cancelSelection": "Cancel",
    "markAsUnreadSwipe": "Mark unread",
    "silence": "Silence",
    "unsilence": "Unmute",
    "markingAsRead": "Conversation was marked as unread.",
    "lookingForArchive": "To archive, swipe right instead.",
    "empty": {
      "secondLine": {
        "recent": "You haven't exchanged messages with a member recently.",
        "archived": "You have no archived conversations.\nSwipe a conversation to archive it."
      }
    },
    "footer": {
      "title": "Where are my other conversations?",
      "text": "Old conversations get archived automatically. Click the Archived tab at the top to see them.",
      "button": "Go to Archived conversations"
    },
    "file": "[Photo]",
    "filters": {
      "listing": "By item",
      "personal": "By member"
    },
    "loan": {
      "accepted": "Proposed loan - accepted",
      "completed": "Loan completed",
      "pending": "Proposed loan - pending",
      "rejected": "Proposed loan - declined"
    },
    "service": {
      "accepted": "Service offer - accepted",
      "completed": "Service provided",
      "pending": "Service offer - pending",
      "rejected": "Service offer - declined"
    },
    "donation": {
      "accepted": "Donation offer - accepted",
      "completed": "Donation concluded",
      "pending": "Donation offer - pending",
      "rejected": "Donation offer - declined"
    },
    "sell": {
      "accepted": "Proposed sale - accepted",
      "completed": "Sale completed",
      "pending": "Proposed sale - pending",
      "rejected": "Proposed sale - declined"
    },
    "noResponse": "Received {{ago}} ago. Reply?",
    "tabs": {
      "recent": "Recent",
      "archived": "Archived"
    },
    "noChannelSelected": "No conversation selected",
    "groupConversationCount_one": "{{count}} conversation",
    "groupConversationCount": "{{count}} conversations"
  },
  "landing-page": {
    "tabs": {
      "explore": "Explore",
      "home": "Home",
      "feed": "Community",
      "catalog": "Explore"
    },
    "manageMyInterests": "Manage my interests",
    "recentSearches": "Recent searches",
    "popularTags": "Popular interests",
    "viewAllListings": "View all listings",
    "quickActions": {
      "loanOutgoing_one": "1 lending",
      "loanOutgoing_other": "{{count}} lendings",
      "loanIncoming_one": "1 borrowing",
      "loanIncoming_other": "{{count}} borrowings",
      "noActivity": "No activity",
      "activity": "Activity",
      "messages": "Messages",
      "pendingRatings": "Ratings",
      "pendingRatingsSubtitle_one": "1 to do",
      "pendingRatingsSubtitle_other": "{{count}} to do",
      "unread": "unread",
      "noUnread": "No unread messages",
      "createPost": "Share an experience",
      "createPostSubtitle_one": "1 exchange to share",
      "createPostSubtitle_other": "{{count}} exchanges to share"
    },
    "upcomingActivity": {
      "title": "Upcoming activity",
      "allTitle": "Loan activity",
      "window": "Your next 3 days",
      "allWindow": "All your active loans",
      "filteredWindow": "Activity within {{period}}",
      "viewAll": "View all",
      "openDetails": "Opens the loan details",
      "deletedUser": "Deleted user",
      "calendar": {
        "addLabel": "Add this date to my calendar",
        "addedLabel": "Added to my calendar",
        "added": "{{item}} was added to your calendar"
      },
      "filters": {
        "all": "All",
        "threeDays": "3 days",
        "oneWeek": "1 week",
        "oneMonth": "1 month",
        "threeMonths": "3 months",
        "sixMonths": "6 months",
        "empty": "No activity in this period"
      },
      "roles": {
        "lending": "Lending",
        "borrowing": "Borrowing"
      },
      "donationRoles": {
        "lending": "Donation offered",
        "borrowing": "Donation received"
      },
      "saleRoles": {
        "lending": "Sale",
        "borrowing": "Purchase"
      },
      "actions": {
        "completePurchase": "Confirm receipt from {{name}}",
        "completeSale": "Confirm sale to {{name}}",
        "handOff": "Hand over to {{name}}",
        "pickUp": "Pick up from {{name}}",
        "returnItem": "Return to {{name}}",
        "expectReturn": "Expect back from {{name}}",
        "confirmReturn": "Confirm return from {{name}}",
        "confirmSale": "Confirm sale with {{name}}"
      },
      "relative": {
        "actionRequired": "Action needed",
        "overdue_one": "1 day overdue",
        "overdue_other": "{{count}} days overdue",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "inDays_one": "In 1 day",
        "inDays_other": "In {{count}} days"
      },
      "empty": {
        "title": "You're all caught up",
        "subtitle": "Nothing needs your attention in the next 3 days."
      }
    },
    "stepsToComplete": {
      "stepsCompleted": "{{completed}} out of {{total}} step(s) completed",
      "nextStep": "Next: {{step}}",
      "title": "Complete your profile",
      "description": "Build trust with members by completing your profile...",
      "completedTitle": "Profile completed, well done! 🎉",
      "completedSubtitle": "You inspire trust among community members",
      "addPicture": "Add a picture",
      "addBio": "Add a bio",
      "setInterests": "Set your interests",
      "addListings": "Add ({{count}}/5) items to lend"
    },
    "popularInterests": "Popular interests 📈",
    "myInterests": "My interests 🎯",
    "noInterestsTitle": "Personalise your discovery",
    "noInterestsSubtitle": "Pick your interests and get suggestions tailored to you.",
    "addInterestsCta": "Add my interests",
    "greeting": {
      "morning": "Good morning",
      "afternoon": "Good afternoon",
      "evening": "Good evening"
    },
    "subscription": {
      "discovery": "Discovery"
    },
    "unlockFullExperience": {
      "accessibilityLabel": "Unlock the full experience",
      "title": "Unlock the full experience!",
      "discount": "-25%",
      "discountDeadline": "until {{date}}"
    },
    "requests": {
      "emptyState": {
        "title": "Nothing to display at the moment.",
        "subtitle": "We will notify you if your neighbors need help",
        "cta": "View all needs"
      }
    },
    "theme": "Theme of the week",
    "multipleOfferCard": {
      "new": "New",
      "quickOffers": "Publish items",
      "desktopBadge": "Quick offer ⚡",
      "title": "You probably have these items at home!",
      "desktopSubtitle": "Good news, the offers are already ready to publish",
      "subtitle": "Good news, the offers are already ready to publish",
      "button": "Publish in a flash",
      "desktopButton": "Publish in a flash"
    },
    "viewMore": "View more",
    "viewLess": "View less",
    "carousel": {
      "previousSlide": "Previous slide",
      "nextSlide": "Next slide",
      "previousSlideHint": "Scrolls the list to the left",
      "nextSlideHint": "Scrolls the list to the right"
    },
    "immature": {
      "defricheur": {
        "title": "Pioneer offer",
        "text": "There are few items in your neighbourhood. <strong>Free subscription for the first 5</strong> who publish an item.",
        "button": "Publish an offer"
      },
      "referral": {
        "title": "Help us grow the community. Invite <strong>5 people</strong> and earn <strong>a gift worth $25!</strong>",
        "progress": "{{current}} out of {{total}}",
        "button": "Invite your neighbours",
        "seeConditions": "See conditions"
      },
      "writeToMayor": {
        "title": "Ask your city to offer Partage Club to its citizens",
        "text": "We've written a letter you can send directly. Just fill out the request form on our website",
        "button": "Write to the mayor",
        "textLetter": "We've written a letter you can personalize and send to your city's mayor."
      },
      "socialMedia": {
        "title": "Follow us on social media!",
        "text": "Join thousands of trusted sharers"
      }
    }
  },
  "my-interests": {
    "title": "My interests 🎯",
    "subtitle": "Select your interests to personalise your discovery experience",
    "searchPlaceholder": "Search an interest…",
    "selectedSection": "Selected ({{count}})",
    "exploreSection": "All interests",
    "noResults": "No results for \"{{query}}\"",
    "emptyTitle": "No interests selected",
    "emptySubtitle": "Tap an interest below to add it to your profile"
  },
  "all-listings": {
    "map": {
      "signInToExplore": "Sign in to explore the map.",
      "approximateLocation": "Approximate location",
      "switchToMap": "Switch to map view",
      "switchToList": "Switch to list view"
    },
    "emptyRequests": {
      "title": "The most recent needs appear here",
      "secondTitle": "Nothing to show right now. Be the first to add a need!",
      "button": "Add a need"
    },
    "bonificationPrompt": {
      "title_one": "One item to improve",
      "title": "{{numListings}} items to improve",
      "text_one": "You have <strong>one item</strong> with a generic photo or no description. Items with complete information are more likely to be borrowed.",
      "text": "You have <strong>{{numListings}} items</strong> with a generic photo or no description. Items with complete information are more likely to be borrowed.",
      "button_one": "Complete the item details",
      "button": "View my listings",
      "dismiss": "Dismiss"
    },
    "pendingBonificationsBanner": {
      "title_one": "1 suggestion to review",
      "title": "{{count}} suggestions to review",
      "subtitle": "A borrower has suggested improvements for your listing.",
      "item": "View suggestion"
    },
    "bonificationBadge": "To improve",
    "bonificationBadge2": "Quality",
    "numComments_one": "1 comment",
    "numComments_other": "{{count}} comments",
    "hasAcceptedLoan": "has lent the item",
    "hasAcceptedLoanAgo": "has lent the item {{ago}} ago",
    "addAddressPrompt": {
      "button": "Add a neighbourhood",
      "text": "At the office, at school, at the chalet, or at your parents' place: if you go there often, it’s worth broadening your search.",
      "title": "Add an address"
    },
    "addPhoneNumberPrompt": {
      "banner": {
        "button": "Add my phone number",
        "text": "Adding <strong>your phone number</strong> helps members reach you more easily to arrange loans.",
        "title": "Your profile is {{percent}}% complete"
      },
      "bottom-sheet": {
        "button": "Add my phone number",
        "text": "Adding <strong>your phone number</strong> helps members reach you more easily to arrange loans.",
        "title": "Your profile is {{percent}}% complete"
      }
    },
    "addressAddedToast": {
      "text": "To change it or add others, go to Profile > My Clubs",
      "title": "New club created"
    },
    "allCategories": "All",
    "peopleSearch": {
      "title": "People",
      "empty": "No members matched this search.",
      "viewAll": "View all",
      "subtitle": "{{count}} member found nearby",
      "subtitle_other": "{{count}} members found nearby"
    },
    "filters": {
      "all": "All",
      "name": "Filters"
    },
    "guest": {
      "locationHint": "Set your location to see the items available near you.",
      "addressError": "We couldn't find that address or postal code.",
      "apply": "Apply",
      "bannerCta": "Get the app",
      "bannerText": "The fastest way to add equipment to your profile.",
      "bannerTitle": "Post your items in a flash with the mobile app",
      "categories": "Categories",
      "distance": "Within {{distance}} km",
      "distanceTitle": "Within a radius of:",
      "locating": "Finding your position…",
      "location": "Location",
      "locationError": "We couldn't access your position. The default location is still selected.",
      "locationTitle": "Location",
      "maximumDistance": "Maximum ({{distance}} km)",
      "mobileBannerTitle": "Open in the {{appName}} mobile app",
      "myPosition": "My position",
      "myPositionHint": "Discover offers near you",
      "postalCode": "Address or postal code",
      "reset": "Reset",
      "tags": "Tags"
    },
    "banner": {
      "halloween": {
        "title": "Abracadabra!",
        "text": "Suggest costumes in 1-click!",
        "button": "Offer them"
      },
      "xmas": {
        "text": "The holidays are approaching! Help your neighbours find these frequently requested items.",
        "button": "Check out the suggestions"
      }
    },
    "canOffer": "I can lend",
    "createYourNeed": "Add your own need",
    "createYourOffer": "Add your own offer",
    "dateRange": "From {{start}} to {{end}}",
    "disconnected": {
      "text": "Sign up or log in to browse offers near you.",
      "buttonSignUp": "Create my account",
      "buttonLogIn": "I already have an account",
      "buttonCode": "Have an invitation code?"
    },
    "empty": {
      "offer": {
        "firstLine": "Start your journey here!",
        "primaryButtonText": "Publish an offer!",
        "secondLine": "Members will be able to see it and send you a request to borrow it."
      },
      "request": {
        "firstLine": "Not finding what you're looking for?",
        "primaryButtonText": "Publish a need!",
        "secondLine": "Members can help find what you’re looking for."
      },
      "invite": {
        "firstLine": "Start your journey here!",
        "primaryButtonText": "Invite your neighbours",
        "secondLine": "Invite your neighbours or publish an offer in your club."
      },
      "nothing": {
        "firstLine": "No listings for now.",
        "secondLine": "It should not take long!"
      },
      "nothingServicesOnly": {
        "firstLine": "Nothing to harvest at the moment.",
        "secondLine": "Keep an eye open: requests arrive with the seasons!"
      }
    },
    "filter": {
      "neighborhoodClubCheckbox": "<strong>Neighbourhood Club</strong>{{suffix}}",
      "neighborhoodClub": "Neighbourhood Club"
    },
    "found": "Found!",
    "groupingMembers": "{{count}} members",
    "groupingMembersMany": "{{count}}+ members",
    "headline": "Headline",
    "inviteOthersPrompt": {
      "title": "Help us grow the community in your neighbourhood!",
      "description": "Your neighbourhood seems to have few members nearby, but you can change that!",
      "ctaButton": "Invite your neighbours"
    },
    "levelUpModal": {
      "primaryButtonText": "See my impact",
      "secondaryButtonText": "Close",
      "text": "You've increased your impact by publishing your first offer. You have reached a new level: <strong>Contributor</strong>.",
      "title": "Well done!"
    },
    "moreResultsWithoutDistanceFilter": "Search farther than <strong>{{distance}}</strong>",
    "nearYou": "New near you",
    "needLogin": {
      "firstLine": "Start your journey here!",
      "primaryButtonText": "Sign in",
      "secondLine": "Sign in to see what's available in your neighbourhood."
    },
    "needsAppUpdateTitle": "Update required",
    "needsAppUpdateText": "To benefit from the latest features, you need to update the app using the Apple App Store, or the Google Play Store.",
    "needsAppUpdateButtonTextIOS": "Open the App Store",
    "needsAppUpdateButtonTextAndroid": "Open the Play Store",
    "neighborOffer": "Offer from a member",
    "neighborRequest": "Need from a member",
    "noDateRange": "Flexible dates",
    "flexibleLabel": "(flexible)",
    "new": "New",
    "nearby": "Nearby",
    "noResults": {
      "firstLine": "Members have not yet published any items in your neighbourhood.",
      "primaryButtonText": "Post",
      "secondLine": "Be the first to do so!"
    },
    "numResults": {
      "default_zero": "No items found",
      "default_one": "{{count}} item found",
      "default": "{{count}} items found",
      "offer_zero": "Items to borrow",
      "offer_one": "{{count}} item to borrow",
      "offer": "{{count}} items to borrow",
      "request_zero": "Needs",
      "request_one": "{{count}} need",
      "request": "{{count}} needs",
      "publicDonations_zero": "Donations available",
      "publicDonations_one": "{{count}} donation available",
      "publicDonations": "{{count}} donations available"
    },
    "offeredBy": "Lent by {{firstName}} {{lastName}}",
    "postNeedPrompt": {
      "afterResults": {
        "button": "Publish a need",
        "text": "Ask your community!\n<strong>1 in 3 needs</strong> is fulfilled within <strong>24 hours</strong>.",
        "title": "🥳"
      },
      "noResults": {
        "button": "Publish a need",
        "text": "Ask your community!\n<strong>1 in 3 needs</strong> is fulfilled within <strong>24 hours</strong>.",
        "title": "🥳"
      }
    },
    "searchAssistant": {
      "title": "We can search for you!",
      "body": "Would you like our smart assistant to contact lenders who might have <strong>{{itemName}}</strong>?",
      "bodyNote": "You can adjust the search details right after.",
      "dismiss": "Not now",
      "confirm": "Yes, start the search",
      "close": "Close"
    },
    "postOfferPrompt": {
      "first": {
        "button": "Publish an offer!",
        "text": "Publish 5 offers to win your <strong>annual subscription</strong>!",
        "title": "Win your subscription!"
      },
      "firstAfter": {
        "button": "Invite your neighbours",
        "text": "Contribute to grow your neighbourhood and encourage generosity!",
        "title": "Invite your neighbours!"
      },
      "second": {
        "button": "Publish an offer!",
        "text": "With the multiple offer, publish faster than lightning.",
        "title": "Publish in 10 seconds"
      },
      "third": {
        "button": "Publish a need!",
        "text": "Members often have more items to lend than what is displayed. Ask, you never know.",
        "title": "Ask your neighbours"
      }
    },
    "promoDragonText": "« Dans l'oeil du dragon » <strong>promotion</strong>. Get an <strong>annual subscription</strong> at $30 instead of $60.",
    "promoDragonText2": "⌛ Until April 24, 2024 11:59 pm",
    "promoDragonButtonText": "Get 50% off (now $30)",
    "promoFreeSub": {
      "defricheur": {
        "text": "⏳ Only {{numDays}} days left to enjoy your free trial. Publish offers to win your subscription!",
        "text1": "⏳ Last day to enjoy your free trial. Publish offers to win your subscription!",
        "button": "Win your annual subscription"
      },
      "trial": {
        "text": "⏳ Only {{numDays}} days left to enjoy your free trial. Check out our offer and get your free subscription!",
        "text1": "⏳ Last day to enjoy your trial period. Get your free subscription with our special offer!",
        "button": "Enjoy our special offer!"
      }
    },
    "quickOffer": {
      "text": "Publish in 10 seconds!",
      "title": "Quick publish"
    },
    "partialSearchBar": {
      "placeholder": "Search in this list",
      "empty": "No items match this search."
    },
    "sortTitle": "Sort by",
    "sortBy": {
      "distance": "Distance",
      "date": "Newest",
      "startDate": "Date",
      "popularity": "Popularity",
      "random": "Random",
      "relevance": "Relevance",
      "urgency": "Urgency"
    },
    "subtype": {
      "object": "Object",
      "service": "Service"
    },
    "tabs": {
      "offer": "Offers",
      "people": "People",
      "request": "Needs",
      "donations": "Donations",
      "services": "Needs"
    },
    "topListings": {
      "title": "Popular offers",
      "viewMore": {
        "details": "Browse all offers sorted by popularity.",
        "cta": "Let's go!"
      }
    },
    "featured": {
      "title": "Featured"
    },
    "recommended": {
      "title": "Recommended for you"
    },
    "urgent": "Urgent",
    "dateTag": {
      "from": "From {{date}}",
      "until": "Until {{date}}",
      "range": "{{start}} to {{end}}",
      "remaining_one": "{{count}} day left",
      "remaining_other": "{{count}} days left",
      "urgent": "Urgent",
      "urgentRemaining_one": "Urgent · {{count}} day left",
      "urgentRemaining_other": "Urgent · {{count}} days left"
    },
    "mode": {
      "lend": "Loan",
      "sell": "Sale",
      "give": "Give"
    },
    "requestMode": {
      "lend": "Loan",
      "sell": "Purchase",
      "give": "Donation"
    },
    "activeSearch": "Active search",
    "dismissAction": "Hide",
    "dismissAccessibilityHint": "Hides this request from your feed",
    "undismissAction": "Restore",
    "dismissToast": {
      "title": "Request hidden",
      "undo": "Undo"
    },
    "focused-user-listings": "Showing {{userName}}'s listings",
    "user-display-name-fallback": "This member",
    "userMetaModal": {
      "polymtl_segment_user_type": {
        "prompt": "Help us better understand how the app is used at Poly! I am …",
        "options": {
          "student": "Student",
          "staff": "Faculty or staff member"
        }
      }
    }
  },
  "api-errors": {
    "Municipal activation code already active": "This code is already active on your account.",
    "Social sign-in failed": "Social sign-in failed. Try again, or sign in with your email and password. If you do not have a password or have forgotten it, use the password reset option on the login form.",
    "generic-title": "API Connection Error",
    "An account cannot move into or out of the United States by changing its address.": "Once an account is created, its address cannot move into or out of the United States.",
    "The last admin cannot leave or be removed before another member is promoted.": "You need to promote another admin before leaving this conversation.",
    "Attempt limit exceeded, please try after some time.": "Attempt limit exceeded, please try after some time.",
    "An account already exists for this email address. Please use the log in form.": "An account already exists for this email address. Please use the log in form.",
    "Can't delete listing that has accepted loan.": {
      "offer": "You cannot delete an offer that has an accepted loan in progress. Either cancel or mark this item as returned before deleting this listing.",
      "request": "You cannot delete a need that has an accepted loan in progress. The item owner will need to confirm the return before you can delete this listing."
    },
    "Date is required": "You need to choose a date",
    "Failed to apply invite code.": "Failed to apply invite code.",
    "Incorrect email or password": "Incorrect email or password",
    "Network Error": "Network unavailable",
    "Outside geofence": "It is not possible to use this code outside of the allowed zone.",
    "Please complete your profile before creating a listing.": "Please complete your profile before creating a listing.",
    "Please enter a valid activation code.": "Please enter a valid invitation code.",
    "No user exists with the specified email.": "No user exists with the specified email.",
    "The provided address was not found.": "The provided address was not found.",
    "The provided password is incorrect": "The provided (current) password is incorrect.",
    "You already created a listing for this item in this category": "You already created a listing for this item in this category.",
    "You are not authorized to use this code": "You are not authorized to use this code.",
    "You need a valid license to post a need.": "You need a valid license to post a need."
  },
  "app_update": {
    "button_cancel": "Cancel",
    "button_ok": "Ok",
    "question": "Would you like to update?",
    "title": "A new update is available."
  },
  "billboard": {
    "tabBarLabel": "Home",
    "title": "Easily find",
    "title_2": "the item you need!",
    "unauthenticatedTitle": "Create an account or log in",
    "unauthenticatedTitle_2": "to see offers near you.",
    "invitationCode": "Do you have an invitation code?",
    "buttonSignUp": "Create my account",
    "buttonLogIn": "I already have an account",
    "requestTitle": "Needs",
    "publishOfferButton": "Publish an offer",
    "publishNeedButton": "Add a need",
    "viewAllCatalogButton": "View the complete catalog",
    "browseByCategories": "Browse by categories",
    "needsTitle": "These members need help"
  },
  "calendar": {
    "disabled": "You cannot change the dates of a need that is currently in progress or past due."
  },
  "calendar-settings": {
    "calendarModal": {
      "primaryButtonText": "Go to Settings",
      "secondaryButtonText": "Cancel",
      "text": "To start adding event to your phone calendar, simply access your phone's settings and grant full access for Calendar.",
      "title": "Enable Calendar"
    },
    "title": "Add to calendar"
  },
  "change-password": {
    "newPasswordConfirmationFieldLabel": "New password confirmation",
    "newPasswordConfirmationFieldPlaceholder": "",
    "newPasswordFieldLabel": "New password",
    "newPasswordFieldPlaceholder": "",
    "passwordFieldLabel": "Current password",
    "passwordFieldPlaceholder": "",
    "primaryButtonText": "Save",
    "title": "Change Password"
  },
  "chooseUserType": {
    "title": "Welcome!",
    "alreadyHaveAccount": "Already have an account?",
    "clickHere": "Log in",
    "loggedIn": "You're logged in!",
    "loggedInRedirect": "You will be redirected automatically.",
    "instructionsLoggedIn": "Choose your profile below to finish setting up your account:",
    "instructions": "Or choose your profile below:",
    "type": {
      "desc": {
        "pro": "Access reserved for farms, trainers, and organizations involved in local agriculture.\n\n<strong>Invitation code required.</strong>",
        "public": "For citizens who wish to get involved."
      },
      "button": {
        "pro": "Professionals",
        "public": "General public"
      }
    }
  },
  "closestListingsModal": {
    "breadcrumb": {
      "first": "Your interests",
      "second": "Your selection",
      "third": "Send"
    },
    "title": "Break the ice and make your first loan!",
    "instructions": "Select the categories you're interested in, and we'll show you some great finds!",
    "buttonText": "Continue →"
  },
  "closestListingsChoose": {
    "instructions": "Choose the item you’d like to borrow — we’ll take care of the rest.",
    "buttonText": "Check availability",
    "messageToSend": "Hello {{name}},\nI'm interested in your offer. Do you have any availability soon?",
    "chatToast": "We reached out for you. Now, suggest your borrowing dates!"
  },
  "collection": {
    "title": "Collection: {{name}}",
    "iHaveThis": "I have this!",
    "iNeedThis": "I need this",
    "itemHasListingsIStillNeedThisPrompt": "If the above offers are not what you're looking for, you can always post a need using this button.",
    "moreMembers": "+ {{num}} more",
    "nobodyOfferedYet": "⭐️ Be the first in your hood!",
    "postNeedPrompt": {
      "button": "Post a Need!",
      "text": "Members can help find what you’re looking for.",
      "title": "Need something special?"
    },
    "subscribe": "Subscribe",
    "subscriptionSuccess": "You successfully subscribed to this item. You will receive notifications when members post a new offer for this item.",
    "successfullyAddedNeed": "Need posted",
    "successfullyAddedOffer": "Offer posted",
    "successfullyAddedOfferNow": "Whoo-hoo!",
    "unsubscribe": "Subscribed",
    "unsubscriptionSuccess": "You successfully unsubscribed from this item. You will no longer receive notifications about this item."
  },
  "common": {
    "perishable": "Perishable",
    "goBack": "Go back",
    "ambassador": "Ambassador",
    "ambassadorAndSuper": "Super Sharer |\n<color>Ambassador</color>",
    "appName": "Partage Club",
    "appDownloadPrompt": {
      "title": "Download the app",
      "guest": "Like what you see? Get Partage Club on your phone and receive new availability near you",
      "dateProposal": "Download the app to be notified as soon as {{firstName}} replies",
      "listingPublished": "Download the app to post offers and needs even more easily!",
      "thisMember": "this member",
      "qrCodeAccessibilityLabel": "QR code to download the Partage Club app",
      "openStore": "Open {{store}}"
    },
    "applicationError": {
      "firstLine": "Oops, that wasn't supposed to happen! We are working to fix this issue.",
      "secondLine": "Here are a few things you can try:\n\n• Wait a few seconds, then use the 'Try Again' button below.\n\n• Close the app completely, and relaunch it.\n\n• Go to the Profile screen, log out, then log back in {{connectHow}}\n\n• Uninstall the app from your device, and reinstall it.\n\n• If none of these help, write to us ASAP at support@partage.club.",
      "connectHow": {
        "empty": "",
        "email": "using the email address {{email}}",
        "loginWithApple": "using the 'Log in with Apple' button"
      },
      "primaryButtonText": "Try Again"
    },
    "applyUpdateLabel": "Apply Update",
    "archived": "Archived",
    "available": "Available",
    "back": "Back",
    "cancel": "Cancel",
    "cityRequiredError": "Please enter a city.",
    "dateFormat_MMMd": "MMM d",
    "dateFormat_MMMMd": "MMMM d",
    "dateFormat_EEEEMMMMd": "EEEE, MMMM d",
    "dateFormat_MMMYYYY": "MMM. yyyy",
    "dateFormat_MMMdYYYY": "MMM d, yyyy",
    "dateFormat_MMMMdYYYY": "MMMM d, yyyy",
    "deleted": "Deleted",
    "deletedUser": "Deleted User",
    "donation": {
      "label": "<strong>Donation</strong>",
      "lastDay": "<strong>Last day</strong>",
      "numDays_one": "<strong>1 day</strong> left",
      "numDays": "<strong>{{count}} days</strong> left",
      "numMonths_one": "> <strong>1 month</strong> left",
      "numMonths": "> <strong>{{count}} months</strong> left"
    },
    "expiredLoans": {
      "firstParagraph": "<strong>{{item}}</strong> from <strong>{{firstName}} {{lastName}}</strong> was due on {{date}}.",
      "secondParagraph": "Please confirm the return or modify the loan dates by clicking here.",
      "sectionTitle_one": "{{count}} late loan",
      "sectionTitle": "{{count}} late loans",
      "title": "Did you return the loaned item?"
    },
    "expiredService": {
      "firstParagraph": "<strong>{{firstName}} {{lastName}}</strong> was supposed to help you with <strong>{{item}}</strong> on {{date}}.",
      "secondParagraph": "Confirm that the service was provided or update the dates by clicking here.",
      "sectionTitle_one": "{{count}} late service",
      "sectionTitle": "{{count}} late services",
      "title": "Has the service been provided?"
    },
    "expiredDonation": {
      "firstParagraph": "You were supposed to pick up <strong>{{item}}</strong> on {{date}} from <strong>{{firstName}} {{lastName}}</strong>.",
      "secondParagraph": "Confirm that the pick up was completed or update the dates by clicking here.",
      "sectionTitle_one": "{{count}} late donation",
      "sectionTitle": "{{count}} late donations",
      "title": "Was this donation picked up?"
    },
    "expiredSale": {
      "firstParagraph": "The sale of <strong>{{item}}</strong> with <strong>{{firstName}} {{lastName}}</strong> was scheduled for {{date}}.",
      "secondParagraph": "Confirm the sale or update the pick-up date by clicking here.",
      "sectionTitle_one": "{{count}} late sale",
      "sectionTitle": "{{count}} late sales",
      "title": "Was the sale completed?"
    },
    "expiredItems": {
      "sectionTitle_one": "{{count}} late item",
      "sectionTitle": "{{count}} late items"
    },
    "favourites": "Favourites",
    "fieldErrorDefault": "This field is not valid",
    "fieldErrorLength": "This field must contain exactly {{length}} characters",
    "fieldErrorPatternEmail": "This field must be a valid email address",
    "fieldErrorRequired": "This field is required",
    "fieldErrorTooLong": "This field must contain at most of {{max}} characters",
    "fieldErrorTooShort": "This field must contain at least {{min}} characters",
    "genericError": "An error occurred",
    "lastActiveAgo": "Active {{ago}} ago",
    "lastActiveAgoShort": "{{ago}} ago",
    "lateSince": "Overdue by {{days}} days",
    "loaned": "Borrowed",
    "manageOffer": "Manage listing",
    "mandatory": "mandatory",
    "noResults": "No results",
    "noResultsFor": "No results for:\n<strong>{{query}}</strong>",
    "afterResultsFor": "Can’t find what you’re looking for?",
    "offer": "Offer",
    "optional": "optional",
    "optionals": "optional",
    "optionale": "optional",
    "optionales": "optional",
    "or": "or",
    "otherCountries": "All countries",
    "passwordErrorDigit": "This field must contain at least one digit",
    "passwordErrorLowercase": "This field must contain at least one lowercase letter",
    "passwordErrorMatching": "This field must be identical to your password",
    "passwordErrorSpecial": "This field must contain at least one special character",
    "passwordErrorUppercase": "This field must contain at least one uppercase letter",
    "postalCodeRequiredError": "Please enter a postal code",
    "postedOn": "Posted on {{date}}",
    "request": "Need",
    "search": "Search",
    "searchPlaceholder": "Search listings, users and items...",
    "serviceCategories": {
      "general_help_outside_bf": {
        "name": "Outside at-home help",
        "desc": "Example: refill windshield washer liquid in the car, inflate tires, take out trash/recycling…"
      },
      "urgency_help_bf": {
        "name": "Urgent help",
        "desc": "Example: helping to find a veterinarian for an injured animal, helping to find an on-call pharmacy…"
      },
      "companionship_bf": {
        "name": "Companionship and leisure",
        "desc": "Example: Practicing a language, walk partner…"
      },
      "know_how_bf": {
        "name": "Knowledge transfer",
        "desc": "Example: gardening advice, repairs…"
      },
      "landscaping_bf": {
        "name": "Landscaping",
        "desc": "Example: raking, preparing the land, the pool, taking out furniture…"
      },
      "public_tessier": {
        "name": "Service Need",
        "desc": ""
      }
    },
    "streetRequiredError": "Please enter an address",
    "suggested": "suggested",
    "suggestede": "suggested",
    "superPartageur": "Super Sharer",
    "unavailable": "Unavailable",
    "updateAvailable": "Hey there! We got an update for you 🥳🎉.",
    "version": {
      "copied": "Version copied",
      "update_label": "Update",
      "version_label": "Version"
    },
    "year": "Year",
    "x$": "${{amount}}"
  },
  "contact-information": {
    "title": "Your Postal Code",
    "prompt": "Input your postal code to discover everything you can borrow near you!",
    "mapMarkerPrompt": "Set the location of your home by positioning the marker on the map.",
    "mapStatsPrompt": "Change the search radius to visualize the number of members and items available to borrow around you.",
    "invalidAddressError": "Invalid postal code. Please try again.",
    "changePostalCode": "Change my postal code"
  },
  "help": {
    "title": "How does it work?",
    "roleBorrow": "I borrow",
    "roleLend": "I lend",
    "assistanceQuestion": "Need more help?",
    "visitHelpCenter": "Visit the help center",
    "guestCta": {
      "title": "Ready to start sharing?",
      "text": "Join your neighbourhood and discover what you can borrow nearby.",
      "button": "Create my account"
    },
    "compensation": {
      "title": "Item compensation",
      "text": "You are covered on items you lend and borrow",
      "subscribeText": "With a subscription, Partage Club compensates you up to $300 on items you lend and borrow.",
      "subscribeCta": "Subscribe",
      "learnMore": "Learn more"
    },
    "borrower": {
      "steps": {
        "catalog": {
          "title": "Browse the catalog",
          "text": "Search for an item in the catalog or post a need visible to your neighbours",
          "exploreLink": "Explore the catalog",
          "needLink": "Post a need"
        },
        "meeting": {
          "title": "Agree on a meeting",
          "text": "Propose and confirm borrowing and pickup dates with your neighbour"
        },
        "pickup": {
          "title": "Pick up the item and use it",
          "text": "Meet your neighbour at their home or in a safe public place. <strong>No money changes hands — it's free!</strong>"
        },
        "return": {
          "title": "Return the item",
          "text": "Bring the item back in good condition to its owner and share your experience"
        }
      }
    },
    "lender": {
      "steps": {
        "photo": {
          "title": "Take a photo of an item",
          "text": "Take a few shots that show off your item"
        },
        "publish": {
          "title": "Post an offer",
          "text": "Add usage details about your item and publish your offer. Short on time? Choose ready-made listings we prepared for commonly requested items.",
          "offerLink": "Post a specific offer",
          "suggestedLink": "Choose from suggested items"
        },
        "share": {
          "title": "Share the item",
          "text": "Meet your neighbour at your home or in a safe public place to hand over the item. <strong>No money changes hands — it's free!</strong>"
        },
        "return": {
          "title": "Get the item back",
          "text": "Pick up the item when the loan ends and share your experience. <strong>Less than 1%</strong> of borrowed items are damaged. And often, they come back even cleaner. It's magic."
        }
      }
    }
  },
  "contact-us": {
    "title": "Help",
    "firstParagraph": "Partage Club member service is available by email and in-app messaging. We will respond to you as quickly as possible.",
    "chatCTALabel": "In-app Messaging",
    "transportCTALabel": "Transportation assistance",
    "emailCTALabel": "Email",
    "faqCTALabel": "Frequently Asked Questions (FAQ)",
    "bugReportCTALabel": "Report an issue",
    "suggestionCTALabel": "Feature suggestion",
    "faqLink": "https://www.partage.club/en-ca/about/frequently-asked-questions",
    "chatPrompt": {
      "bugReport": "Hi {{name}}! 😊\n\nThanks for explaining what's wrong.",
      "suggestion": "Hi {{name}}! 😊\n\nWe're always open to suggestions. Thank you for helping us improve our service.\n\nThanks!"
    }
  },
  "choose-sharer-type": {
    "title": "Motivations",
    "subtitle": "With {{appName}},\n what do you anticipate doing the most?",
    "borrower": "Borrowing",
    "lender": "Lending",
    "both": "Both",
    "borrowerEmoji": "🙋",
    "lenderEmoji": "🤝",
    "bothEmoji": "🔁"
  },
  "credentials": {
    "emailFieldLabel": "Email address",
    "emailFieldPlaceholder": "Email address",
    "errors": {
      "resource-already-exists": "The email you've entered is already linked to an account"
    },
    "activationCodeFieldLabel": "Invitation code",
    "activationCodeFieldPlaceholder": "Enter the code required to create an account",
    "inviteCodeFieldLabel": "Invitation code (optional)",
    "inviteCodeFieldPlaceholder": "ex. XYZ1234",
    "passwordConfirmationFieldLabel": "Confirm your password",
    "passwordConfirmationFieldPlaceholder": "Password",
    "passwordFieldLabel": "Password",
    "passwordFieldPlaceholder": "Password",
    "title": "Account information",
    "loadingPleaseWait": "Loading, please wait...",
    "validate": "Validate"
  },
  "email-verification": {
    "codeFieldLabel": "Confirmation code",
    "codeFieldPlaceholder": "eg: 123456",
    "errors": {
      "invalid-code": "The code you've entered is invalid, try again"
    },
    "subtitle": "We've sent you an email with a 6-digit verification code, enter it below.",
    "title": "Email verification"
  },
  "favourites": {
    "empty": {
      "filtered": "No favourites match this filter.",
      "firstLine": "Add your first favourite!",
      "primaryButtonText": "Explore listings",
      "secondLine": "Your favourites will appear here"
    },
    "filters": {
      "all": "All"
    },
    "title": "My favourites"
  },
  "forgot-password": {
    "emailFieldLabel": "Email",
    "emailFieldPlaceholder": "Email",
    "forgotPassword": {
      "close": "Close forgot password",
      "goBack": "Go back"
    },
    "primaryButtonText": "Reset my password",
    "subtitle": "Enter your email address below and we'll send you instructions to create a new password.",
    "title": "Recover your password"
  },
  "free-sub": {
    "billboardButtonText": "Go to the board",
    "headerText": "You published your first offer.",
    "headerTextFiveOffers": "You have published 5 offers!",
    "headerTextNotYet": "You are helping grow the <strong>Partage Club</strong> catalog!",
    "headerTextTutorial": "You now master the art of sharing items.",
    "headerTitle": "Bravo!",
    "headerTitleNotYet": "Thank you!",
    "inviteButtonText": "Invite my neighbours",
    "myImpactLevelButtonText": "See my impact",
    "createOfferButtonText": "Publish another offer",
    "spreadTheLoveText": "Tell your neighbours about it so they can also enjoy the special offer!",
    "subHeaderTextTutorial": "Thank you for publishing some items. We are delighted to announce that your free annual subscription is now activated!",
    "subscriptionActivatedText": {
      "CAD": "<strong>Yearly subscription activated</strong> ($60 value)",
      "EUR": "<strong>Yearly subscription activated</strong> (€72 value)",
      "USD": "<strong>Yearly subscription activated</strong> (72 USD value)"
    },
    "subscriptionNotYetActivatedText": "<strong>Continue publishing offers to win your subscription!</strong>",
    "userNowContributorText": "You've reached a higher level: <strong>Contributor</strong>. By publishing your first offer, you have increased your impact."
  },
  "group-members": {
    "headerTitle": "Members",
    "Members": "Members",
    "filter": {
      "apply": "Apply",
      "neighborhoodClub": "Neighbourhood Club",
      "title": "Filter"
    }
  },
  "grouped-listing": {
    "concierge": {
      "title": "One request. We’ll do the asking.",
      "description": "Post a request to your community. We’ll contact nearby lenders for you.",
      "action": "Send a request",
      "publishing": "Publishing your request…",
      "successTitle": "Your request is live!",
      "successDescription": "We’ll contact potential lenders. Follow their replies in your request.",
      "viewRequest": "View my request",
      "retry": "Try again",
      "message": "Hi! I’m looking to borrow {{item}}. Could you lend yours? We can agree on dates together. Thank you!",
      "queued_one": "Sending in {{count}} second…",
      "queued_other": "Sending in {{count}} seconds…",
      "undo": "Undo",
      "undone": "Nothing was posted. No lenders were contacted.",
      "pausedTitle": "Outreach paused",
      "pausedDescription": "Your request is still visible to your community. Resume whenever you’re ready.",
      "activeDescription": "Your request is visible to your community. We’ll ask nearby lenders for you.",
      "waitingDescription": "Your request is visible to your community. Follow replies in your request.",
      "found": "A lender is ready to help",
      "foundDescription": "Open your request to follow up with the lender.",
      "contacted_zero": "No lenders contacted yet.",
      "contacted_one": "{{count}} lender contacted.",
      "contacted_other": "{{count}} lenders contacted."
    },
    "headerSection": {
      "numOffers": "Number of offers: {{numOffers}}",
      "lenders_one": "{{number}} nearby lender",
      "lenders_other": "{{number}} nearby lenders",
      "available": "Available nearby"
    },
    "listHeader": "Contact a lender directly",
    "listHeaderLegacy": "Choose a member offering this item"
  },
  "guidelines": {
    "firstParagraph": "<strong>Always be respectful</strong> to members, whether virtually or in person.",
    "secondParagraph": "<strong>Take care to return borrowed items</strong> in the same condition as they were entrusted to you. If anything happens to your items (breakage or damage), we recommend that the borrower repair or replace the borrowed item.",
    "secondParagraphInsured": "<strong>Take care to return borrowed items</strong> in the same condition they were entrusted to you. With your subscription, if an item you lend or borrow (valued at $25 or more) gets damaged, <strong>we're committed to compensating you up to $300 per year</strong>. Contact us via in-app messaging or by email at info@partage.club",
    "secondParagraphPublic": "<strong>Respect meeting dates & times</strong> as agreed with members.",
    "thirdParagraph": "<strong>Respect loan return dates.</strong>",
    "thirdParagraphPublic": "<strong>Respect pick-up instructions</strong> from members.",
    "fourthParagraph": "<strong>Be generous</strong> by proactively responding to members who post requests for items you can lend.",
    "fifthParagraph": "Do not use Partage Club to sell or rent items.",
    "conditionsCheckboxText": "I accept the <Link1>terms of service</Link1> and the <Link2>privacy policy</Link2>.",
    "guidelinesCheckboxText": "I agree to respect the golden rules.",
    "primaryButtonText": "Save",
    "startingKit": "I want to receive the <startingKitLink>Starting Kit</startingKitLink> by mail to recruit my neighbours (optional)",
    "title": "Community guidelines"
  },
  "image-picker": {
    "add": "Add",
    "camera": "Camera",
    "cancel": "Cancel",
    "fileTooLarge": {
      "title": "File too large",
      "text": "Please choose a file smaller than {{max}} MB."
    },
    "library": "Photo gallery",
    "manage": "Manage photos",
    "save": "Save"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Joined the Partage Club",
        "title": "Explorer"
      },
      "1": {
        "button": "Publish",
        "description": "Post an offer",
        "description-completed": "Posted an offer",
        "title": "Contributor"
      },
      "2": {
        "button": "Explore",
        "description": "Complete a share (loan or borrowing)",
        "description-completed": "Completed a share",
        "title": "Sharer"
      },
      "3": {
        "button": "Explore",
        "description": "Complete 5 shares (loan or borrowing)",
        "description-completed": "Completed 5 shares",
        "title": "Super Sharer"
      }
    }
  },
  "header": {
    "publishButton": "Publish",
    "helpButtonAccessibilityLabel": "Help with the sharing process"
  },
  "introModal": {
    "pageTitle": {
      "intro": "Good to know!",
      "b2c_paid": "Subscription Activated",
      "b2b_activated": "Subscription Activated",
      "newly_insured": "The Partage Club Responsibility",
      "offre_defricheur": "Trailblazer Offer",
      "custom": "Information"
    },
    "title": "Hello\n{{name}}!",
    "titleNewFeature": "Partage Club takes responsibility!",
    "codeFullWarning": "All the subscriptions offered by {{groupName}} have been distributed, but you can still enjoy a free offer. →",
    "welcome": {
      "b2b": "<strong>Welcome to the Club!</strong>\nThanks to {{groupName}}, you now enjoy a free subscription. 🎉Enjoy unlimited sharing with {{withWho}}!",
      "withWho": {
        "education": "the members of your community",
        "enterprise": "your colleagues and neighbours",
        "municipal": "your neighbours",
        "municipal_closed": "your neighbours",
        "realestate": "your neighbours"
      },
      "trial": {
        "CAD": "<strong>Your first borrow is free!\n</strong><padding/>Lending your stuff?\nIt’s free forever.\n<padding/><smaller>After your free credit, subscribe to keep borrowing:\n<padding/><strong>• $60 /year</strong>\n<padding/><underline>No charge without your consent.</underline></smaller>",
        "EUR": "<strong>Your first borrow is free!\n</strong><padding/>Lending your stuff?\nIt’s free forever.\n<padding/><smaller>After your free credit, subscribe to keep borrowing:\n<padding/><strong>• €72 /year</strong>\n<padding/><underline>No charge without your consent.</underline></smaller>",
        "USD": "<strong>Your first borrow is free!\n</strong><padding/>Lending your stuff?\nIt’s free forever.\n<padding/><smaller>After your free credit, subscribe to keep borrowing:\n<padding/><strong>• 72 USD/year</strong>\n<padding/><underline>No charge without your consent.</underline></smaller>"
      },
      "regular": "<strong>Welcome to the Club!</strong>\nAs an official member of Partage Club, your subscription unlocks new benefits."
    },
    "insurable": {
      "insurance": {
        "trial": "With your subscription, if an item you lend or borrow (valued at $25 or more) gets damaged, <strong>we're committed to compensating you up to $300 per year</strong>.",
        "regular": "Thanks to your subscription, if damage occurs to your items valued at $25 or more during a loan, <strong>we're committed to compensating you up to $300 per year</strong>."
      },
      "zeroOnePercent": "Rest assured, <strong>fewer than 0.1% of shares result in damage</strong>. It’s only natural for items to show a bit of wear when they’re shared and enjoyed by many!"
    },
    "notInsurable": {
      "savings": "<strong>Borrowing is much more cost-effective than buying!</strong> Take a look at the app before making a purchase — you might be surprised.",
      "community": "<strong>It’s the perfect opportunity to connect with your neighbours</strong> and take a step toward a more sustainable world."
    },
    "cleaner": "And imagine — <strong>items often come back even cleaner than before</strong>. It’s like magic!",
    "referralPromo": "<strong>Refer someone and get one month free!</strong>\nEach new referral extends your subscription by one month.\n\nExample: 12 referrals = 12 free months.",
    "offreDefricheur": "There are few items in your neighbourhood. <strong>Free annual subscription for the first (5) users</strong> who post an offer.",
    "borrow": "<strong>You can now borrow</strong> from a wide catalog of items available just steps away from you.",
    "custom": {
      "support": "<strong>Is something damaged? Do you have an issue? Our team is available to assist you anytime.</strong>",
      "supportButtons": {
        "inAppMessaging": "In-app chat",
        "email": "Email"
      }
    },
    "continueButton": "Next",
    "backButton": "Previous",
    "doneButton": "Understood"
  },
  "insured": {
    "landing-page": {
      "title": "Partage Club Responsibility",
      "text": "You are protected in case of damages"
    },
    "listing": {
      "title": "Share with peace of mind.",
      "text": {
        "own": "With your subscription, you’re covered by the Partage Club Responsibility in case your items are damaged.",
        "other": "With their subscription, {{name}} is covered by the Partage Club Responsibility in case their items are damaged."
      }
    },
    "link": {
      "more_details": "Learn more"
    },
    "myPlan": {
      "title": "Covered by Partage Club",
      "text": "By subscribing, you benefit from Partage Club Responsibility if an item you lend or borrow gets damaged."
    },
    "profile": {
      "title": "{{name}} is covered by the <strong>Partage Club Responsibility</strong> in case their items are <strong>damaged</strong>."
    },
    "help": {
      "button": "Report damage"
    },
    "details": {
      "title": "Partage Club Responsibility",
      "text": {
        "own": "With your subscription, if an item you lend or borrow (valued at $25 or more) gets damaged, we're committed to compensating you up to <strong>$300 per year</strong>.",
        "other": "With their subscription, if an item {{name}} lends you or borrows from you (valued at $25 or more) gets damaged, we're here to compensate them up to <strong>$300 per year</strong>."
      },
      "how": {
        "intro": "How it works:",
        "step1": "The lender or borrower contacts us via in-app messaging or by email.",
        "step2": "We assess the situation quickly.",
        "step3": "If the claim is eligible, the lender is compensated."
      },
      "link": "Read the Responsibility Policy"
    }
  },
  "invite": {
    "headerAction": "Invite",
    "headerTitle": "Invite friends",
    "codeCopied": "The invitation code has been copied.",
    "details": "You have invited {{numInvited}} people.\nThe more you invite, the more you contribute to expanding this chain of generosity!",
    "details2": "",
    "referralProgram": {
      "title": "Love Partage Club?\n<color>For each referral</color> we give you <color>1 free month!</color>",
      "details": "Each time a friend subscribes using your referral link, you get 1 free month at Partage Club.",
      "details2": "",
      "referrals": {
        "title_zero": "Ready to get started? 🚀",
        "title": "Your referrals !🎉",
        "subTitle_zero": "Make your first referral to get your first free month!",
        "subTitle_one": "<strong>{{count}} person</strong> joined Partage Club thanks to <strong>you</strong> 🥳",
        "subTitle": "<strong>{{count}} people</strong> joined Partage Club thanks to <strong>you</strong> 🥳",
        "rewardMessage_one": "Thanks to your referral, you’ve earned <strong>1 month of free subscription</strong> 😊",
        "rewardMessage": "Thanks to your referrals, you’ve earned <strong>{{count}} months of free subscription</strong> 😊",
        "1referral": "One referral",
        "1monthFree": "One free month",
        "1monthFreeWithEmoji": "1 free month 🎉"
      },
      "subscription": "See my subscription",
      "howItWorks": {
        "title": "How does it work?",
        "subtitle": "1 referred member = 1 person who downloads the app and creates an account",
        "step1": "Send your invite code",
        "step2": "Your friends sign up using your code",
        "step3": "Get your reward!"
      },
      "gift": {
        "prefix": "For each person you refer, you automatically get one free month at Partage Club.",
        "prefix2": "<strong>1 free month</strong>"
      },
      "shareYourCode": "Share your code",
      "shareText": "Hey!\n\nI’ve been using Partage Club, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "referralProgram202506": {
      "title": "Love Partage Club?\n<color>Invite 5 friends</color> and get <color>a gift worth $25!</color>",
      "details": "Every time 5 of your friends sign up using your referral link, you get a $25 reward.",
      "details2": "",
      "currentStep": {
        "progress": "{{numInvites}} of 5",
        "0": "Ready to get started? 🚀",
        "1": "Let’s go! 🎯",
        "2": "Great start! ✌️",
        "3": "You’re almost there! 🔥",
        "4": "Just one more! ⏳",
        "5": "🎉 Congrats and thank you.\nYou’ve earned your reward!"
      },
      "howItWorks": {
        "title": "How does it work?",
        "subtitle": "1 referred member = 1 person who downloads the app and creates an account",
        "step1": "Send your invite code",
        "step2": "Your friends sign up using your code",
        "step3": "Get your reward!"
      },
      "gift": {
        "prefix": "Once you reach <strong>5 referred members</strong>, you’ll receive a <strong>$25</strong> reward of your choice:",
        "gift1": "Grocery gift card of your choice",
        "gift2": "Public transit gift card",
        "gift3": "A $25 donation to a non-profit, made in your name"
      },
      "shareText": "Hey!\n\nI’ve been using Partage Club, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "primaryButtonText": "Send invite",
    "secondaryButtonText": "Copy code",
    "shareText": "Hey!\n\nI’ve been using Partage Club, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}",
    "subtitle": "Share your code",
    "title": "Invite your neighbours or relatives!",
    "referrals": {
      "title_zero": "Ready to get started? 🚀",
      "title": "Your referrals !🎉",
      "subTitle_zero": "Make your first referral!",
      "subTitle_one": "<strong>{{count}} person</strong> joined Partage Club thanks to <strong>you</strong> 🥳",
      "subTitle": "<strong>{{count}} people</strong> joined Partage Club thanks to <strong>you</strong> 🥳"
    }
  },
  "landing": {
    "signin": "Sign in",
    "signup": "Sign up",
    "welcome": "Welcome!"
  },
  "language": {
    "options": {
      "en": "English",
      "fr": "French",
      "es": "Spanish"
    },
    "title": "Communication language"
  },
  "listings-filters": {
    "title": {
      "request": "Filter needs by",
      "offer": "Filter offers by"
    },
    "titleClubs": "Clubs",
    "titleType": "Type",
    "transactionMode": {
      "lend": "Loans",
      "give": "Donations",
      "sell": "Sales"
    },
    "titleFoundRequests": "Requests",
    "foundRequestsLabel": "Show found requests?",
    "dismissedRequestsLabel": "Show dismissed requests?",
    "hideFoundRequestsTag": "Requests not found",
    "showDismissedOnlyTag": "Dismissed requests",
    "titleOffersWithFee": "Offers",
    "offersWithFeeLabel": "Show with sharing fee?",
    "hideOffersWithFeeTag": "Offers with no fee",
    "showOffersWithFeeTag": "Offers with fee",
    "titleCategories": "Categories",
    "close": "Close",
    "titleTags": "Tags",
    "tagsPlaceholder": "Filter by tag",
    "titleSubtypes": "Types",
    "subtype": {
      "object": "Items",
      "service": "Services",
      "donation": "Donations"
    },
    "searchDistance": "Distance",
    "distanceTag": "{{distance}} {{unit}}"
  },
  "loanDatesPicker": {
    "endFieldPlaceholder": "End date",
    "informationTextAsBorrower": "Suggest dates to the lender to make the reservation and track the item until it is returned.",
    "informationTextAsLender": "Suggest dates to the borrower to make the reservation and track your item until it is returned.",
    "informationTextAsService": "Suggest a date to the member for this service in order to confirm the booking.",
    "informationTextAsDonation": "Suggest a pick up date to the member for this donation.",
    "informationTextAsSell": "Suggest a pickup date to the seller to make the reservation.",
    "informationTextForExistingLoanAsBorrower": "Suggest new dates to the lender. Until they approve your suggestion, the previously accepted dates will still apply.",
    "informationTextForExistingLoanAsLender": "Suggest new dates to the borrower. Until they approve your suggestion, the previously accepted dates will still apply.",
    "informationTextForExistingLoanAsService": "Suggest new dates to the member who requested the service. The previously accepted date will remain valid until this new date is confirmed.",
    "informationTextForExistingLoanAsDonation": "Propose a new pick up date to the member for this donation. The previously accepted date will remain valid until this new date is confirmed.",
    "informationTextForExistingLoanAsSell": "Suggest a new pickup date to the seller. The previously accepted date will remain valid until this new date is confirmed.",
    "offerDates": "Offer dates",
    "offerDateRange": "{{start}} - {{end}}",
    "plannedSalePeriodReminder": "Reminder: the period defined when the offer was created is from {{start}} to {{end}}.",
    "flexibleDates": "Are the dates flexible?",
    "primaryButtonTextAsBorrower": "Send request",
    "primaryButtonTextBeforeReminder": "Continue",
    "primaryButtonTextAsLender": "Suggest these dates",
    "primaryButtonTextAsLenderSingleDate": "Suggest this date",
    "promptIntroduceYourself": "Don't forget to send a quick message to the member to introduce yourself, and express your interest.",
    "startFieldPlaceholder": "Start date",
    "title": "Dates suggestion"
  },
  "loanFee": {
    "document": {
      "label": "Sharing-fee document",
      "help": "PDF, PNG or JPEG — up to 10 MB. Visible to members who view this offer.",
      "choose": "Choose a document",
      "replace": "Replace document",
      "remove": "Remove document",
      "view": "View",
      "preview": "Preview: {{name}}",
      "open": "Open document",
      "uploading": "Uploading document…",
      "invalid": "Choose a PDF, PNG or JPEG file up to 10 MB.",
      "uploadError": "Upload failed. Please try again.",
      "previewError": "Unable to open the document. Please try again."
    },
    "selectionTitle": "Edit sharing fees for selection ({{count}})",
    "title": "Edit Sharing Fee",
    "saveButton": "Save sharing fee",
    "fields": {
      "loanFeePrompt": "Fees required for this loan?",
      "loanFeeDescriptionLabel": "Reason for sharing fee",
      "loanFeeDescriptionPlaceholder": "Explain in a few words what this fee covers. ex. 1 person for assembly/disassembly, transportation of equipment and installation, etc.",
      "loanFeeLabel": "Sharing fee",
      "loanFeePlaceholder": "0",
      "loanFeePaymentMethodLabel": "Payment method"
    },
    "listingCard": {
      "loanFee": "Sharing fee"
    },
    "modals": {
      "loanFee": {
        "title": "Sharing fee",
        "text": "<strong>What is a sharing fee?</strong>\n\nA sharing fee is applied at the lender's discretion in various cases. For example, to cover:\n  • Handling or transportation costs.\n  • Time spent preparing, setting up, or taking down.\n  • etc.",
        "detailsForLender": "This fee is optional. It is recommended to clearly state the reason for the fee to ensure transparency with the borrower."
      },
      "amount": {
        "title": "Sharing fee",
        "text": "<strong>How much to charge?</strong>\n\nHere are some guidelines for estimating a shared fee:\n\n  • Small loan (tools, accessories, etc.):\n<strong>5% of the market value</strong>\n\n  • Loans requiring assembly/disassembly:\n<strong>5 to 10% depending on the effort required</strong>\n\n  • Loans with transportation or travel\n<strong>Add a fixed amount (e.g., $10)</strong>\n\n  • Loans involving time or coordination:\n<strong>Estimate based on the time invested (e.g., $10/hour)</strong>\n\nThese amounts are for guidance only; adjust them according to your judgment and the specifics of each loan."
      },
      "paymentMethod": {
        "title": "Payment method",
        "text": "<strong>Payment of the Sharing Fee</strong>\n\n  • If the payment method is not indicated, it is strongly recommended to contact the lender before the sharing.\n  • Payment of the sharing fee can be made before or after the sharing, at the convenience of the lender and the borrower.\n  • Payment is made outside of the app."
      },
      "other": {
        "title": "Sharing fee"
      }
    },
    "paymentMethods": {
      "cash": "Cash",
      "interac": "Interac e-Transfer",
      "eft": "Bank transfer",
      "other": "Other"
    }
  },
  "loanParticipants": {
    "title": "Participants"
  },
  "loans": {
    "services": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your borrowings or services to receive will be displayed here."
        },
        "pastTitle": "Service received",
        "subtitle": "Borrowings and services to receive",
        "title": "I receive"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your loans or services to provide will be displayed here."
        },
        "pastTitle": "Service provided",
        "subtitle": "Loans and services to provide",
        "title": "I offer"
      },
      "past": {
        "tabs": {
          "borrowing": "Received",
          "lending": "Offered"
        }
      }
    },
    "donations": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your loans or donations to receive will be displayed here."
        },
        "pastTitle": "Donation received",
        "subtitle": "Loans and donations to receive",
        "title": "I receive"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your loans or donations to give away will be displayed here."
        },
        "pastTitle": "Donation offered",
        "subtitle": "Loans and donations to give away",
        "title": "I offer"
      },
      "past": {
        "tabs": {
          "borrowing": "Received",
          "lending": "Offered"
        }
      }
    },
    "sales": {
      "borrowing": {
        "pastTitle": "Purchase"
      },
      "lending": {
        "pastTitle": "Sale"
      }
    },
    "services+donations": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your loans, services to receive and donations to receive will be displayed here."
        },
        "subtitle": "Ongoing loans, services to receive and donations to receive",
        "title": "I receive"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your loans, services to provide and donations to give away will be displayed here."
        },
        "subtitle": "Ongoing loans, services to provide and donations to give away",
        "title": "I offer"
      },
      "past": {
        "tabs": {
          "borrowing": "Received",
          "lending": "Offered"
        }
      }
    },
    "services+donations-ro": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your donations to receive will be displayed here."
        },
        "subtitle": "Donations to receive",
        "title": "I receive"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Your services to provide will be displayed here."
        },
        "subtitle": "Services to provide",
        "title": "I offer"
      },
      "past": {
        "tabs": {
          "borrowing": "Received",
          "lending": "Offered"
        }
      }
    },
    "borrowing": {
      "empty": {
        "firstLine": "No items are currently borrowed",
        "secondLine": "All your borrowings will be shown here."
      },
      "pastTitle": "Borrowing",
      "subtitle": "Things I borrow",
      "title": "My Borrowings"
    },
    "calendar": {
      "activitySummary_one": "{{count}} activity in {{month}}",
      "activitySummary_other": "{{count}} activities in {{month}}",
      "activityTitle": "Monthly activity",
      "close": "Close date details",
      "dateAccessibility_one": "{{date}}, {{count}} activity",
      "dateAccessibility_other": "{{date}}, {{count}} activities",
      "emptyPeriod": {
        "closestActivity": "Go to {{month}}",
        "description": "Choose another month or jump to the closest activity.",
        "title": "No activity this month"
      },
      "emptyRange": {
        "description": "Swipe the calendar or use the arrows to view another period.",
        "title": "No activity in this period"
      },
      "legend": {
        "late": "Needs attention",
        "ongoing": "In progress",
        "returned": "Awaiting confirmation",
        "scheduled": "Upcoming"
      },
      "loading": "Loading loans",
      "nextMonth": "Next month",
      "nextPeriod": "Next period",
      "noActivityOnDate": "There is no activity on this date.",
      "planner": {
        "attentionSummary_one": "{{count}} item needs attention",
        "attentionSummary_other": "{{count}} items need attention",
        "compact": {
          "attention": "Alert",
          "completed": "Completed",
          "loanCount_one": "{{count}} loan",
          "loanCount_other": "{{count}} loans",
          "ongoing": "Ongoing",
          "periodSummary_one": "{{count}} activity",
          "periodSummary_other": "{{count}} activities"
        },
        "due": "due",
        "groups": {
          "attention": "Needs attention",
          "completed": "Completed",
          "ongoing": "In progress",
          "upcoming": "Upcoming"
        },
        "loanColumn": "Loans",
        "returned": "returned",
        "starts": "starts",
        "views": {
          "month": "Month",
          "planner": "Sharing"
        }
      },
      "previousMonth": "Previous month",
      "previousPeriod": "Previous period",
      "sheetSummary_one": "{{count}} activity on this date",
      "sheetSummary_other": "{{count}} activities on this date",
      "tabs": {
        "borrowing": "List",
        "calendar": "Calendar",
        "lending": "List"
      },
      "today": "Today"
    },
    "card": {
      "status": {
        "cancelled": "Cancelled",
        "late": "Late",
        "ongoing": "Ongoing",
        "past": "Completed",
        "pending": "Pending",
        "returned": "Returned",
        "returnedSale": "Sold",
        "returnedService": "Delivered",
        "returnedDonation": "Picked up",
        "scheduled": "Scheduled"
      },
      "type": {
        "offer": {
          "mine": "Your offer",
          "notMine": "Member's offer"
        },
        "request": {
          "mine": "Your need",
          "notMine": "Member's need"
        }
      },
      "when": {
        "late": {
          "x_days": "{{numDays}} days overdue",
          "yesterday": "Overdue since yesterday"
        },
        "ongoing": {
          "today": "Return expected today",
          "tomorrow": "Return expected tomorrow",
          "x_days": "Return expected in {{numDays}} days"
        },
        "past": {
          "today": "Returned today",
          "x_days": "Returned on {{date}}",
          "yesterday": "Returned yesterday"
        },
        "pending": {
          "today": "Awaiting confirmation",
          "tomorrow": "Awaiting confirmation",
          "x_days": "Awaiting confirmation"
        },
        "returned": {
          "today": "Returned today",
          "x_days": "Returned on {{date}}",
          "yesterday": "Returned yesterday"
        },
        "scheduled": {
          "today": "Scheduled today",
          "tomorrow": "Scheduled for tomorrow",
          "x_days": "Scheduled in {{numDays}} days"
        }
      },
      "whenService": {
        "late": {
          "x_days": "{{numDays}} days overdue",
          "yesterday": "Overdue since yesterday"
        },
        "ongoing": {
          "today": "Expected today",
          "tomorrow": "Expected tomorrow",
          "x_days": "Expected in {{numDays}} days"
        },
        "past": {
          "today": "Completed today",
          "x_days": "Completed on {{date}}",
          "yesterday": "Completed yesterday"
        },
        "pending": {
          "today": "Awaiting confirmation",
          "tomorrow": "Awaiting confirmation",
          "x_days": "Awaiting confirmation"
        },
        "returned": {
          "today": "Completed today",
          "x_days": "Completed on {{date}}",
          "yesterday": "Completed yesterday"
        },
        "scheduled": {
          "today": "Scheduled today",
          "tomorrow": "Scheduled for tomorrow",
          "x_days": "Scheduled in {{numDays}} days"
        }
      },
      "whenDonation": {
        "late": {
          "x_days": "{{numDays}} days overdue",
          "yesterday": "Overdue since yesterday"
        },
        "ongoing": {
          "today": "Expected today",
          "tomorrow": "Expected tomorrow",
          "x_days": "Expected in {{numDays}} days"
        },
        "past": {
          "today": "Picked up today",
          "x_days": "Picked up on {{date}}",
          "yesterday": "Picked up yesterday"
        },
        "pending": {
          "today": "Awaiting confirmation",
          "tomorrow": "Awaiting confirmation",
          "x_days": "Awaiting confirmation"
        },
        "returned": {
          "today": "Picked up today",
          "x_days": "Picked up on {{date}}",
          "yesterday": "Picked up yesterday"
        },
        "scheduled": {
          "today": "Scheduled today",
          "tomorrow": "Scheduled for tomorrow",
          "x_days": "Scheduled in {{numDays}} days"
        }
      },
      "whenSale": {
        "late": {
          "x_days": "Sale overdue by {{numDays}} days",
          "yesterday": "Sale overdue since yesterday"
        },
        "ongoing": {
          "today": "Sale scheduled today",
          "tomorrow": "Sale scheduled tomorrow",
          "x_days": "Sale scheduled in {{numDays}} days"
        },
        "past": {
          "today": "Sale completed today",
          "x_days": "Sale completed on {{date}}",
          "yesterday": "Sale completed yesterday"
        },
        "pending": {
          "today": "Pending confirmation",
          "tomorrow": "Pending confirmation",
          "x_days": "Pending confirmation"
        },
        "returned": {
          "today": "Receipt confirmed today",
          "x_days": "Receipt confirmed on {{date}}",
          "yesterday": "Receipt confirmed yesterday"
        },
        "scheduled": {
          "today": "Sale scheduled today",
          "tomorrow": "Sale scheduled tomorrow",
          "x_days": "Sale scheduled in {{numDays}} days"
        }
      }
    },
    "lending": {
      "empty": {
        "firstLine": "No items are currently loaned",
        "secondLine": "All your loans will be shown here."
      },
      "pastTitle": "Loan",
      "subtitle": "Things I loan",
      "title": "My Loans"
    },
    "past": {
      "empty": {
        "filtered": "No history matches this filter.",
        "firstLine": "Your sharing history is empty",
        "secondLine": "All your past loans and borrowings will be shown here."
      },
      "filters": {
        "all": "All"
      },
      "savings": {
        "header": {
          "borrowing": "Saved by borrowing instead of buying",
          "lending": "Saved by your neighbours thanks to you"
        }
      },
      "cards": {
        "date": "{{end}}",
        "dates": "{{start}} to {{end}}"
      },
      "rating": {
        "mine": "My rating:",
        "recommended": "Recommended",
        "notRecommended": "Not recommended"
      },
      "tabs": {
        "borrowing": "Borrowings",
        "lending": "Loans"
      },
      "title": "My History"
    }
  },
  "login": {
    "signUpOrLogin": "Sign up / Log in",
    "title": "Log in",
    "emailFieldLabel": "Email address",
    "emailFieldPlaceholder": "Email address",
    "passwordFieldLabel": "Password",
    "passwordFieldPlaceholder": "Password",
    "forgotPassword": "I forgot my password",
    "guestPrimaryButtonText": "Continue",
    "primaryButtonText": "Log in",
    "lastUsedMethod": "Last used",
    "noAccountYetPrefix": "Don't have an account ?",
    "noAccountYet": "Sign up",
    "downloadApp": "Download the app!",
    "errors": {
      "incorrect-credentials": "Your email address or password is invalid."
    }
  },
  "management": {
    "bonificationPrompt": {
      "text": "Some of your items are available, but without a photo or description."
    },
    "tabBarLabel": "Sharings",
    "title": "My sharings",
    "ongoing": "Ongoing sharings",
    "publications": "My publications",
    "moreOptions": "More options"
  },
  "my-address": {
    "administrativeAreaFieldLabel": "Province",
    "administrativeAreaFieldPlaceholder": "Choose your province",
    "cityFieldLabel": "City",
    "countryFieldLabel": "Country",
    "countryRegionLockedHelp": "Once an account is created, its address cannot move into or out of the United States.",
    "postalCodeFieldLabel": "Postal code",
    "primaryButtonText": "Save",
    "streetFieldLabel": "Street number and name",
    "title": "My address",
    "unitFieldLabel": "Unit (optional)"
  },
  "my-clubs": {
    "createClubButton": "Add a neighbourhood",
    "addProClubButton": "Join a club",
    "infoButtonLabel": "More information about my clubs",
    "help": {
      "neighbourhoods": {
        "title": "Neighbourhood Clubs",
        "paragraph1": "Add clubs for neighbourhoods that you frequent to access more offers and expand your reach to more members.",
        "paragraph2": "Your kid's school, your cottage, etc."
      },
      "pro": {
        "title": "Partner Clubs",
        "paragraph1": "A partner club is managed by an organization such as your city, employer, association, or university. Add such a club if you have received an invitation code."
      }
    },
    "neighbourhoodClubName": "Home",
    "neighbourhoodTitle": "Neighbourhood Clubs",
    "sharingPlaceTitle": "Sharing Places",
    "proTitle": "Partner Clubs",
    "title": "My clubs"
  },
  "activity-sectors": {
    "title": "My activity sectors",
    "fieldLabel": "Activity sector (required)*",
    "subtitle": "Select the sectors that best describe your activity. You can pick several.",
    "empty": "No sector available right now",
    "errorToast": "Something went wrong. Please try again.",
    "minOneToast": "You must keep at least one activity sector.",
    "addCta": "Add a sector",
    "overflowTitle": "My other sectors"
  },
  "my-impact-financial": {
    "ctaButtonText": {
      "borrowing": "Go to My Borrowings",
      "lending": "Go to My Loans"
    },
    "ctaButtonTextByTransaction": {
      "lend": {
        "borrowing": "View my borrowings",
        "lending": "View my loans"
      },
      "sell": {
        "borrowing": "View my purchases",
        "lending": "View my sales"
      },
      "give": {
        "borrowing": "View my received donations",
        "lending": "View my donations"
      }
    },
    "empty": {
      "borrowing": {
        "firstLine": "The amount you save by borrowing will be displayed here.",
        "primaryButtonText": "See offers from other members",
        "secondLine": "Start borrowing and see how much money you save!"
      },
      "lending": {
        "firstLine": "The amount other members save by borrowing your items will be displayed here.",
        "primaryButtonText": "See the needs of other members",
        "secondLine": "Share your items and see how much money you allow your neighbours to save!"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "borrowing": {
          "firstLine": "The amount you save by borrowing will be displayed here.",
          "primaryButtonText": "See offers from other members",
          "secondLine": "Start borrowing and see how much money you save!"
        },
        "lending": {
          "firstLine": "The amount other members save by borrowing your items will be displayed here.",
          "primaryButtonText": "See the needs of other members",
          "secondLine": "Share your items and see how much money you allow your neighbours to save!"
        }
      },
      "sell": {
        "borrowing": {
          "firstLine": "The value of your purchases will be displayed here.",
          "primaryButtonText": "See items for sale",
          "secondLine": "Start buying and track the value of your purchases!"
        },
        "lending": {
          "firstLine": "The value of your sales will be displayed here.",
          "primaryButtonText": "See the needs of other members",
          "secondLine": "Start selling and track the value of your sales!"
        }
      },
      "give": {
        "borrowing": {
          "firstLine": "The value of the items you receive will be displayed here.",
          "primaryButtonText": "See items to receive",
          "secondLine": "Receive items and track the value of your received donations!"
        },
        "lending": {
          "firstLine": "The value of the items you donate will be displayed here.",
          "primaryButtonText": "See the needs of other members",
          "secondLine": "Donate items and track the value of your donations!"
        }
      }
    },
    "howItWorks": {
      "title": "How is this calculated?",
      "body": "We use an artificial intelligence tool to determine the average price of each borrowed item",
      "bodyByTransaction": {
        "lend": "We use an artificial intelligence tool to determine the average price of each borrowed item",
        "sell": "We use an artificial intelligence tool to estimate the value of each item sold",
        "give": "We use an artificial intelligence tool to estimate the value of each donated item"
      }
    },
    "subtext": {
      "borrowing": "by borrowing items",
      "lending": "by lending my items"
    },
    "subtextByTransaction": {
      "lend": {
        "borrowing": "by borrowing items",
        "lending": "by lending my items"
      },
      "sell": {
        "borrowing": "by buying items",
        "lending": "by selling my items"
      },
      "give": {
        "borrowing": "by receiving items",
        "lending": "by donating my items"
      }
    },
    "roleTabs": {
      "lend": {
        "borrowing": "I saved",
        "lending": "I helped save"
      },
      "sell": {
        "borrowing": "I bought",
        "lending": "I sold"
      },
      "give": {
        "borrowing": "I received",
        "lending": "I donated"
      }
    },
    "tabs": {
      "borrowing": "I saved",
      "lending": "I helped save"
    },
    "transactionTabs": {
      "lend": "Sharing",
      "sell": "Sale",
      "give": "Donation"
    },
    "title": "My Financial Impact"
  },
  "my-information": {
    "credentialInformationText": "The information below will <strong>not be accessible</strong> to other members.",
    "credentialInformationTitle": "Account & security",
    "edit": "Edit",
    "editAvatarButtonLabel": "Change my photo",
    "emailFieldLabel": "Email",
    "firstNameFieldLabel": "First name",
    "groupMemberCountFieldLabel": "Number of members",
    "groupNameFieldLabel": "Business",
    "groupsTitle": "My sharing club",
    "lastNameFieldLabel": "Last name",
    "my-neighborhood-club": "My neighbourhood club",
    "passwordFieldLabel": "Password",
    "passwordFieldCTA": "Change my password",
    "personalInformationText": "The information below will be <strong>visible</strong> to other members.",
    "personalInformationTitle": "Personal information",
    "phoneFieldLabel": "Phone number",
    "phoneFieldError": "Phone number is not valid.",
    "search-radius": "Search radius*",
    "title": "My information",
    "visibilityRadiusSection": {
      "title": "My address"
    }
  },
  "my-listings": {
    "title": {
      "offer": "My offers",
      "request": "My needs"
    },
    "editButton": "Select",
    "selectAllButton": "Select all",
    "deselectAllButton": "Deselect all",
    "cancelButton": "Cancel",
    "modifyListingsButton": "Modify",
    "modifyListingsCountButton": "Modify ({{count}})",
    "modifyListingsTitle": "Modify",
    "blockDatesButton": "Block dates",
    "changeLoanFeeButton": "Edit sharing fee",
    "duplicateButton": "Duplicate",
    "changePriceButton": "Edit price",
    "duplicateModal": {
      "title": "Duplicate",
      "copies": "Copies",
      "confirm": "Confirm"
    },
    "priceModal": {
      "title": "Edit price for selection ({{count}})",
      "label": "Price",
      "placeholder": "50 $/kg",
      "save": "Save"
    },
    "hideButton": "Hide",
    "hideAlert": {
      "title": "Confirm hide items",
      "message": "The selected items will not be visible to others, but you'll be able to undo this here later.",
      "confirmButton": "Hide",
      "cancelButton": "Cancel"
    },
    "unhideButton": "Un-hide",
    "unhideAlert": {
      "title": "Confirm un-hide items",
      "message": "The selected items will be visible to others once more.",
      "confirmButton": "Un-hide",
      "cancelButton": "Cancel"
    },
    "deleteButton": "Delete",
    "deleteAlert": {
      "title": "Confirm deletion",
      "message": "Are you sure you want to delete those items? This action is irreversible.",
      "confirmButton": "Delete",
      "cancelButton": "Cancel"
    },
    "hideToast": {
      "title": "Items hidden",
      "text": "They are no longer visible to others."
    },
    "unhideToast": {
      "title": "Items un-hidden",
      "text": "They are visible to others again."
    },
    "deleteToast": {
      "title": "Items deleted",
      "text": "They were permanently deleted."
    },
    "duplicateToast": {
      "title": "Items duplicated",
      "text": "The copies were added to your offers."
    },
    "priceUpdatedToast": {
      "title": "Price updated",
      "text": "The price of the selection was changed."
    },
    "transactionModeTabs": {
      "all": "All",
      "lend": "Loans",
      "sell": "Sales",
      "give": "Donations"
    },
    "emptyState": {
      "all": "Your offers will appear here",
      "lend": "Your offers to lend will appear here",
      "sell": "Your offers for sale will appear here",
      "give": "Your offers to give away will appear here"
    }
  },
  "my-neighbourhood": {
    "addAddressHelp": "Having more than one neighborhood club (several addresses) allows you to access more offers.",
    "addressLabel": "Address",
    "audience": "Members in this zone",
    "clubName": "{{clubName}} Club",
    "clubNameLabel": "Club Name",
    "createClubButton": "Add this neighbourhood",
    "completeAddress": "Complete address",
    "deleteButton": "Delete",
    "deleteConfirmation": "Delete this neighbourhood club?",
    "edit": "Edit",
    "iconLabel": "Club Icon",
    "neighborhoodClub": "Neighbourhood Club",
    "noteBelowMap": "Adjust your sharing zone by moving it on the map.",
    "postalCodeLabel": "Postal Code",
    "radiusLabel": "Sharing Radius",
    "radiusDescription": "Your radius allows you to share your listings within a limited area of your neighbourhood. Neighbours living outside of this zone will not be able to see your listings.",
    "saveClubButton": "Save",
    "titleNew": "Add a neighbourhood club",
    "viewMembersList": "View members list"
  },
  "travel-distance": {
    "title": "Search distance",
    "noteBelowMap": "Adjust your search zone by moving it on the map.",
    "potentialAudience": "Potential audience",
    "neighbours": "Members",
    "neighboursRecentOnly": "Active members",
    "neighbourListings": "Available offers",
    "describeStatsRecentOnly": "In the last 3 months.",
    "noLimit": "Maximum ({{max}} {{unit}})",
    "noLimitWhiteLabel": "No limit - All members",
    "save": "Save",
    "reset": "Reset",
    "text": "The search distance applies only to offers in your Neighbourhood Club."
  },
  "my-personal-information": {
    "additionalNameFieldLabel": "Additional name",
    "bioFieldLabel": "About me",
    "bioFieldPlaceholder": "Tell us a little about yourself.",
    "firstNameFieldLabel": "First name",
    "firstNameFieldPlaceholder": "First name",
    "lastNameFieldLabel": "Last name",
    "lastNameFieldPlaceholder": "Last name",
    "primaryButtonText": "Save",
    "title": "My personal information"
  },
  "my-plan": {
    "addCodeButton": "Enter my invitation code",
    "design": {
      "activeSubscription": "You currently have a Partage+ subscription.",
      "available": "Available",
      "billingNote": {
        "monthly": "*You will be billed {{price}} / month on the renewal date. Cancel up to 24 hours before your next payment date.",
        "yearly": "*You will be billed {{price}} / year on the renewal date. Cancel up to 24 hours before your next payment date."
      },
      "cancelAnytime": "Cancel at any time",
      "cancelAnytimeShort": "Cancel at any time",
      "cancelDescription": "You can cancel your subscription up to 24 hours before your next payment date. Your subscription will renew automatically.",
      "codeCopied": "The invitation code was copied.",
      "current": "Current",
      "damageCoverage": "Coverage for shared items",
      "discovery": "Discovery",
      "free": "free",
      "freeBorrowDescription": "Borrow your first item from your neighbours for free",
      "frequency": {
        "monthly": "Monthly",
        "no": "Provided",
        "yearly": "Annual"
      },
      "goFurther": "Take it further",
      "invitationCode": "Your invitation code",
      "learnMore": "Learn more",
      "manageTitle": "Manage my subscription",
      "nextPayment": "Next payment",
      "oneBorrow": "1 borrowing",
      "offeredBy": "Provided by:",
      "planType": {
        "citizen": "Citizen",
        "employee": "Employee"
      },
      "referralBenefit": "One referral = 1 additional month",
      "referralTitle": "1 referral = 1 additional month",
      "shareReferral": "Join me on Partage Club: {{url}}",
      "renewalCancelled": "You cancelled the renewal of your Partage+ subscription.",
      "resubscribe": "Resubscribe",
      "subscribeNow": "Subscribe now",
      "subscriptionEnd": "Subscription end date",
      "unlimitedBorrowing": "Unlimited borrowing",
      "unlimitedLending": "Unlimited lending",
      "unlimitedLendingDescription": "Publish offers and lend your items to your neighbours as often as you like",
      "useActivationCode": "Use my activation code",
      "usedOn": "Used on {{date}}",
      "yourBenefits": "Your benefits"
    },
    "businessPlan": {
      "firstParagraph": {
        "education": "Your subscription is provided by {{planName}}.",
        "enterprise": "Your subscription is provided by {{planName}}.",
        "generic": "Your subscription is provided by {{planName}}.",
        "municipal": "Your subscription is provided by {{planName}}.",
        "municipal_closed": "Your subscription is provided by {{planName}}.",
        "realestate": "Your subscription is provided by {{planName}}."
      },
      "title": {
        "education": "Educational Subscription",
        "enterprise": "Employees Subscription",
        "generic": "Provided Subscription",
        "municipal": "Partage+ Subscription",
        "municipal_closed": "Partage+ Subscription",
        "realestate": "Residents Subscription"
      }
    },
    "defricheurPlan": {
      "firstParagraph": "You have received a free one-year subscription with the Trailblazer Offer.",
      "title": "<strong>Free Annual</strong> Subscription"
    },
    "dragonPlan": {
      "firstParagraph": "You are currently on a subscription for {{planName}}.",
      "title": "<strong>Annual</strong> Subscription"
    },
    "end": "Ends on {{date}}",
    "extraGroups": "Your other Clubs",
    "freeSubButtonText": "Create an offer",
    "freeSubText": {
      "defricheur": "There are few items in your neighbourhood. <strong>Free annual subscription for the first (5) users</strong> who post an offer.",
      "trial": "Help grow the <strong>Partage Club</strong> catalog! Post 5 offers and get a <strong>free annual subscription</strong>!"
    },
    "giftPlan": {
      "firstParagraph": "You have received a subscription as a gift.",
      "title": "<strong>Annual</strong> Subscription"
    },
    "modal": {
      "codeFieldLabel": "Invitation code",
      "codeFieldPlaceholder": "eg: 4D86DJ",
      "error": {
        "codeLimitReached": "There are no more subscriptions available for this invitation code. You can still use the trial period to try the application.",
        "forbidden": "You are not authorized to use this code",
        "invalidCode": "You entered an invalid code",
        "missingCode": "Please enter a code"
      },
      "firstParagraph": "Please enter the invitation code sent to you.",
      "primaryButtonText": "Activate",
      "secondaryButtonText": "Cancel",
      "title": "Activate your Subscription"
    },
    "noEnd": "Lifetime subscription",
    "offreTrialPlan": {
      "firstParagraph": "You have received a free subscription by publishing 5 offers.",
      "title": "<strong>Free Annual</strong> Subscription"
    },
    "planExpired": {
      "advantages": "Benefits of subscribing",
      "title": {
        "regular": "Your subscription has expired.",
        "trial": "Your free trial has ended."
      },
      "text": {
        "regular": "You can continue lending without a subscription, but to borrow, a subscription is required.",
        "trial": "You can continue lending without a subscription, but to borrow, a subscription is required."
      }
    },
    "promoDragonText": "« Dans l'oeil du dragon » <strong>promotion</strong>. Get an <strong>annual subscription</strong> at $30 instead of $60.",
    "promoDragonText2": "⌛ Until April 24, 2024 11:59 pm",
    "promoDragonButtonText": "Get 50% off (now $30)",
    "recurrenceWhen": "Next payment date",
    "endsWhen": "Subscription end date",
    "trialEndsWhen": "Trial end date",
    "referralPrizePlan": {
      "firstParagraph": "You have received a free one-year subscription by inviting one person to sign up.",
      "title": "<strong>Free Annual</strong> Subscription"
    },
    "regularPlan": {
      "firstParagraph": "You are currently on a regular subscription.",
      "title": "<strong>Regular</strong> Subscription"
    },
    "regularMonthlyPlan": {
      "firstParagraph": "You are currently on a monthly subscription.",
      "title": "<strong>Monthly</strong> Subscription"
    },
    "regularYearlyPlan": {
      "firstParagraph": "You are currently on a yearly subscription.",
      "title": "<strong>Yearly</strong> Subscription"
    },
    "startRecurrenceButtonText": "Renew",
    "stopRecurrenceButtonText": "Unsubscribe",
    "stopRecurrenceModal": {
      "title": "Subscription cancellation",
      "text": "Your next payment will not be charged, and the automatic renewal will be canceled. You can continue enjoying your subscription until {{date}}.",
      "ctaPositive": "Unsubscribe",
      "ctaNegative": "Do nothing"
    },
    "subscribeButton": "Choose a subscription",
    "title": "My Subscription",
    "trialPlan": {
      "firstParagraph": "You have <strong>1 free borrowing credit</strong>.",
      "title": "Discovery"
    },
    "viewReferralProgramButton": "Win a free annual subscription",
    "referralProgram": {
      "title": "Want to extend your subscription for free?",
      "subtitle": "For each person you refer, you automatically get one free month at Partage Club."
    }
  },
  "my-preferences": {
    "addToCalendar": {
      "always": "Yes, for all loans",
      "never": "No, never",
      "once": "Always ask me"
    },
    "calendarButtonText": "Calendar",
    "deleteAccountButtonText": "Delete account",
    "languageButtonText": "Communication language",
    "notificationsButtonText": "Notifications",
    "title": "My preferences"
  },
  "my-profile": {
    "clubName": "{{clubName}} Club",
    "memberSince": "Member since {{date}}",
    "subscribedMemberSince": {
      "1": "Member",
      "2": "subscribed",
      "3": "since"
    },
    "city": "City",
    "location": {
      "profileTitle_one": "Approximate pickup area",
      "profileTitle_other": "Approximate pickup areas",
      "privacyHint": "The circle shows the approximate area where pickups can happen.",
      "securityMessage": "This map never reveals an exact address. Any pickup details shared later stay outside this map."
    },
    "offers": {
      "empty": "You have no offers",
      "subtitle": "{{amount}} offers",
      "title": "My offers",
      "count_title": "My {{count}} offers"
    },
    "requests": {
      "empty": "You have no needs",
      "subtitle": "{{amount}} requests",
      "title": "My needs",
      "count_title": "My {{count}} needs"
    },
    "title": "My Profile",
    "titleSharingPlace": "My Sharing Place",
    "tabs": {
      "offers": "Offers",
      "requests": "Requests",
      "reviews": "Reviews",
      "places": "Places",
      "available": "Available",
      "regulars": "Regulars"
    }
  },
  "neighbour-listings": {
    "title": {
      "offer": "Their offers",
      "request": "Their needs"
    }
  },
  "neighbour-profile": {
    "empty": {
      "offers": "Offers shared on this profile will appear here.",
      "requests": "Requests posted on this profile will appear here.",
      "places": "Sharing places added to this profile will appear here.",
      "onSite": "Items available for pickup at this place will appear here."
    },
    "clubName": "{{clubName}} Club",
    "contactButtonTextMember": "Contact this member",
    "contactButtonTextPlace": "Contact this place",
    "memberSince": "Member since {{date}}",
    "currentlyUnavailable": "Unavailable",
    "unavailabilityBannerMessage": "This member is currently unavailable and may not respond to your messages.",
    "subscribedMemberSince": {
      "1": "Member",
      "2": "subscribed",
      "3": "since"
    },
    "city": "City",
    "sectorActivity": "Sector(s) of activity",
    "location": {
      "profileTitle_one": "Approximate pickup area",
      "profileTitle_other": "Approximate pickup areas",
      "privacyHint": "The circle shows the approximate area where pickups can happen. The exact address is not shown."
    },
    "offers": {
      "empty": "This member has no offers",
      "subtitle": "{{amount}} offers",
      "title": "Their offers",
      "count_title": "Their {{count}} offers"
    },
    "requests": {
      "empty": "This member has no needs",
      "subtitle": "{{amount}} requests",
      "title": "Their needs",
      "count_title": "Their {{count}} needs"
    },
    "stats": {
      "chatResponseRate": "Response rate",
      "chatResponseTimeAvg": "Avg. response",
      "impactLevel": "Level of impact",
      "numberOfIncomingLoans": "Borrowings",
      "numberOfOutgoingLoans": "Loans",
      "numberOfRequests": "Needs",
      "trustPoints": "Recommendations",
      "numberOfOutgoingServiceLoans": "Services provided",
      "numberOfIncomingServiceLoans": "Services received",
      "numberOfOutgoingDonations": "Donations provided",
      "numberOfIncomingDonations": "Donations received",
      "numberOfSales": "Sales",
      "recommendationsShort": "Recs.",
      "shares": "Shares",
      "responseRateShort": "Response rate",
      "responseTimeShort": "Avg. response",
      "seeMore": "See more",
      "seeLess": "See less",
      "less": "Less",
      "lent": "Loan(s)",
      "borrowed": "Borrowing(s)",
      "requests": "Need(s)",
      "memberSince": "Joined"
    },
    "seeMore": "See more",
    "goodToKnow": "Good to know",
    "trust": {
      "summary": "<strong>{{count}}</strong> members including <strong>{{names}}</strong> trust this member",
      "summary_one": "<strong>{{count}}</strong> member, <strong>{{names}}</strong>, trusts this member",
      "summaryMore": "<strong>{{count}}</strong> members including <strong>{{names}}</strong> and <strong>{{remaining}} others</strong> trust this member",
      "noMembers": "No members trust this member yet",
      "add": "Add to trust circle",
      "trusted": "I trust this member",
      "info": "Members of your trust circle can see the offers you choose to reserve for them.",
      "manage": "Manage my trust circle",
      "circleTitle": "Trust circle",
      "memberCount_one": "{{count}} member",
      "memberCount": "{{count}} members",
      "commonHeading": "These members of your trust circle also trust {{name}}",
      "otherHeading": "Other members who trust {{name}}",
      "empty": "No members to display",
      "distance": "{{distance}} km",
      "since": "since {{date}}",
      "removeTitle": "Remove {{name}}?",
      "removeMessage": "{{name}} will no longer see offers reserved for your trust circle.",
      "remove": "Remove",
      "cancel": "Cancel",
      "manager": {
        "title": "Trusted sharers",
        "addMembers": "Add members",
        "search": "Search members",
        "clear": "Clear all",
        "results": "Search results",
        "suggestions": "Suggestions",
        "noResults": "No other members found",
        "save": "Save",
        "close": "Close"
      },
      "badge": "In your trust circle"
    },
    "shares": {
      "lentTitle": "Items {{name}} lent",
      "borrowedTitle": "Items {{name}} borrowed",
      "recentTitle": "Recent shares",
      "allTitle": "All shares",
      "commonTitle": "All shares together",
      "borrowed": "borrowed",
      "lent": "lent",
      "lentToYou": "lent you",
      "borrowedFromYou": "borrowed from you",
      "empty": "No shares to display",
      "viewHistory": "View history",
      "commonWidget": "You have shared <strong>{{count}} times</strong> with <strong>{{name}} ·</strong> Last {{ago}}",
      "filters": {
        "all": "All ({{count}})",
        "lent": "Lent ({{count}})",
        "borrowed": "Borrowed ({{count}})"
      },
      "memberActions": {
        "more": "More actions for {{name}}",
        "view": "View profile",
        "message": "Send a message",
        "addTrust": "Add to trust circle",
        "removeTrust": "Remove from trust circle",
        "report": "Report member"
      }
    },
    "title": "Profile",
    "shareProfile": "Share profile",
    "mainTabs": {
      "info": "Info",
      "reviews": "Reviews ({{count}})"
    },
    "titleSharingPlace": "Sharing place",
    "reportUser": "Report this user",
    "reportUserPrompt": "Hi, I'd like to report a user whose behavior I find objectionable or abusive. Could you please review their profile?\n\nThank you.",
    "reportRatingPrompt": "Hi, I'd like to report a review that I find objectionable or inappropriate. Could you please review it?\n\nThank you.",
    "ambassadorLabel": "Ambassador",
    "discount": {
      "sheetTitle": "Offer details",
      "learnMore": "Learn more"
    },
    "placeHelp": {
      "title": "Sharing place",
      "help": "Help",
      "description": {
        "1": "A sharing place is a ",
        "bold1": "safe and community-centred space",
        "2": " where members can meet up to ",
        "bold2": "share",
        "3": " items with each other and also ",
        "bold3": "borrow",
        "4": " items available on site"
      },
      "features": {
        "borrow": {
          "title": "Borrow items on site",
          "description": "Choose and borrow items from the selection offered by the place"
        },
        "dropOff": {
          "title": "Drop off and pick up items easily",
          "description": "This sharing place agrees to temporarily hold loaned items so that borrowers can pick them up whenever they like"
        },
        "deals": {
          "title": "Enjoy special deals",
          "description": "Sharing activities at a sharing place can unlock certain perks, such as discounts on products available on site"
        },
        "frequenting": {
          "title": "Let other members know you visit this place",
          "description": "Let members see the sharing places you frequent directly on your profile"
        }
      }
    },
    "days": {
      "day1": "Monday",
      "day2": "Tuesday",
      "day3": "Wednesday",
      "day4": "Thursday",
      "day5": "Friday",
      "day6": "Saturday",
      "day7": "Sunday"
    },
    "place": {
      "open": "Open",
      "closed": "Closed",
      "until": "until {{time}}",
      "closedUntil": "until {{day}}",
      "members_one": "{{count}} member visits this place",
      "members": "{{count}} members visit this place",
      "membersTitle": "Members",
      "searchMembers": "Search by name",
      "noMembersFound": "No members found",
      "frequenting": "Place visited",
      "joinButton": "I visit this place",
      "helpButton": "Place help",
      "itinerary": "Directions",
      "share": "Share",
      "openingHoursTitle": "Opening hours",
      "openingHoursDisclaimer": "Hours may change. Please check directly on the business's website.",
      "viewHoursOnWebsite": "View hours on the website",
      "joinTitle": "I visit this place",
      "join": {
        "profileTitle": "Show this place on your public profile",
        "profileDesc": "Other users will be able to see that you visit this place.",
        "offersTitle": "Make your offers available to members near this place",
        "offersDesc": "Your offers will be visible to members who visit this place."
      },
      "leaveTitle": "Stop visiting this place",
      "leave": {
        "profileDesc": "This place will no longer appear on your public profile.",
        "offersDesc": "Your offers will no longer be available to members near this place."
      },
      "confirm": "Confirm",
      "noListingsOffer": "No offers available",
      "noListingsRequest": "No requests",
      "noListingsOnSite": "No offers available on site",
      "noFrequentedPlaces": "No frequented sharing places"
    },
    "reviews": {
      "recentTitle": "Recent reviews",
      "noComments": "No comments",
      "defaultSubject": "This member",
      "summaryTitle": "Recommendations summary",
      "howItWorks": "How ratings work",
      "topOpinions": "What people think",
      "viewAllCount_zero": "No ratings for this offer",
      "viewAllCount_one": "View 1 rating",
      "viewAllCount": "View {{count}} ratings",
      "recommended": "Recommended",
      "notRecommended": "Not recommended",
      "loanLabel": "loan",
      "unknownUser": "Member",
      "count": "{{count}} ratings",
      "count_one": "{{count}} rating",
      "sortRecent": "Recent",
      "pendingPrompt": {
        "title": "Had a good experience? Share it!",
        "bodyBorrowingStart": "Rate your borrowing of ",
        "bodyLendingStart": "Rate your loan of ",
        "bodyWith": " with {{name}} from ",
        "dateTo": "to",
        "button": "Leave a rating"
      },
      "role": {
        "borrower": "Borrower",
        "lender": "Lender"
      },
      "listingType": {
        "offer": "Offer:",
        "request": "Request:"
      },
      "listingFallback": "Listing",
      "labels": {
        "assetQuality": "Item matched",
        "logisticsReliability": "Punctuality",
        "communityTrust": "Courtesy"
      },
      "filters": {
        "all": "All ({{count}})",
        "positive": "Recommended ({{count}})",
        "negative": "Not recommended ({{count}})",
        "borrower": "From borrower ({{count}})",
        "lender": "From lender ({{count}})"
      },
      "empty": {
        "title": "{{name}} has no ratings yet",
        "subtitle": "Ratings will appear here"
      },
      "sheet": {
        "title": "How do ratings work?",
        "paragraph1": "On Partage Club, ratings help build a trusted community for safer sharing.",
        "paragraph2": "Only when a loan or borrowing is completed can members rate each other by answering themed questions and optionally leaving a comment and photos.",
        "paragraph3": "Question results are shown as positive, medium, or negative tags depending on the answers. Ratings are visible on member profiles and offers, and are reviewed by our team."
      },
      "actions": {
        "edit": "Edit review",
        "delete": "Delete",
        "report": "Report review",
        "deleteConfirmTitle": "Delete review?",
        "deleteConfirmMessage": "This action cannot be undone.",
        "deleteConfirmOk": "Delete",
        "deleteConfirmCancel": "Cancel"
      }
    },
    "tabs": {
      "overview": "Overview",
      "listings": "Listings",
      "reviewsShort": "Reviews",
      "offers": "Offers",
      "requests": "Requests",
      "reviews": "Ratings",
      "places": "Places",
      "available": "Available",
      "regulars": "Regulars"
    }
  },
  "new": {
    "bonificationPrompt": "Clear photos and details help your item get borrowed.",
    "baconBanner": {
      "text": "This pilot project is for Beaconsfield residents only. <strong>Thanks for being part of it!</strong>",
      "linkText": "Look at tips and best practices",
      "link": "https://www.beaconsfield.ca/en/culture-and-leisure/leisure-and-community-life/partage-club-en"
    },
    "categorySection": {
      "primary": {
        "subtitle": "Choose a category",
        "title": "Category",
        "placeholder": "Categories"
      }
    },
    "dateSection": {
      "title": "Dates",
      "titleOne": "Date",
      "flexibleDates": "Are the dates flexible?",
      "endBeforeStart": "The end date must be on or after the start date."
    },
    "urgentSection": {
      "urgentRequiresExpirable": "The Urgent option is reserved for perishable items."
    },
    "duplicatesStepper": {
      "title": "Extra copies",
      "text": "Create extra identical copies of this offer.",
      "increment": "Increase the number of copies",
      "decrement": "Decrease the number of copies"
    },
    "generalSection": {
      "addPicture": "Add a picture",
      "addPictureLater": "Add the picture later",
      "addPictures": "Add pictures",
      "coverPhoto": "Cover",
      "makeCover": "Make cover",
      "pictureCount": "{{count}}/{{max}} photos",
      "oneOrMany": {
        "many": {
          "title": "Multiple offers",
          "subtext": "Publish multiple items in one click, without photos or prior reflection. It's simple and fast!"
        },
        "one": {
          "title": "Individual offer",
          "subtext": "Publish your item by taking a photo of it."
        }
      },
      "publishOffer": "Post an offer",
      "publishRequest": "Post a need",
      "title": "Offer or need?",
      "addPhotosCompact": "Add photos"
    },
    "multiImagePicker": {
      "addImage": "Add a photo",
      "addImageHint": "Adds another photo to your listing",
      "removeImage": "Remove photo",
      "removeImageHint": "Removes this photo from your listing",
      "coverHint": "The first photo is your cover",
      "emptyHint": "Add up to {{max}} photos. Bright, well-lit shots get more borrows.",
      "uploading": "Loading in progress..."
    },
    "headerTitle": "Create a listing",
    "discardChanges": {
      "title": "Leave listing creation?",
      "description": "Your listing hasn't been published. If you leave now, the content you entered will be lost.",
      "keepEditing": "Keep editing",
      "leave": "Leave"
    },
    "bulk": {
      "headerTitle": "Create many offers",
      "progress": {
        "accessibility": "Step {{current}} of {{total}}"
      },
      "steps": {
        "select": {
          "eyebrow": "Photos",
          "title": "Add one photo per item",
          "subtitle": "Choose all the objects you want to publish in this session."
        },
        "confirm": {
          "eyebrow": "Review",
          "title": "Confirm the photos",
          "subtitle": "Check the order and remove anything you do not want to publish."
        },
        "generating": {
          "eyebrow": "Preparing offers",
          "title": "Generating your offers",
          "subtitle": "We’re preparing a title and description for each photo."
        },
        "review": {
          "eyebrow": "Publish",
          "title": "Review each offer",
          "subtitle": "Check the details, then publish or skip each offer."
        },
        "complete": {
          "eyebrow": "Done",
          "title": "Bulk creation complete",
          "subtitle": "Your saved offers are now published like regular listings."
        },
        "visibility": {
          "eyebrow": "Visibility",
          "title": "Who can see these offers?",
          "subtitle": "Choose the addresses and groups for all offers created in this session."
        }
      },
      "photoSelection": {
        "addPhotos": "Add photos",
        "selectedCount": "{{count}}/{{max}} selected",
        "reorderHint": "Use arrows to reorder",
        "continue": "Review photos",
        "generate": "Generate drafts",
        "photoNumber": "Photo {{number}}",
        "firstHint": "This will be processed first",
        "eachPhotoHint": "One listing draft will be created",
        "moveLeft": "Move photo earlier",
        "moveRight": "Move photo later",
        "remove": "Remove photo"
      },
      "confirmation": {
        "readyTitle": "Ready to generate",
        "readyDescription": "{{count}} photos will be uploaded and analyzed.",
        "confirm": "Generate drafts"
      },
      "camera": {
        "capture": "Take photo",
        "close": "Close camera",
        "counter": "{{count}}/{{max}} photos",
        "done": "Finish",
        "limitReached": "You reached the {{max}} photo limit",
        "permissionAction": "Allow camera",
        "permissionDescription": "Allow camera access to photograph your items, or add photos from your library below.",
        "permissionTitle": "Camera access needed",
        "remaining_one": "{{count}} photos remaining",
        "remaining_other": "{{count}} photos remaining",
        "removePhoto": "Remove captured photo",
        "library": "Library",
        "hint": "One photo, one item",
        "draftHint": "Take your photos, then tap Finish.",
        "finishHint": "Generate drafts from the selected photos",
        "settings": "Open settings",
        "removePhotoNumber": "Remove photo {{number}}"
      },
      "generation": {
        "progress": "{{done}} of {{total}} drafts ready",
        "progressPercent": "{{percent}}% complete",
        "detail": "{{queued}} queued, {{generating}} analyzing, {{failed}} failed",
        "retryFailed": "Retry failed drafts",
        "uploading": "Uploading your photos…",
        "reviewHint": "Nothing is published until you approve it.",
        "failed_one": "{{count}} photo needs another try.",
        "failed_other": "{{count}} photos need another try.",
        "title": "Turning photos into offers",
        "preparing": "Getting your offers ready…"
      },
      "review": {
        "remaining": "{{remaining}} left · {{saved}}/{{total}} saved",
        "generationFailedTitle": "This photo could not be analyzed",
        "generationFailedDescription": "Retry this photo or skip it for now.",
        "saveFailedTitle": "This offer was not saved",
        "saveFailedDescription": "Edit the title or description and try again.",
        "retry": "Retry",
        "accept": "Publish",
        "reject": "Skip",
        "regenerate": "Regenerate",
        "skip": "Skip",
        "acceptSwipe": "Publish",
        "rejectSwipe": "Skip",
        "swipeHint": "← Skip · Publish →",
        "looksGood": "Looks good",
        "noDraftsTitle": "No drafts need review",
        "noDraftsDescription": "Everything generated in this session has been saved or skipped.",
        "finish": "Finish",
        "edit": "View & edit details",
        "doneEditing": "Done editing",
        "untitled": "Add a title",
        "titleHint": "Use at least 3 characters for the title.",
        "title": "Review your offers",
        "position": "{{current}} of {{total}}",
        "editTitle": "Edit details",
        "editHint": "Check the details. Your changes won’t be published until you tap Publish."
      },
      "completion": {
        "title": "Thanks for sharing!",
        "description": "{{saved}} saved, {{skipped}} skipped.",
        "close": "Done",
        "toast": "Bulk offers published",
        "emptyTitle": "All photos reviewed",
        "published_zero": "No offers published.",
        "published_one": "{{count}} offer created.",
        "published_other": "{{count}} offers created.",
        "skipped_one": "{{count}} photo skipped.",
        "skipped_other": "{{count}} photos skipped."
      },
      "cancel": {
        "title": "Cancel bulk creation?",
        "description": "Unsaved draft photos from this session will be removed.",
        "keepWorking": "Keep working",
        "confirm": "Cancel session"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel"
      },
      "errors": {
        "noPhotos": "Add at least one photo before continuing.",
        "noVisibility": "Choose at least one address or group before creating offers."
      },
      "visibility": {
        "confirm": "Save visibility",
        "privateHint": "All sharing options are off. These offers will be private."
      }
    },
    "itemInformationSection": {
      "new": "New",
      "title": "Information",
      "nameFieldLabel": "Item's name",
      "nameFieldPlaceholder": "Ex: Mower",
      "serviceNameFieldLabel": "Title",
      "serviceNameFieldPlaceholder": "Ex: Rake the ground, gardening tips…",
      "descriptionFieldLabel": "Description",
      "descriptionFieldPlaceholder": {
        "offer": "Add useful details: dimensions, brand, weight, etc. The more details you add, the easier it will be for members to understand your offer!",
        "request": "Add useful details: dimensions, brand, weight, etc. The more details you add, the easier it will be for members to understand your need!"
      },
      "clearDescription": "Clear description",
      "clearDescriptionAction": "Clear all",
      "descriptionFieldHelperText": "The more details you provide, the better the smart assistant will be at finding matching offers.",
      "serviceDescriptionFieldPlaceholder": "Add useful details to help understand the requested service. The more details you add, the easier it will be for members to understand your needs!",
      "aiGenerate": {
        "button": "Generate",
        "promptTitle": "Auto-fill",
        "promptDescription": "A title and description, ready to edit.",
        "skip": "No thanks",
        "loading": "Analyzing the image",
        "error": "Failed to analyze the image. Please try again.",
        "rateLimitError": "Too many requests. Please try again later."
      },
      "priceFieldLabel": "Price",
      "valueFieldLabel": "Market value",
      "valueFieldPlaceholder": "Unit price",
      "transactionMode": {
        "sell": "I sell",
        "lend": "I lend",
        "give": "I give"
      },
      "requestTransactionMode": {
        "sell": "💵 Buy",
        "lend": "🫴 Borrow",
        "give": "🎁 Recover"
      },
      "assistant": {
        "knowMore": {
          "howItWorks": "How it works?",
          "title": "Smart Assistant",
          "text1": "The smart assistant <strong>matches</strong> your needs with <strong>relevant offers</strong> and <strong>automatically contacts</strong> potential lenders based on your <strong>description</strong> and your <strong>desired distance</strong>.",
          "text2": "To help the smart assistant find the best matches, add as many <strong>useful details</strong> as possible in the description.",
          "text3": "If there are no relevant offers in the first few days, don't worry. The smart assistant keeps watching for <strong>new potential offers</strong> as they are published."
        },
        "optOutBanner": {
          "title": "Automatically contact members who have what you need",
          "description": "Customize the message sent before publishing"
        },
        "firstCreated": {
          "title": "Let's go!",
          "text1": "Great, the smart assistant has started searching for relevant offers! You will be <strong>notified</strong> when potential lenders have <strong>responded to your message</strong>.",
          "text2": "This may take a few minutes",
          "text3": "In the meantime, <strong>find</strong> the smart assistant directly in the <strong>details of your need</strong>."
        }
      }
    },
    "chooseAutomaticMessage": {
      "text1": "Your automatic message",
      "text2": "You can always edit it later",
      "automaticMessageLabel": "✏️ Customize the message that will be sent:",
      "confirmButton": "Confirm",
      "reset": "Reset",
      "defaultAutomaticMessage": {
        "greeting": "Hi {{firstName}}! I'm looking for the following item, and the recommendation system thinks you might be able to help:\n\n",
        "itemWithDescription": "\"{{itemName}}: {{description}}\"",
        "itemWithoutDescription": "\"{{itemName}}\"",
        "dateBoth": "\n\nFor the period from {{startDay}} {{startMonth}} to {{endDay}} {{endMonth}}",
        "dateStartOnly": "\n\nFor the period starting from {{startDay}} {{startMonth}}",
        "dateEndOnly": "\n\nFor the period until {{endDay}} {{endMonth}}"
      },
      "automaticMessageRequired": "The message cannot be empty."
    },
    "listingCreatedToast": {
      "text": {
        "offer": "To manage it, go to Sharings > My offers",
        "request": "To manage it, go to Sharings > My needs"
      },
      "title": "Listing published"
    },
    "locationSection": {
      "addressFieldSubtitle": "Based on your home address",
      "addressFieldSubtitleCustom": "Based on the address of {{clubName}}",
      "addressFieldTitle": "Neighbourhood Club",
      "groupFieldTitle": "{{clubName}} Club",
      "oneGroupFieldTitle": "Visibility",
      "oneGroupFieldHelp": "Should this listing be visible to other members?",
      "invisible": "Your listing will not be visible to other users.",
      "addressesTitle": "Addresses",
      "clubsTitle": "Partner Clubs",
      "title": "Visible for",
      "makePrivate": "Make private",
      "privateVisibility": "Private visibility",
      "shareWithAll": "Share with all"
    },
    "primaryButtonPostOffer": "Post this offer",
    "primaryButtonPostOfferMultiple": "Post {{count}} offers",
    "primaryButtonPostRequest": "Post this need",
    "primaryButtonConfirmRequest": "Confirm",
    "secondaryButtonText": "Cancel",
    "prompt": {
      "type": {
        "title": "What do you want to do?",
        "offer": "Offers",
        "request": "Requests",
        "post": "Share an experience"
      },
      "post": {
        "title": "Which exchange do you want to share?",
        "loading": "Loading your exchanges...",
        "empty": "You have no completed exchange available for a new post."
      },
      "offer": {
        "title": "Offers",
        "one": "Loan a specific item",
        "perishable": "Perishable offer",
        "donation": "Give away an item",
        "bulk": "Create many offers from photos",
        "many": "Choose from suggested items"
      },
      "request": {
        "title": "Requests",
        "one": "Borrow an item",
        "donation": "Ask for a donation",
        "service": "Ask for a service"
      },
      "serviceRequest": {
        "title": "Select a category",
        "missing": {
          "title": "Not finding what you are looking for?",
          "text": "Send us your request, and we will assess whether it can be added to the list soon.",
          "ctaButton": "Send",
          "chatPrompt": "Hello {{name}},\n\nFeel free to <strong>share the service need</strong> you would like to see in the application.\n\nWe will forward it to the City of Beaconsfield, which will determine if it can be added."
        }
      },
      "publishAnObject": "Publish an object"
    },
    "timeSection": {
      "title": "Times",
      "labelStart": "Start",
      "labelEnd": "End"
    },
    "addressSection": {
      "title": "Address"
    },
    "bonificationDetailsPrompt": "A clear description helps your item get borrowed."
  },
  "notification-explainer": {
    "headerTitle": "Notifications",
    "context": {
      "chat": {
        "subtitle": "Be alerted as soon as this person replies by receiving a notification.",
        "title": "Would you like to know when {{name}} answers you?"
      },
      "listing": {
        "subtitle": "Be alerted as soon as someone contacts you by receiving a notification.",
        "title": "Would you like to know when someone contacts you?"
      }
    },
    "primaryButtonText": "Yes, alert me",
    "secondaryButtonText": "Not now"
  },
  "notification-super-changed": {
    "headerTitle": "Super Sharer"
  },
  "notification-warn": {
    "authorize": "Authorize",
    "later": "Not now",
    "subtitle": "Be alerted as soon as someone writes to borrow your items or responds to your need.",
    "title": "Enable notifications to stay informed!"
  },
  "notifications": {
    "donationEndsSoonTitle": "{{listingName}} will expire in {{numDays}} days",
    "donationEndsSoonMessage": "Change the pick up before date, or delete it if it is not relevant anymore.",
    "joinCoCreatorTitle": "Improve the app with us!",
    "joinCoCreatorMessage": "Join our co-creators group on Facebook.",
    "emptyState": "You have no notification",
    "favouriteReceived": "<strong>{{userName}}</strong> added your listing to their favourites.",
    "favouriteReceivedOffer": "<strong>{{userName}}</strong> added your offer to their favourites.",
    "favouriteReceivedRequest": "<strong>{{userName}}</strong> added your request to their favourites.",
    "futureReminder": "Return in {{days}} days",
    "futureReminderSale": "Sale scheduled in {{days}} days",
    "impactLevel": "Your current level: <strong>{{level}}</strong>!",
    "impactLevelCelebration": {
      "sharer1": {
        "message": "🥳 Well done! Continue to grow your positive impact.",
        "title": "You've moved on to <strong>Sharer</strong> level!"
      },
      "sharer23": {
        "message": "🎉 You are <strong>{{numLeft}}</strong> shares away from top level. Continue one loan at a time!",
        "title": "Well done!"
      },
      "sharer4": {
        "message": "💪🏻 One more share and you will reach the highest level: <strong>Super Sharer</strong>.",
        "title": "You’re almost there!"
      },
      "superSharer": {
        "message": "Well done! With each share, you grow your impact for a greener future. Go see your impact! 💚",
        "title": "You're a <strong>Super Sharer</strong>!"
      }
    },
    "impactLevelExplorerMessage": "Begin your Partage Club experience. Publish something to grow your impact and move to the next level.",
    "impactLevelMessage": "Well done! Go see how you can grow your impact and advance your level.",
    "introModal": {
      "intro": {
        "title": "Welcome to the Club",
        "body": "Discover Partage Club!"
      },
      "b2c_paid": {
        "title": "Welcome to the Club!",
        "body": "As an official member of Partage Club, your subscription unlocks new benefits."
      },
      "b2b_activated": {
        "title": "Welcome to the Club!",
        "body": "Thanks to {{groupName}}, you now enjoy a free subscription."
      },
      "newly_insured": {
        "title": "Partage Club takes responsibility!",
        "body": "Thanks to your subscription, if damage occurs to your items valued at $25 or more during a loan, we're committed to compensating you up to $300 per year."
      },
      "custom": {
        "support": {
          "title": "Something went wrong? Reach out to us!",
          "body": "Our team is here to help quickly."
        }
      }
    },
    "lateLoan": "Was the item returned?",
    "lateLoanService": "Service completed?",
    "lateLoanDonation": "Donation picked up?",
    "lateLoanSale": "Sale completed?",
    "newListingPostedSubscribed": "<strong>{{userName}}</strong> ({{distance}}) posted a new offer you might be interested in: {{itemName}}",
    "newReferralSubscribed": {
      "numLeftMessage": "You have {{numLeft}} sign-ups left to win a free annual subscription!",
      "receivedPrizeMessage": "Congrats! 🥳 You have just won a free annual subscription to Partage Club!",
      "receivedMonthPrizeMessage": "Congrats! 🥳 You have just won a free month to Partage Club!",
      "referredUserRegisteredMessage": "You have invited {{numInvited}} people.\nThe more you invite, the more you contribute to expanding this chain of generosity!",
      "title": "{{firstName}} has signed up with your invitation code"
    },
    "onTime": "Return expected today",
    "onTimeService": "Service expected today",
    "onTimeDonation": "Donation picked up today",
    "onTimeSale": "Sale scheduled today",
    "superChanged": {
      "initialGained": {
        "title": "Congratulations!",
        "body": "You're now a Super Sharer."
      },
      "initialLost": {
        "title": "You’ve lost your Super Sharer badge 😢",
        "body": "Check the new criteria to get it back."
      },
      "initialKept": {
        "title": "Congratulations!",
        "body": "You still have your Super Sharer badge — even with the new criteria!"
      },
      "gained": {
        "title": "Congratulations!",
        "body": "You're now a Super Sharer."
      },
      "lost": {
        "title": "Your Super Sharer badge is gone :(",
        "body": "Find out how to earn it back in no time."
      }
    },
    "rate": {
      "borrower": {
        "message": "Your opinion is important to us and to other members of the Partage Club.",
        "title": "How was your experience with {{lenderName}}?"
      },
      "lender": {
        "message": "Your opinion is important to us and to other members of the Partage Club.",
        "title": "How was your experience with {{borrowerName}}?"
      }
    },
    "ratingReceived": {
      "cta": "View ratings"
    },
    "trustAdded": {
      "title": "New recommendation",
      "message": "A member has recommended you."
    },
    "savedMoney": {
      "title": {
        "borrower": "You saved!",
        "lender": "You helped to save!"
      },
      "message": {
        "borrower": "You saved <strong>${{amount}}</strong> by borrowing {{item}}.",
        "lender": "You helped a member to save <strong>${{amount}}</strong> by lending {{item}}."
      }
    },
    "savedMoneyService": {
      "title": {
        "borrower": "You saved!",
        "lender": "You helped to save!"
      },
      "message": {
        "borrower": "You saved <strong>${{amount}}</strong> by requesting help for {{item}}.",
        "lender": "You helped a member to save <strong>${{amount}}</strong> by offering help for {{item}}."
      }
    },
    "savedMoneyDonation": {
      "title": {
        "borrower": "You saved!",
        "lender": "You helped to save!"
      },
      "message": {
        "borrower": "You saved <strong>${{amount}}</strong> when you received a donation of {{item}}.",
        "lender": "You helped a member to save <strong>${{amount}}</strong> by giving away {{item}}."
      }
    },
    "loanReciprocity": {
      "title": "Your turn to help 🤝",
      "message": "Post the items you rarely use and share them with your neighbours."
    },
    "tabBarLabel": "Notifications",
    "closeButtonAccessibilityLabel": "Close notifications",
    "welcome": "Welcome to Partage Club!",
    "welcomeMessage": "Thanks for trusting us!",
    "trustAdded": {
      "title": "{{name}} trusts you! 🎉",
      "message": "You were added to their trust circle. Would you like to add them to yours?",
      "add": "Add to trust circle",
      "decline": "No thanks",
      "viewProfile": "View member profile"
    }
  },
  "notifications-setting": {
    "title": "Notifications",
    "chatTitle": "Messages",
    "chatHelp": "Receive a notification when a member sends you a private message, for example, to borrow one of your items.",
    "conciergerieTitle": "Intelligent Assistant",
    "conciergerieHelp": "Allow the intelligent assistant to contact you when your items can meet a member's need.",
    "conciergerieToggle": "Allow contacts from the intelligent assistant",
    "needTitle": "Needs",
    "needHelp": "Receive a notification when members publish new needs, to see if you can help them.",
    "weeklyOffersTitle": "New items to borrow",
    "weeklyOffersHelp": "Receive a weekly notification that lists new offers available near you.",
    "urgentOffersTitle": "Urgent offers",
    "urgentOffersHelp": "Receive a notification when members publish new offers for perishable items that need to be claimed soon.",
    "interestAlertsTitle": "Alerts for my interests",
    "interestAlertsHelp": "Receive a notification when a new offer is posted in a category you follow.",
    "pushNotif": "Push notifications",
    "email": "Emails",
    "sms": "SMS"
  },
  "offerAvailability": {
    "conflictWhen": "Reserved on <strong>{{dates}}</strong>",
    "conflictsTitle": "Reservation conflict",
    "conflictsInformationText": "Some items are <strong>already lent</strong> for those dates. You can continue with your reservation, but you need to contact the borrower(s) to resolve those conflicts.",
    "informationText": "Reserve your items to make them unavailable to be borrowed during the selected dates.",
    "informationTextDonation": "Pick a date to indicate that you would like the donation to be picked up before this date.",
    "refrainPopup": {
      "hi": "Dear festival,",
      "text": {
        "lender": {
          "before": "Don't forget to book your festival dates and plan your setup and takedown days when making your reservation.",
          "after": "Don't forget to book your festival dates and plan your setup and takedown days."
        },
        "borrower": "Don't forget to plan your setup and takedown days when borrowing."
      },
      "subtext": {
        "lender": {
          "before": "Book the full days during which the item or items will be unavailable.",
          "after": "Book the full days during which the item is unavailable."
        },
        "borrower": "Indicate the full days during which the item will be borrowed."
      },
      "continue": "Got it",
      "reserveDates": "Reserve dates",
      "later": "Later"
    },
    "saveButton": "Save",
    "title": "Offer Reservation",
    "titleMany": "Reservation for {{count}} offers",
    "titleDonation": "Pick up before date",
    "titleSell": "Sale date"
  },
  "offers": {
    "empty": {
      "firstLine": "All your community offers are listed here. ",
      "primaryButtonText": "Post an offer",
      "secondLine": "You have not yet posted an offer."
    },
    "title": "My listings"
  },
  "onboarding": {
    "confirm": "Confirm",
    "nextStep": "Continue"
  },
  "onboardingIntro": {
    "title": "Ready to share?",
    "text": "Sign up (it’s quick, we promise!) and start sharing with your community."
  },
  "one-channel": {
    "add": "Add",
    "loadingMessages": "Loading messages...",
    "supportReplyPreparing": "Preparing a reply...",
    "dismissConversation": "Dismiss conversation",
    "messageDateSeparator": {
      "todayAt": "Today at {{time}}",
      "yesterdayAt": "Yesterday at {{time}}",
      "dateAt": "{{date}} at {{time}}"
    },
    "minimizeConversation": "Minimize conversation",
    "noChannelSelected": "No conversation selected",
    "titleUser": "Conversation with {{user}}",
    "titleListing": "Conversation with {{user}} - Re: {{listing}}",
    "addToCalendar": {
      "event": {
        "buyItem": "Purchase of {{item}} from {{name}}",
        "donateItem": "Donation of {{item}} to {{name}}",
        "receiveDonation": "Don de {{item}} par {{name}}",
        "giveService": "Service to provide for {{name}}: {{item}}",
        "receiveService": "Service to receive from {{name}}: {{item}}",
        "sellItem": "Sale of {{item}} to {{name}}",
        "borrowObject": {
          "start": "Borrow start with {{name}} for {{item}}",
          "end": "Borrow end with {{name}} for {{item}}"
        },
        "lendObject": {
          "start": "Loan start with {{name}} for {{item}}",
          "end": "Loan end with {{name}} for {{item}}"
        }
      },
      "modal": {
        "always": "Yes, for all loans",
        "description": "Would you like to add these dates to your phone calendar?",
        "discard": "No, not this time",
        "never": "No, never",
        "once": "Yes, just once",
        "title": "Add to calendar"
      }
    },
    "beaconsfieldNewLoanWarning": "Hello {{name}},\n\nIn Beaconsfield, sharing is built on respect, trust… while having fun!\nHere are some simple tips to make your experience enjoyable and safe:\n- Meet in a public place if that makes you feel more comfortable (e.g., Library, City Hall).\n- Only share essential information: just enough to make the sharing possible (e.g., phone number, address).\n\nHappy sharing!\n\nTake your time - connections don’t need to be rushed.",
    "firstLoanPrompt": {
      "title": "Congratulations on your first borrow!",
      "savedAmount": "Congratulations, that's <highlight>{{amount}}</highlight> saved!",
      "description": "Your first borrow is free!",
      "subscribeTitle": "To keep borrowing",
      "subscribeDescription": "To keep borrowing without limits, subscribe now and get <strong>25% off!</strong>",
      "subscribeDescriptionWithDeadline": "Subscribe and get <strong>25% off until {{date}}!</strong>",
      "cta": "Switch to",
      "discountDeadlineNote": "Valid until {{date}}.",
      "note": "If the reservation is cancelled, your free borrow will be available again",
      "lending": {
        "title": "Congratulations on your first loan!",
        "description": "Enjoy coverage for shared items",
        "subscribeDescription": "Subscribe now and get <strong>25% off!</strong>"
      }
    },
    "banner": {
      "listingDeleted": "Listing deleted",
      "oneDate": "Suggest a date",
      "donationDate": "Suggest a pickup date",
      "saleDate": "Suggest a pickup date",
      "twoDatesLender": "Suggest dates",
      "twoDatesBorrower": "View availability",
      "borrowerCreditExhausted": "This user is a free trial member and cannot borrow anymore.",
      "manageLoan": {
        "lender": "Manage loan",
        "borrower": "Manage loan"
      },
      "manageSale": {
        "lender": "Manage sale",
        "borrower": "Manage sale"
      },
      "manageParticipations": {
        "lender": "Manage participation",
        "borrower": "Manage service request"
      },
      "manageService": {
        "lender": "Manage service",
        "borrower": "Manage service request"
      },
      "manageDonation": {
        "lender": "Manage pick up",
        "borrower": "Manage pick up"
      },
      "memberNeed": "Member need",
      "memberOffer": "Member offer",
      "unavailable": {
        "lender": {
          "offer": "Already lent",
          "request": "Already found"
        },
        "borrower": {
          "offer": "Already borrowed",
          "request": "Already found"
        }
      },
      "viewListing": "View listing",
      "yourNeed": "This member can help you",
      "yourOffer": "Your offer"
    },
    "levelModal": {
      "primaryButtonText": "See my impact",
      "secondaryButtonText": "Close",
      "sharer1": {
        "message": "You've increased your impact by making your first loan! You have reached a higher level: <strong>Sharer</strong>.",
        "title": "Well done!"
      },
      "sharer23": {
        "message": "You are <strong>{{numLeft}}</strong> shares away from top level. Continue one loan at a time!",
        "title": "Well done!"
      },
      "sharer4": {
        "message": "<strong>One</strong> more share and you will reach the highest level: <strong>Super Sharer</strong>.",
        "title": "You’re almost there!"
      },
      "superSharer": {
        "message": "You've increased your impact by completing 5 shares! You're at the top level: <strong>Super Sharer</strong> and an example to follow at the Partage Club.\n\nWell done! With each share, you grow your impact for a greener future.",
        "title": "You're a Super Sharer!"
      }
    },
    "loanManagement": {
      "cta": {
        "late": "Confirm return",
        "returned": "Confirm return"
      },
      "body": {
        "late": {
          "lender": "The loan end date is now past. You should contact {{name}} to schedule a time for them to return this item. Once they've returned the item, you can click the button below.",
          "borrower": "The loan end date is now past. You should contact {{name}} to schedule a time for you to return this item. Once you've returned the item, you can click the button below."
        },
        "returned": {
          "lender": "{{name}} said they returned this item to you. Can you confirm?",
          "borrower": "Awaiting confirmation by {{name}}"
        }
      },
      "title": {
        "scheduled": "Loan scheduled",
        "late": "This loan is late",
        "returned": {
          "lender": "Item has been returned?",
          "borrower": "You have returned this item"
        },
        "past": "This loan is now completed"
      },
      "status": "Status"
    },
    "saleManagement": {
      "cta": {
        "ongoing": {
          "borrower": "Confirm receipt",
          "lender": "Confirm sale"
        },
        "late": {
          "borrower": "Confirm receipt",
          "lender": "Confirm sale"
        },
        "returned": {
          "lender": "Confirm sale"
        }
      },
      "body": {
        "ongoing": {
          "borrower": "The scheduled sale date has arrived. Once you have received the item from {{name}}, confirm receipt using the button below.",
          "lender": "The scheduled sale date has arrived. Once you have given the item to {{name}}, confirm the sale using the button below."
        },
        "late": {
          "borrower": "The scheduled sale date has passed. You can contact {{name}} to arrange pickup. Once you have received the item, confirm receipt using the button below.",
          "lender": "The scheduled sale date has passed. You can contact {{name}} to arrange pickup. Once the item has been handed over, confirm the sale using the button below."
        },
        "returned": {
          "borrower": "You confirmed that you received the item. Waiting for confirmation from {{name}}.",
          "lender": "{{name}} confirmed that they received the item. Confirm the sale to complete it."
        }
      },
      "title": {
        "scheduled": "Sale scheduled",
        "ongoing": "The sale is scheduled for today",
        "late": "This sale is late",
        "returned": {
          "borrower": "Receipt confirmed",
          "lender": "The item was received"
        },
        "past": "This sale is completed"
      },
      "status": "Status"
    },
    "serviceManagement": {
      "cta": {
        "late": "Confirm service completion",
        "returned": "Confirm service completion"
      },
      "body": {
        "late": {
          "lender": "The scheduled period for the service has passed. You can contact {{name}} to arrange a new time to complete it. Once the service is done, use the button below.",
          "borrower": "The scheduled period for the service has passed. You can contact {{name}} to arrange a new time as soon as possible. Once the service is completed, use the button below."
        },
        "returned": {
          "lender": "{{name}} says the service has been completed. Can you please confirm?",
          "borrower": "Awaiting confirmation by {{name}}"
        }
      },
      "title": {
        "late": "This service is overdue",
        "returned": {
          "lender": "Has the service been completed?",
          "borrower": "You have received this service"
        },
        "past": "The service has been successfully completed"
      },
      "status": "Status"
    },
    "donationManagement": {
      "cta": {
        "late": "Confirm the donation",
        "returned": "Confirm the donation"
      },
      "body": {
        "late": {
          "lender": "The scheduled date for the donation pick up has passed. You can contact {{name}} to arrange a new time to complete it. Once the pick up is done, use the button below.",
          "borrower": "The scheduled date for the donation pick up has passed. You can contact {{name}} to arrange a new time to complete it. Once the pick up is done, use the button below."
        },
        "returned": {
          "lender": "{{name}} says that the donation has been picked up. Can you confirm?",
          "borrower": "Waiting for confirmation from {{name}}."
        }
      },
      "title": {
        "late": "This pick up is late",
        "returned": {
          "lender": "Has the pick up been completed?",
          "borrower": "You picked up the donation"
        },
        "past": "The donation was successfully picked up"
      },
      "status": "Status"
    },
    "loanMessage": {
      "cancel": "Cancel",
      "edit": "Edit",
      "accept": "Accept",
      "contentAccepted": "The reservation of the item has been confirmed.",
      "contentAsBorrower": "The lender must confirm to reserve the item.",
      "contentAsLender": "The borrower must confirm to reserve the item.",
      "contentCompleted": "The loan of the item is now completed.",
      "contentPending": "The suggested dates must be accepted for the item to be reserved.",
      "contentPendingIsUpdate": "New dates have been suggested. Accept to confirm those new dates.",
      "contentRejected": "The reservation of the item has been cancelled.",
      "endDatePassed": "The proposed loan end date is past.",
      "flexibleDates": "(flexible)",
      "loanStatusAsBorrower": "Borrowing status",
      "loanStatusAsLender": "Loan status",
      "period": "Period",
      "date": "Date",
      "reject": "Decline",
      "startDatePassed": "The proposed loan start date is past.",
      "status": {
        "accepted": "Accepted",
        "completed": "Completed",
        "pending": "Pending",
        "rejected": "Cancelled",
        "returned": "Returned"
      },
      "to": "to"
    },
    "serviceMessage": {
      "contentAccepted": "The service reservation is confirmed.",
      "contentAsBorrower": "The member must confirm for the service to be reserved.",
      "contentAsLender": "The request must be confirmed for the service to be reserved.",
      "contentCompleted": "This service has been completed.",
      "contentPending": "The proposed dates must be accepted for the service to be reserved.",
      "contentPendingIsUpdate": "New dates have been suggested. Accept to confirm those new dates.",
      "contentRejected": "The service request has been declined.",
      "loanStatusAsBorrower": "Status",
      "loanStatusAsLender": "Status",
      "startDatePassed": "The proposed date for the service has passed.",
      "status": {
        "accepted": "Accepted",
        "completed": "Completed",
        "pending": "Pending",
        "rejected": "Declined",
        "returned": "Completed"
      }
    },
    "donationMessage": {
      "contentAccepted": "The donation pick up date has been confirmed.",
      "contentAsBorrower": "The proposed pick up date is pending confirmation.",
      "contentAsLender": "The proposed pick up date is pending confirmation.",
      "contentCompleted": "The donation has been picked up.",
      "contentPending": "The proposed date must be accepted for the pick up to take place.",
      "contentPendingIsUpdate": "The pick up date has been changed. Accept to confirm this new date.",
      "contentRejected": "The proposed date was rejected.",
      "loanStatusAsBorrower": "Status",
      "loanStatusAsLender": "Status",
      "startDatePassed": "The proposed pick up date has passed.",
      "status": {
        "accepted": "Accepted",
        "completed": "Picked up",
        "pending": "Pending",
        "rejected": "Declined",
        "returned": "Picked up"
      }
    },
    "sellMessage": {
      "contentAccepted": "The pick up date has been confirmed.",
      "contentAsBorrower": "The proposed pick up date is pending your confirmation.",
      "contentAsLender": "The proposed pick up date is pending the buyer's confirmation.",
      "contentCompleted": "The item has been handed over to the buyer.",
      "contentPending": "The proposed date must be accepted for the pick up to take place.",
      "contentPendingIsUpdate": "The pick up date has been changed. Accept to confirm this new date.",
      "contentRejected": "The proposed date was rejected.",
      "loanStatusAsBorrower": "Status",
      "loanStatusAsLender": "Status",
      "startDatePassed": "The proposed pick up date has passed.",
      "status": {
        "accepted": "Accepted",
        "completed": "Handed over",
        "pending": "Pending",
        "rejected": "Declined",
        "returned": "Handed over"
      }
    },
    "participationsMessage": {
      "contentAccepted": "Your participation has been confirmed.",
      "contentAsBorrower": "",
      "contentAsLender": "",
      "contentCompleted": "This service has been completed.",
      "contentPending": "",
      "contentPendingIsUpdate": "",
      "contentRejected": "Your participation has been canceled.",
      "loanStatusAsBorrower": "Status",
      "loanStatusAsLender": "Status",
      "startDatePassed": "The date of this event is past.",
      "status": {
        "accepted": "Accepted",
        "completed": "Past",
        "pending": "Pending",
        "rejected": "Canceled",
        "returned": "Past"
      }
    },
    "message_was_read": "Read by {{name}}",
    "notifNowInsured": "<strong>Rest assured and share!\n\nPartage Club can compensate you up to $300</strong> if anything happens to loaned items worth $25 or more.\nIf needed, can contact us here, or by email at <strong>info@partage.club</strong>",
    "promptIntroduceYourself": "You should first send a quick message to the member to introduce yourself, and express your interest.",
    "quickOffer": {
      "text": "Publish in 10 seconds!",
      "title": "Quick publish"
    },
    "membersCount_one": "{{count}} member",
    "membersCount": "{{count}} members",
    "membersTitle": "Members",
    "admin": "Admin",
    "isYou": "You",
    "memberMenu": {
      "makeAdmin": "Add as admin",
      "makeRegular": "Remove as admin",
      "seeProfile": "View profile",
      "remove": "Remove from conversation",
      "report": "Report member",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "makeAdminModal": {
        "title": "Add as admin",
        "body": "Are you sure you want to add {{name}} as an admin of this conversation?"
      },
      "makeRegularModal": {
        "title": "Remove as admin",
        "body": "Are you sure you want to remove {{name}} as an admin of this conversation?"
      },
      "removeModal": {
        "title": "Remove from conversation",
        "body": "Are you sure you want to remove {{name}} from this conversation?"
      },
      "reportModal": {
        "title": "Report member",
        "body": "Are you sure you want to report {{name}}?"
      }
    },
    "muteConversation": "Silence conversation",
    "linkOffer": "Link offer",
    "linkedOffer": "Linked offer",
    "linkOfferModal": {
      "title": "Link an offer",
      "description": "Choose one of your offers to use its availability calendar for this conversation.",
      "empty": "You do not have an active offer to link."
    },
    "linkOfferInline": {
      "title": "Link an offer",
      "description": "Choose one of your offers related to \"{{itemName}}\", then confirm to use its availability calendar in this conversation.",
      "loading": "Searching your offers...",
      "empty": "No matching offer found for this search.",
      "confirm": "Link this offer",
      "confirmSelected": "Link this offer"
    },
    "seeListing": "See listing",
    "transportListing": {
      "date": "Date",
      "departure": "Departure",
      "destination": "Destination",
      "notAvailable": "N/A",
      "view": "View"
    },
    "silenceDurationPrompt": "How long do you want to silence this conversation?",
    "silenceFor1Minute": "For 1 minute",
    "silenceFor15Minutes": "For 15 minutes",
    "silenceFor1Hour": "For 1 hour",
    "silenceFor8Hours": "For 8 hours",
    "silenceFor24Hours": "For 24 hours",
    "silenceFor48Hours": "For 48 hours",
    "silenceFor1Week": "For 1 week",
    "silenceUntilChanged": "Until I change it",
    "silenceNotifications": "Silence notifications",
    "toolbar": {
      "defaultValue": "Hi {{name}}! ",
      "openCamera": "Open camera",
      "openLibrary": "Open photo library",
      "placeHolder": "Your message...",
      "sendLike": "Send a thumbs-up",
      "sendMessage": "Send message"
    },
    "unmuteConversation": "Turn notifications back on",
    "viewMembers": "View members",
    "conciergeMessage": {
      "canHelp": {
        "title": "Great! You can help {{interlocutorName}}:",
        "proposeDates": "• Suggest loan dates",
        "sendMessage": "• Send a message to discuss details",
        "lastMessageText": "You want to help {{interlocutorName}} with this need"
      },
      "canYouHelp": {
        "title": "Do you think you can help?",
        "subtitle": "If not, I will archive this conversation for you",
        "buttonNo": "No",
        "buttonYes": "Yes",
        "whyDidIReceiveThisMessage": "Why did I receive this message?",
        "bottomSheet": {
          "title": "Smart assistant",
          "paragraph1": "You received this message because the smart assistant thinks you might have the item requested by this member.",
          "paragraph2": "Until you answer “yes”, the conversation stays invisible to the borrower, so feel free to decline.",
          "paragraph3": {
            "beforeBold": "To stop receiving these messages, ",
            "bold": "disable the option in your preferences",
            "afterBold": "."
          },
          "cta": "Edit my preferences →"
        },
        "lastMessageText": "Can you help {{interlocutorName}} with this need?"
      },
      "matchAccepted": {
        "title": "Great news! {{interlocutorName}} wants to help you",
        "proposeDates": "• Suggest loan dates",
        "sendMessage": "• Send a message to discuss details",
        "lastMessageText": "{{interlocutorName}} wants to help you"
      },
      "cantHelp": {
        "title": "No problem!",
        "subtitle": "Feel free to contact {{interlocutorName}} if you change your mind",
        "lastMessageText": "You can't help {{interlocutorName}} with this need"
      },
      "resolved": {
        "title": "Good news!",
        "subtitle": "{{interlocutorName}} found what they needed",
        "lastMessageText": "{{interlocutorName}} found what they needed"
      }
    },
    "archivedConvoToast": {
      "title": "Conversation archived",
      "message": "You can find it in the Archived Conversations section."
    },
    "visibleOnlyToYou": "Visible only to you",
    "transportPrompt": {
      "title": "Do you need help with transportation?",
      "description": "You can contact the transportation assistance service to arrange pickup.",
      "cta": "Message the assistance service"
    },
    "postSaleListingPrompt": {
      "title": "What do you want to do with your listing?",
      "description": "Do you still have more to sell? Do you expect to have more later?",
      "keep": "Do nothing",
      "hide": "Hide",
      "delete": "Delete"
    },
    "loanReciprocityPrompt": {
      "title": "Your turn to help 🤝",
      "description": "The community lets you borrow instead of buying. Post several items you rarely use and help in return.",
      "publish": "Post my items",
      "later": "Later"
    },
    "bonification": {
      "borrowerPrompt": {
        "title": "🌟 Make this item shine!",
        "text": "This item would benefit from a real photo or a better description. Suggest an improvement.",
        "cta": "Suggest an improvement"
      },
      "borrowerSubmitted": {
        "title": {
          "reviewing": "✨ Nice work!",
          "accepted": "🎉 Suggestion accepted!",
          "rejected": "✏️ Suggestion declined"
        },
        "text": {
          "reviewing": "Your suggestions were sent to the lender for review.",
          "accepted": "The lender accepted your suggestions. Thank you for your help!",
          "rejected": "The lender declined your suggestions. Thank you for taking the time to suggest improvements for this listing."
        }
      },
      "lenderNudge": {
        "title": {
          "lend": "Someone wants to borrow your item 👋",
          "sell": "Someone wants to buy your item 👋",
          "give": "Someone wants to receive your item 👋"
        },
        "text": "To make the exchange go even better, add a real photo and a short description. It builds trust and makes your item more appealing!",
        "cta": "Complete the item listing"
      },
      "lenderReview": {
        "title": "📩 New suggestion received",
        "text1": "<strong>{{name}}</strong> suggested improvements for your item.",
        "text2": "👉 You can review it and decide to accept, decline, or edit it",
        "ctaView": "View suggestion",
        "ctaReject": "Decline"
      },
      "lenderReviewed": {
        "title": {
          "accepted": "🎉 Suggestion accepted",
          "rejected": "✏️ Suggestion declined",
          "modified": "🎉 Modifications applied!"
        },
        "text": {
          "accepted": "Great! You just completed your item listing.",
          "rejected": "You declined the suggested changes for this listing. You can improve your item listing yourself from your offers.",
          "modified": "The modifications have been applied to your listing."
        }
      }
    },
    "bonificationScreen": {
      "title": "Suggest improvements",
      "suggestionBadge": "Suggestion",
      "borrower": {
        "bannerTitle": "✏️ You are in suggestion mode",
        "bannerText": "The photo and description you suggest will be sent to the lender for approval.",
        "addPhoto": "Add a photo",
        "titleLabel": "Title",
        "descriptionLabel": "Description",
        "submit": "Submit suggestions"
      },
      "lender": {
        "bannerTitle": "✏️ You are viewing a suggestion",
        "bannerText": "Here is the photo and/or description suggested by the borrower. You can accept, edit, or decline it.",
        "banner": "You are viewing a suggestion from a borrower.",
        "photoLabel": "Listing photo",
        "titleLabel": "Item name",
        "descriptionLabel": "Description",
        "currentValue": "Current: {{value}}",
        "accept": "Accept suggestions",
        "acceptModified": "Accept modifications",
        "modify": "Update",
        "reject": "Decline",
        "cancel": "Cancel",
        "rejectConfirm": {
          "title": "Decline suggestions?",
          "text": "Are you sure you want to decline these suggestions?",
          "cancel": "Cancel",
          "confirm": "Decline"
        }
      },
      "summary": {
        "title": {
          "pending": "Suggestions pending review",
          "reviewing": "Suggestions sent",
          "accepted": "Suggestions accepted",
          "rejected": "Suggestions declined"
        },
        "text": {
          "pending": "These suggestions are waiting for the owner to review.",
          "reviewing": "Your suggestions were sent to the lender for review.",
          "accepted": "These suggestions have been accepted and applied to the listing.",
          "rejected": "These suggestions have been declined."
        }
      }
    },
    "replyingTo": "Replying to {{name}}",
    "editing": "Editing",
    "edited": "Edited",
    "deletedMessage": {
      "author": "You deleted this message",
      "other": "This message was deleted"
    },
    "menu": {
      "reply": "Reply",
      "copy": "Copy",
      "edit": "Edit",
      "delete": "Delete",
      "messageActions": "Message actions",
      "photo": "📷 Photo"
    },
    "automaticMessageLabel": "Automated message",
    "helpButton": "How it works",
    "howItWorks": {
      "title": "How does it work?",
      "screenTitle": {
        "borrow": "Borrow",
        "lend": "Lend"
      },
      "assistanceQuestion": "Need more help?",
      "visitHelpCenter": "Visit the help center",
      "borrow": {
        "step1": "<bold>Write a message</bold> to introduce yourself and <bold>express your interest</bold>",
        "step2": "<bold>Suggest</bold> borrowing dates, <bold>wait for confirmation</bold> from your neighbour then <bold>plan the pickup</bold> together",
        "step3": "<bold>Pick up the item</bold> from your neighbour or at a safe public place. <bold>No money exchanged, it's free!</bold>",
        "step4": "<bold>Return it</bold> in good condition and share your experience"
      },
      "lend": {
        "step1": "<bold>Reply to the message</bold> to get to know each other and <bold>discuss the details</bold>",
        "step2": "<bold>Accept or suggest</bold> lending dates and <bold>plan the pickup</bold> together",
        "step3": "<bold>Lend the item</bold> to your neighbour. <bold>No money exchanged, it's free!</bold>",
        "step4": "<bold>Get your item back</bold> in good condition and share your experience"
      }
    },
    "groupCreatedByYou": "You created this discussion",
    "addMembers": "Add members",
    "seeProfile": "View profile",
    "seeMembers": "View members",
    "leaveConversation": "Leave the discussion",
    "renameConversation": "Rename the discussion",
    "deleteConversation": "Delete the discussion",
    "confirmLeaveTitle": "Leave discussion",
    "confirmLeave": "Are you sure you want to leave this discussion?",
    "confirmDeleteTitle": "Delete discussion",
    "confirmDelete": "Are you sure you want to delete this discussion? This cannot be undone.",
    "renameTitle": "Rename discussion",
    "save": "Save",
    "cancel": "Cancel",
    "changeLinkedOffer": "Change linked offer",
    "unlinkOffer": "Unlink offer"
  },
  "recommendations": {
    "one-to-many-similar-listings": {
      "title": {
        "offer": "Similar offers",
        "request": "Similar needs"
      }
    },
    "your-favourites": {
      "title": "Your favourites",
      "emptyStateButton": "Explore the catalog",
      "emptyStateTitle": "Add your first offer to favourites!",
      "emptyStateText": "Favourites will appear here"
    },
    "most-popular": {
      "title": "Most shared"
    },
    "urgent-needs": {
      "title": "Help your neighbors!"
    },
    "recent-offers": {
      "title": "Recent offers"
    },
    "match-needs-with-offers": {
      "title": "You may be able to help"
    },
    "mixed-recommendations": {
      "title": "Recommended for you"
    },
    "your-interest": {
      "title": "{{tagName}}"
    },
    "by-category": {
      "title": "{{categoryName}}"
    },
    "recent-loans": {
      "title": "Recent loans",
      "and": "and",
      "shared": "shared",
      "timeAgo": "{{time}} ago"
    },
    "neighbour-offers": {
      "title": "Their offers"
    },
    "neighbour-requests": {
      "title": "Their needs"
    },
    "nearest-sharing-place": {
      "title": "Sharing places near you"
    }
  },
  "one-listing": {
    "trustCircle": {
      "offerLabel": "Trusted offer",
      "requestLabel": "Trusted request",
      "offerExplanation": "You see this offer because {{name}} trusts you.",
      "requestExplanation": "You see this request because {{name}} trusts you."
    },
    "urgent": "Urgent",
    "availabilitySection": {
      "reservations": {
        "title": "Reservations",
        "text": "Confirm your dates"
      },
      "quantity": {
        "fieldPlaceholder": "1",
        "title": "Inventory",
        "text": "Specify a quantity"
      },
      "title": "Availability",
      "donation": {
        "reservations": {
          "title": "Date",
          "text": "Come pick up this before ..."
        },
        "title": "Availability"
      },
      "loan": {
        "reservations": {
          "title": "Reservation",
          "text": "Make unavailable for my use"
        }
      }
    },
    "categorySection": {
      "primary": {
        "subtitle": "Choose the primary category for this item",
        "title": "Category",
        "placeholder": "Categories"
      }
    },
    "confirmReturnModal": {
      "primaryButtonText": "Confirm",
      "secondaryButtonText": "Cancel",
      "text": {
        "borrower": "By confirming this item's return, you are confirming that you returned it to {{name}}.",
        "lender": "By confirming this item's return, you are confirming that it was returned to you by {{name}}."
      },
      "title": "Confirm return?"
    },
    "confirmSaleModal": {
      "primaryButtonText": {
        "borrower": "Confirm receipt",
        "lender": "Confirm sale"
      },
      "secondaryButtonText": "Cancel",
      "text": {
        "borrower": "By confirming receipt, you indicate that you received the item from {{name}}. The seller must then confirm the sale.",
        "lender": "By confirming the sale, you indicate that you handed the item to {{name}}. The listing will be archived."
      },
      "title": {
        "borrower": "Confirm receipt?",
        "lender": "Confirm sale?"
      }
    },
    "confirmServiceDoneModal": {
      "primaryButtonText": "Confirm",
      "secondaryButtonText": "Cancel",
      "text": {
        "borrower": "By confirming that the service was completed, you acknowledge that {{name}} did provide the service.",
        "lender": "By confirming, you acknowledge having completed the service requested by {{name}}."
      },
      "title": "Service completed?"
    },
    "confirmDonationDoneModal": {
      "primaryButtonText": "Confirm",
      "secondaryButtonText": "Cancel",
      "text": {
        "borrower": "By confirming that the donation has been picked up, you acknowledge that {{name}} has given you this item.",
        "lender": "By confirming, you acknowledge that you gave this item to {{name}}."
      },
      "title": "Donation picked up?"
    },
    "createOfferModal": {
      "primaryButtonText": "Post this offer",
      "secondaryButtonText": "No, thanks",
      "text": "Other members will surely need it. Would you like to share it with other members by posting an offer?",
      "title": "Thank you for lending your item"
    },
    "deleteButtonText": "Delete",
    "deleteConfirmation": {
      "offer": "Delete the offer",
      "request": "Delete the need"
    },
    "deleteErrorModal": {
      "primaryButtonText": "Close",
      "title": {
        "offer": "The offer cannot be deleted",
        "request": "The need cannot be deleted"
      }
    },
    "hasAcceptedLoan": "has lent the item",
    "hasAcceptedLoanAgo": "has lent the item {{ago}} ago",
    "beTheFirstToHelpTitle": "No offers to help yet",
    "beTheFirstToHelp": "You can be the first by contacting this member.",
    "wantToHelpTitle_one": "{{count}} member wants to help",
    "wantToHelpTitle_other": "{{count}} members want to help",
    "wantToHelpSubtitle": "View members who want to help",
    "borrowers": {
      "title_one": "Borrowed {{count}} time",
      "title_other": "Borrowed {{count}} times",
      "borrowedAgo": "{{ago}} ago",
      "borrowedTimesAgo_one": "Borrowed {{count}} time · {{ago}} ago",
      "borrowedTimesAgo_other": "Borrowed {{count}} times · {{ago}} ago"
    },
    "currentBorrower": {
      "title": "Currently borrowed by",
      "scheduledEnd": "Loan scheduled to end {{date}}",
      "viewProfile": "View {{name}}’s profile"
    },
    "sections": {
      "about": "About",
      "noDescription": "This listing does not have a description yet",
      "availabilityAndPickup": "Availability & pickup",
      "owner": "Owner"
    },
    "availability": {
      "availableNow": "Available now",
      "borrowedUntil": "Borrowed until {{date}}",
      "availableUntil": "Available until {{date}}",
      "availableIn_one": "Available in {{count}} day",
      "availableIn_other": "Available in {{count}} days",
      "currentlyUnavailable": "Currently unavailable",
      "currentlyBorrowed": "Currently borrowed",
      "flexibleDates": "Flexible dates",
      "requestDate": "Needed on {{date}}",
      "requestDateRange": "Needed {{start}}–{{end}}"
    },
    "availabilityCalendar": {
      "title": "When is it available?",
      "noUpcomingReservation": "Available all week",
      "currentReservation": "Reserved until {{date}}",
      "nextReservation": "Next reservation starts {{date}}",
      "availableDaysThisWeek_one": "Available 1 day this week",
      "availableDaysThisWeek_other": "Available {{count}} days this week",
      "available": "Available",
      "reserved": "Reserved",
      "viewMore": "Full calendar",
      "viewLess": "Show less",
      "yourDates": "Your date proposal",
      "selectionHint": "Choose your start and end dates",
      "selectedRange": "{{start}} – {{end}}",
      "proposeDates": "Propose these dates",
      "proposalSent": "Your date proposal was sent",
      "dayAvailable": "{{date}} is available",
      "dayUnavailable": "{{date}} is already reserved"
    },
    "socialProof": {
      "savedBy_one": "Saved by {{count}} member",
      "savedBy_other": "Saved by {{count}} members",
      "views_one": "{{count}} view",
      "views_other": "{{count}} views"
    },
    "owner": {
      "member": "Member",
      "lastActive": "Last active {{ago}} ago",
      "memberSince": "Member since",
      "loans": "Loans",
      "recommendations": "Recommendations",
      "responseRate": "Response rate",
      "responseTime": "Usually responds in",
      "trust": "Trust",
      "ratingCount_one": "{{count}} review",
      "ratingCount_other": "{{count}} reviews",
      "viewProfile": "View full profile",
      "openAvatar": "Open {{name}}'s profile photo",
      "openProfile": "Open {{name}}'s profile"
    },
    "headerSection": {
      "address": "Address",
      "available": "Available",
      "contactButtonText": "Contact this member",
      "dateBefore": "Pick up before",
      "date": "Date: ",
      "dates": "Dates: ",
      "distance": "Distance",
      "approximatePickupArea_one": "Approximate pickup area",
      "approximatePickupArea_other": "Approximate pickup areas",
      "approximateLocationHint": "The circle shows the approximate area where this offer can be picked up.",
      "approximateLocationSecurity": "This map never reveals an exact address. Pickup details stay private and are coordinated separately between members.",
      "approximateBorrowerArea_one": "Approximate borrower location",
      "approximateBorrowerArea_other": "Approximate borrower locations",
      "approximateBorrowerLocationHint": "The circle shows where the borrower is located approximately for this need.",
      "approximateBorrowerLocationSecurity": "This map never reveals an exact address. Any follow-up details stay private and are coordinated directly between members.",
      "viewMap": "View map",
      "editButtonText": "Edit ",
      "lessThan": "Less than {{distance}}",
      "lessThanKm": "Less than {{distance}} {{unit}}",
      "loanedLater": "Available until {{date}}",
      "loanedUntil": "Borrowed until {{date}}",
      "myRequest": "My need",
      "neighborRequest": "Need from a member",
      "noDates": "Flexible dates",
      "flexibleDates": "(flexible)",
      "postedOn": "Posted on {{date}}",
      "quantity": "<strong>{{num}}</strong> units",
      "timeBoth": "From <strong>{{start}}</strong> until <strong>{{end}}</strong>",
      "timeStart": "From <strong>{{start}}</strong>",
      "timeEnd": "Until <strong>{{end}}</strong>",
      "unavailable": "Unavailable",
      "inventory": "Inventory",
      "price": "Price",
      "marketValue": "Market value",
      "sharingFee": "Sharing fee",
      "transactionModeLabel": "Transaction",
      "transactionMode": {
        "offer": {
          "sell": "Sale",
          "lend": "Loan",
          "give": "Donation"
        },
        "request": {
          "sell": "Purchase",
          "lend": "Borrow",
          "give": "Donation"
        }
      }
    },
    "loanFee": {
      "title": "Sharing fee: {{amount}}"
    },
    "itemReturnedButtonText": "Confirm return",
    "serviceDoneButtonText": "Confirm service completion",
    "donationDoneButtonText": "Confirm donation pick up",
    "sellDoneButtonText": "Confirm sale",
    "participateButtonText": "Register",
    "unparticipateButtonText": "Cancel my participation",
    "cantParticipateButtonText": "Full",
    "viewParticipationButtonText": "Manage my registration",
    "viewParticipationsButtonText": "View registrations",
    "needFoundModal": {
      "step1": {
        "title": "Remove the listing",
        "body": "Mark your listing as found if your need has been fulfilled.",
        "primaryButtonText": "Mark as found"
      },
      "step2": {
        "title": "Mark as found",
        "gotoSelectLender": "The need has been fulfilled on the Partage Club",
        "gotoFoundElsewhere": "The need has been fulfilled elsewhere",
        "primaryButtonText": "Next"
      },
      "step3": {
        "title": "Congratulations on your loan",
        "body": "Your listing has been marked as found.",
        "primaryButtonText": "Go to catalog",
        "secondaryButtonText": "View my listing"
      },
      "step4": {
        "title": "Select the lender",
        "body": "This step is important for tracking the loan and return dates.",
        "primaryButtonText": "Next"
      },
      "step5": {
        "title": "Select the agreed-upon dates",
        "body": "This step is important for tracking the loan and return dates.",
        "primaryButtonText": "Finish"
      },
      "step6": {
        "title": "Congratulations on your loan",
        "body": "Your listing has been marked as found, and the lender will receive a message to confirm the dates.",
        "primaryButtonText": "Go to catalog",
        "secondaryButtonText": "View my listing"
      }
    },
    "posterSection": {
      "memberSince": "Member since {{date}}",
      "offer": {
        "title": "The member"
      },
      "primaryButtonText": "View profile",
      "request": {
        "title": "The member"
      }
    },
    "primaryButtonText": "Save",
    "primaryButtonTextWithCopies_one": "Save and create {{count}} copy",
    "primaryButtonTextWithCopies_other": "Save and create {{count}} copies",
    "saveToast": {
      "title": "Changes saved",
      "text": "The listing has been updated.",
      "copies_one": "{{count}} new offer created.",
      "copies_other": "{{count}} new offers created.",
      "errorTitle": "Unable to save changes",
      "errorText": "Please try again."
    },
    "removeButtonText": "Remove",
    "subscriptionsSection": {
      "title": "Registrations",
      "titlePublic": "Register to participate",
      "text": "Max. # of participants",
      "textPublic": "How many people?",
      "participants_one": "{{count}} participant confirmed",
      "participants": "{{count}} participants confirmed",
      "participantsFull": "Full!",
      "participantsLeft_one": "{{count}}/{{max}} place left",
      "participantsLeft": "{{count}}/{{max}} places left",
      "participationsSavedToast": {
        "title_one": "Registered {{count}} person successfully",
        "title": "Registered {{count}} people successfully",
        "text": "To modify the number of participants, change the number here and click Save."
      },
      "participationsDeletedToast": {
        "title": "Unregistration successful",
        "text": "You can register again in the future, provided there is still a place available."
      }
    },
    "title": {
      "offer": "Offer",
      "request": "Need",
      "offerDonation": "Offer (donation)",
      "requestDonation": "Need (donation)"
    },
    "unavailableMessage": "The listing may have been deleted or is no longer visible.",
    "unavailableTitle": "This listing is no longer available",
    "urlCopied": "The shareable address (URL) has been copied.",
    "viewsSection": {
      "title": "Reach",
      "views": "Views",
      "favourites": "Favourites"
    },
    "tabs": {
      "info": "Details",
      "stories": "Stories ({{count}})"
    },
    "automaticMessageCard": {
      "title": "We are contacting potential members for you...",
      "titleSearching": "Searching for members...",
      "titleContactedAll": "All potential members have been contacted",
      "titleNoCandidates": "The smart assistant is still on the lookout!",
      "titleDisabled": "The smart assistant is disabled",
      "titleWithResponses": "The smart assistant is contacting potential lenders... You have responses!",
      "subtitle": "The more details you share, the easier it will be for members to understand your offer or need!",
      "subtitleNoCandidates": "No offers found. We are waiting for a member to publish a new offer matching your need!",
      "subtitleDisabled": "Turn the assistant back on to resume searching for potential lenders.",
      "subtitleSearching": "This may take a few minutes.",
      "subtitleWithResponses": "Potential members have replied!",
      "subtitleContactedAll": "In the meantime, we are still watching for a new offer matching your need",
      "contacted": "Members contacted:",
      "responses": "Responses: {{count}}",
      "viewResponses_zero": "View conversation(s)",
      "viewResponses": "View ({{count}}) response(s)",
      "learnMore": "Learn more",
      "automaticMessageLabel": "Automatic message",
      "editAutomaticMessageLabel": "Edit automatic message",
      "enabled": "Smart assistant active",
      "disabled": "Smart assistant disabled"
    },
    "reportListing": "Report this listing",
    "reportListingPrompt": "Hi, I'd like to report a listing that I find objectionable or inappropriate. Could you please review it?\n\nThank you.",
    "invalidFormError": "The listing can't be saved because the form is invalid. Please check each field above and try again."
  },
  "one-loan": {
    "dueDate": "Due date",
    "returned": "Returned",
    "addToCalendarButtonText": "Add to phone calendar",
    "cancelLoanButtonText": {
      "borrowing": "Cancel this loan",
      "lending": "Cancel this loan",
      "service": "Cancel service",
      "donation": "Cancel donation pick up",
      "sale": "Cancel sale"
    },
    "cancelLoanModal": {
      "primaryButtonText": {
        "borrowing": "Cancel this loan",
        "lending": "Cancel this loan",
        "service": "Cancel service",
        "donation": "Cancel donation pick up",
        "sale": "Cancel sale"
      },
      "secondaryButtonText": {
        "borrowing": "Do not cancel",
        "lending": "Do not cancel",
        "service": "Do not cancel",
        "donation": "Do not cancel",
        "sale": "Do not cancel"
      },
      "text": {
        "borrowing": "By confirming the cancellation of this loan, you are signaling the lender that you no longer require this item.",
        "lending": "By confirming the cancellation of this loan, you are signaling the borrower that you will not be loaning this item.",
        "service": "By canceling your request, you inform the member that you no longer need the service.",
        "donation": "By canceling your request, you'd like to inform the member that there will be no pick up of this donation.",
        "sale": "By canceling the sale, you inform the member that the pickup will not take place."
      },
      "title": {
        "borrowing": "Cancel this loan?",
        "lending": "Cancel this loan?",
        "service": "Cancel this service?",
        "donation": "Cancel this donation pick up?",
        "sale": "Cancel this sale?"
      }
    },
    "editParticipationButtonText": "Modifier l'inscription",
    "ratingAccessory": {
      "rate": "👍 Rate {{name}}",
      "mine": "My rating:",
      "recommended": "Recommended",
      "notRecommended": "Not recommended"
    },
    "ratingPrompt": {
      "title": "Had a good experience with {{name}}? Share it!",
      "subtitle": "Your comments help build a more trusted community",
      "dismiss": "No thanks"
    },
    "changeDatesButtonText": {
      "borrowing": "Change loan dates",
      "lending": "Change loan dates",
      "service": "Change service date",
      "donation": "Change pick up date",
      "sale": "Change pickup date"
    },
    "contactSupportAboutIncident": "Report an issue",
    "contactSupportAboutIncidentPrompt": {
      "insured": "Hi {{name}}! 😊\n\nNo worries, unexpected things happen.\n\nTo help you best, could you please explain what happened and, if possible, send us a few photos of the damaged item?\n\nRest assured, if an item you lend or borrow (valued at $25 or more) gets damaged, <strong>we're committed to compensating you up to $300 per year</strong>.\n\nThanks!",
      "uninsured": "Hi {{name}}! 😊\n\nNo worries, unexpected things happen.\n\nTo help you best, could you please explain what happened and, if possible, send us a few photos of the damaged item?\n\n<strong>We're here to help.</strong>\n\nThanks!"
    },
    "donationDate": "Date",
    "end": "Return",
    "endService": "End",
    "expectedEnd": "Expected Return",
    "myParticipations": "My participation",
    "allParticipations": "Number of registered users",
    "counterpart": {
      "borrower": "Borrower",
      "buyer": "Buyer",
      "donor": "Donor",
      "lender": "Lender",
      "recipient": "Recipient",
      "seller": "Seller"
    },
    "listParticipants": "List registered users",
    "history": {
      "accepted_when": "Accepted on {{date}}",
      "end_when": "Expected return · {{date}}",
      "late_x_days": "Item is late · {{numDays}} days",
      "late_yesterday": "Item is late · 1 day",
      "offered_when": "Loan request sent on {{date}}",
      "returned_by_you": "you",
      "returned_when": "Return confirmed by {{who}} · {{date}}",
      "started_when": "Loan started · {{date}}",
      "title": "History"
    },
    "serviceHistory": {
      "accepted_when": "Accepted on {{date}}",
      "end_when": "Expected completion · {{date}}",
      "late_x_days": "Service overdue · {{numDays}} days",
      "late_yesterday": "Service overdue · 1 day",
      "offered_when": "Service request sent on {{date}}",
      "returned_by_you": "you",
      "returned_when": "Service completion confirmed by {{who}} · {{date}}",
      "started_when": "Service in progress · {{date}}",
      "title": "History"
    },
    "donationHistory": {
      "accepted_when": "Accepted on {{date}}",
      "late_x_days": "Pick up overdue · {{numDays}} days",
      "late_yesterday": "Pick up overdue · 1 day",
      "offered_when": "Pick up request sent on {{date}}",
      "returned_by_you": "you",
      "returned_when": "Donation picked up – confirmed by {{who}} · {{date}}",
      "started_when": "Donation pick up expected on {{date}}",
      "title": "History"
    },
    "saleHistory": {
      "accepted_when": "Accepted on {{date}}",
      "end_when": "Pick up expected · {{date}}",
      "late_x_days": "Pick up overdue · {{numDays}} days",
      "late_yesterday": "Pick up overdue · 1 day",
      "offered_when": "Pick up request sent on {{date}}",
      "returned_by_you": "you",
      "returned_when": "Receipt confirmed by {{who}} · {{date}}",
      "started_when": "Pick up expected on {{date}}",
      "title": "History"
    },
    "sendMessage": "Send a message to {{name}}",
    "start": "Start",
    "status": "Status",
    "transactionDate": "Transaction date",
    "title": {
      "borrowing": "Borrowing Details",
      "lending": "Loan Details",
      "service": "Service Details",
      "donation": "Donation Pick Up Details",
      "sell": "Sale Details"
    },
    "viewListing": "View listing's details"
  },
  "payment": {
    "activateButton": "Activate your subscription",
    "benefitsTitle": "Benefits",
    "askForMode": {
      "title": "Choose a payment mode",
      "mode": {
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "stripe": "Credit card"
      }
    },
    "cancellationPolicy": "Your subscription will automatically renew each year. You can cancel your subscription up to 24 hours before the date of your next payment.",
    "couponButton": "Apply",
    "couponFieldPlaceholder": "Promotion code",
    "discountLabel": "Discount",
    "expiredCoupon": "This code has expired",
    "expiredFreeTrial": "Free trial ended on {{date}}",
    "expiredPlan": "Subscription ended on {{date}}",
    "intro": "Borrow <highlight>without limits</highlight> with a <highlight>Partage+</highlight> subscription!",
    "willExpirePlan": "This new subscription would start on {{date}}",
    "invalidCoupon": "This code is invalid",
    "modal": {
      "firstParagraph": "Thanks for trusting us. With your subscription, you can now borrow and lend unlimited items with your neighbours.",
      "primaryButtonText": "Show your subscription",
      "title": "Thank you!"
    },
    "payButton": "Pay",
    "popular": "Popular",
    "loanDiscount": {
      "percentage": "-25%",
      "price": {
        "CAD": "$45",
        "EUR": "€54",
        "USD": "54 USD"
      },
      "footnote": "*{{discountedPrice}} billed annually, then {{renewalPrice}} on the renewal date"
    },
    "yearlyMonthlyEquivalent": "{{price}}/month",
    "monthlyEquivalent": {
      "CAD": "$5",
      "EUR": "€6",
      "USD": "6 USD"
    },
    "period": {
      "monthly": "month",
      "yearly": "year"
    },
    "price": {
      "monthly": {
        "CAD": "$8",
        "EUR": "€9",
        "USD": "9 USD"
      },
      "yearly": {
        "CAD": "$60",
        "EUR": "€72",
        "USD": "72 USD"
      }
    },
    "savings": {
      "yearly": {
        "CAD": "(Save $36)",
        "EUR": "(Save €36)",
        "USD": "(Save 36 USD)"
      }
    },
    "mobileRedirect": {
      "subtitle": "Subscribing to Partage Club is currently only available using our mobile app.\nOnce subscribed, you will be able to continue using the website to borrow and lend items.",
      "forWhat": ""
    },
    "web": {
      "activationPending": "Activation is taking longer than expected. Your payment is confirmed and you will not be charged again.",
      "initializationError": "Unable to load secure checkout. Please try again.",
      "retryCheckout": "Retry checkout",
      "genericError": "The payment could not be confirmed. Check your information and try again.",
      "loading": "Loading secure payment…",
      "paymentConfirmed": "Payment confirmed",
      "paymentDetails": "Payment method",
      "paymentPending": "Payment pending",
      "paymentPendingDetails": "Your payment is still being processed. We’ll activate your subscription once Stripe confirms it.",
      "processing": "We’re activating your subscription. This usually takes a few seconds.",
      "removeCoupon": "Remove promo code",
      "taxes": "Taxes",
      "total": "Total",
      "unavailable": "Web payment is not available for this subscription.",
      "verifyingPayment": "Verifying your payment",
      "verifyingPaymentDetails": "We’re checking the latest payment status with Stripe.",
      "viewSubscription": "View your subscription"
    },
    "subtotal": "Subtotal",
    "taxes": "Taxes",
    "title": "Activate your subscription"
  },
  "paywall": {
    "firstHero": "Your 3-week trial has ended.",
    "firstHeroBis": "Your subscription has ended.",
    "firstSubhero": "You can still share by lending your items for free, but you must be a member to borrow.",
    "pricesDescription": {
      "monthly": "Monthly subscription",
      "yearly": "Annual subscription"
    },
    "firstFeature": "Unlimited borrowings",
    "secondFeature": "One referral = 1 free month",
    "thirdFeature": "Partage Club is responsible for damages to items.",
    "fourthFeature": "Cancel at any time",
    "ctaLabel": "Subscribe now",
    "redesign": {
      "cancelAnytime": "Cancel at any time",
      "coverageFootnote": "*Partage Club Responsibility covers up to $300 for items that are lent or borrowed.",
      "damageCoverage": "Coverage for shared items*",
      "expired": {
        "subtitle": "Your subscription has ended. Get all your benefits back in one click.",
        "title": "Ready to start again?"
      },
      "included": "What’s included:",
      "learnMore": "Learn more",
      "noThanks": "No thanks",
      "standard": {
        "subtitle": "Unlock the full experience to keep borrowing with peace of mind.",
        "title": "You’re on the right track!"
      },
      "subscribe": "Subscribe now",
      "unlimitedBorrowing": "Unlimited borrowing",
      "unlimitedLending": "Unlimited lending"
    }
  },
  "paywall2": {
    "title": {
      "trial": "Free trial ended, but...",
      "regular": "Subscription ended, but..."
    },
    "offer": {
      "trial": "Save 25% on the annual subscription and get coverage with Partage Club Responsibility!",
      "regular": "Here's a great reason to subscribe!"
    },
    "details": {
      "trial": "With your subscription, if an item you lend or borrow (valued at $25 or more) gets damaged, <strong>we're committed to compensating you up to $300 per year</strong>.\n\nPromo code: <strong>PARTAGE25</strong>",
      "regular": "With your subscription, if an item you lend or borrow (valued at $25 or more) gets damaged, <strong>we're committed to compensating you up to $300 per year</strong>."
    },
    "button": {
      "trial": "Subscribe",
      "regular": "Subscribe"
    }
  },
  "personal-information": {
    "activitySectorsFieldLabel": "Activity sector(s)",
    "activitySectorsFieldSubtitle": "Select at least 1 option",
    "firstNameFieldLabel": "First name",
    "firstNameFieldPlaceholder": "First name",
    "lastNameFieldLabel": "Last name",
    "lastNameFieldPlaceholder": "Last name",
    "phoneFieldLabel": "Cell phone number",
    "phoneFieldError": "Phone number is not valid.",
    "phoneFieldSubtitle": "Don’t worry, we will never share your number with another user or with any company.",
    "pictureFieldSubtitle": "The profile picture increases trust between members",
    "pictureFieldTitle": "Add a profile picture",
    "title": "Your personal information",
    "phoneFieldHelp": {
      "title": "Phone number",
      "boldText": "A small gesture that changes everything !",
      "text": "Your number confirms your identity, strengthening the community’s trust.\n\nWe only use it in case of emergency (missed message, blocked email) to ensure every share goes smoothly.\n\nDon’t worry, we will never share it with anyone else."
    }
  },
  "privacy": {
    "title": "Terms and Privacy",
    "button1Text": "Terms and Conditions",
    "link1": "https://www.partage.club/en-ca/terms-and-conditions",
    "button2Text": "Privacy Policy",
    "link2": "https://www.partage.club/en-ca/privacy-policy",
    "button3Text": "Responsibility of Partage Club",
    "link3": "https://www.partage.club/en-ca/terms-and-conditions#responsabilite"
  },
  "profile": {
    "tabBarLabel": "Profile"
  },
  "profile-overview": {
    "contactUsButtonLabel": "Help",
    "editProfileButtonLabel": "Edit",
    "inviteNeighboursButtonLabel": "Invite neighbours",
    "logoutButtonLabel": "Log out",
    "memberSince": "Member since {{date}}",
    "myClubButtonLabel": "Members list",
    "myClubsButtonLabel": "Change my clubs",
    "myFinancialImpactButtonLabel": "Economic",
    "myRatingsButtonLabel": "Ratings",
    "streak": "Streak",
    "streakHood": "Neighbourhood streak",
    "superButtonLabel": "<strong>Super Sharer</strong>",
    "superButtonLabelNotYet": "Become a <strong>Super Sharer</strong>",
    "myImpactTitle": "My Impact",
    "ambassadorButtonLabel": "<strong>Ambassador Space</strong>",
    "ambassadorButtonLabelNotYet": "Become an <strong>Ambassador</strong>",
    "myInformationButtonLabel": "Account settings",
    "myInformationTitle": "Personal Information",
    "myPreferencesButtonLabel": "Manage my preferences",
    "myInterestsButtonLabel": "Manage my interests",
    "myActivitySectorsButtonLabel": "My activity sectors",
    "myProfileButtonLabel": "Public profile",
    "mySubscriptionButtonLabel": "Manage my subscription",
    "otherTitle": "Other",
    "darkModeLabel": "Dark mode",
    "title": "My Profile",
    "tosButtonLabel": "Terms & Privacy",
    "editAvatarButton": "Edit Avatar",
    "profilePictureChangedToast": "Profile picture changed",
    "unavailableButtonLabel": "Report me <strong>unavailable...</strong>",
    "unavailableStatusInformation": "From <strong>{{startDate}}</strong> to <strong>{{endDate}}</strong>",
    "unavailableStatusTitle": "Status",
    "unavailableStatusBadge": "Unavailable",
    "deleteStatus": "Delete my status",
    "deleteStatusToast": {
      "title": "Your unavailability status has been deleted"
    },
    "editStatusAccessibilityLabel": "Edit unavailability status",
    "unavailableStatusWarning": "Planned unavailability: <strong>{{startDate}}</strong> to <strong>{{endDate}}</strong>"
  },
  "my-ratings": {
    "title": "Ratings",
    "loading": "Loading ratings...",
    "tabs": {
      "given": "Given ({{count}})",
      "received": "Received ({{count}})"
    }
  },
  "publicUserWelcome": {
    "title": "Thank you!",
    "instructions": "Your account is ready! You'll soon be able to help local farmers and receive surplus donations.",
    "enableNotificationsPrompt": "Turn on notifications to be alerted as soon as listings appear!",
    "notificationsEnabled": "Notifications are ON. You'll be alerted as soon as new listings appear!",
    "buttonEnableNotifications": "Enable my notifications",
    "buttonLater": "Skip for now"
  },
  "quick-new-choose": {
    "buttonText": "Validate my offers",
    "secondaryButtonText": "Back",
    "headerText": "By publishing items, you increase other people's trust in you.",
    "headerTextHalloween": "It's <strong>Halloween</strong> soon, members are looking for costumes. Do you have those?",
    "headerTitle": "Publish multiple offers",
    "nothingSelectedError": {
      "buttonText": "Back",
      "text": "You must select at least one item to continue.",
      "title": "Select 1+ item(s)"
    }
  },
  "quick-new-confirm": {
    "buttonText": "Publish ({{num}})",
    "secondaryButtonText": "Back",
    "headerText": "By <strong>pressing Publish</strong>, the selected items will be published <strong>on your profile</strong> and other people <strong>will be able to borrow them</strong>",
    "headerTitle": "Confirmation",
    "almostThere": "Almost there!"
  },
  "quick-new-thanks": {
    "bodyText": "You can modify your offers at any time in your sharing center.\n\nYour profile is complete, you are ready to start <strong>lending!</strong>",
    "buttonBackText": "Go to the board",
    "buttonListingsText": "View my listings",
    "buttonAddLoanFeeText": "Add a sharing fee",
    "didYouKnowTitle": "Did you know?",
    "didYouKnowBody": "Items with a real photo are 3x more likely to be borrowed. You can go check your listings to improve them!",
    "headerText": "Thank you!",
    "headerTitle": "Thank you!",
    "myImpactLevelButtonText": "See my impact",
    "userNowContributorText": "You've reached a higher level: <strong>Contributor</strong>. By publishing your first offer, you have increased your impact."
  },
  "ratings": {
    "confirmation": {
      "cancel": "Cancel recommendation",
      "text1": "<strong>You recommended {{name}}!</strong>",
      "text2": "<strong>Thanks</strong> (from them too) 😊",
      "text3": "You can see the number of recommendations that other members received in their profile, but also in listings and members' lists."
    },
    "notGreat": {
      "chatPrompt": "Hello {{name}}! 😊\n\nThanks for taking the time to share your experience with us. So, what happened?",
      "ctaButton": "Contact Partage Club",
      "text1": "Thanks for your feedback.",
      "text2": "We're sorry that your sharing experience wasn't positive. 🙁 Do you want to write to us, so we can understand what happened?"
    },
    "prompt": {
      "text1": "Leave a review for {{name}}?",
      "text2": "Share your experience so others won't hesitate to do the same :)",
      "ctaButton": "Leave a review"
    },
    "promptFigma": {
      "title": "Did you have a great experience?\nShare it!",
      "subtitle": "Your comments help build a more trusted community"
    },
    "ratingPrompt": {
      "text": "Your review has been published! Thank you for taking the time to share your experience."
    },
    "rated": {
      "recommended": "You recommended {{name}}",
      "notRecommended": "You did not recommend {{name}}"
    },
    "newRating": {
      "title": "Rate this exchange",
      "intro": "Your honest feedback helps build a more trusted community. Please rate each aspect from 1 to 5.",
      "finalNotice": "Ratings are final and cannot be edited later.",
      "tapToRate": "Tap a number to rate",
      "commentTitle": "Anything you'd like to add?",
      "commentHelp": "Visible only to the Partage Club team. Use this to flag issues or share useful context.",
      "commentPlaceholder": "Optional internal note...",
      "submitButton": "Submit ratings",
      "errorTitle": "Something went wrong",
      "errorMessage": "We couldn't save your ratings. Please try again.",
      "notReadyMessage": "This exchange must be fully completed before you can leave a review. If you returned an item, wait for the other person to confirm it.",
      "figmaHeaderTitle": "Write a review",
      "figmaStepLabel": "Step {{count}} of 2",
      "figmaStepCounter": "{{current}} of {{total}}",
      "figmaSubjectBorrowerLabel": "Borrower",
      "figmaRecommended": "Recommended",
      "figmaNotRecommended": "Not recommended",
      "figmaOverallQuestion": {
        "lender": "Did your lending experience go well?",
        "borrower": "Did your borrowing experience go well?"
      },
      "figmaInfoPrompt": "Item returned on {{date}} · {{count}} d borrowed",
      "figmaQuestions": {
        "lender": {
          "assetQuality": {
            "question": "What condition was the item in when it was returned?",
            "labels": {
              "1": "Heavily damaged",
              "2": "Damaged",
              "3": "Fair condition",
              "4": "Good condition",
              "5": "Like new"
            }
          },
          "logisticsReliability": {
            "question": "Did this person respect the meeting time?",
            "labels": {
              "1": "Very late",
              "2": "Late",
              "3": "Slightly late",
              "4": "On time",
              "5": "Very punctual"
            }
          },
          "communityTrust": {
            "question": "How did the welcome and interaction with this person go?",
            "labels": {
              "1": "Very unpleasant",
              "2": "A bit cold",
              "3": "Okay",
              "4": "Warm",
              "5": "Excellent"
            }
          }
        },
        "borrower": {
          "assetQuality": {
            "question": "Was the item as described and working properly?",
            "labels": {
              "1": "Not as described",
              "2": "Slightly as described",
              "3": "Mostly as described",
              "4": "As described",
              "5": "Exactly as described"
            }
          },
          "logisticsReliability": {
            "question": "Did this person respect the meeting time?",
            "labels": {
              "1": "Very late",
              "2": "Late",
              "3": "Slightly late",
              "4": "On time",
              "5": "Very punctual"
            }
          },
          "communityTrust": {
            "question": "How did the welcome and interaction with this person go?",
            "labels": {
              "1": "Very unpleasant",
              "2": "A bit cold",
              "3": "Okay",
              "4": "Warm",
              "5": "Excellent"
            }
          }
        }
      },
      "figmaAddDetailsTitle": "Add details",
      "figmaImproveListingTitle": "Improve the listing",
      "figmaAddPhotoTitle": "Add a photo of the item",
      "figmaModifyPhotoTitle": "Modify the photo of the item",
      "figmaCommentTitle": "Leave a comment",
      "figmaOptional": "(optional)",
      "figmaRequired": "(required)",
      "figmaCommentPlaceholder": "I recently borrowed a book from Jean, and it was a great experience...",
      "figmaPublicCommentHint": "Your review will be visible publicly",
      "figmaDetailSectionTitle": "Rate the key aspects",
      "figmaContinueButton": "Continue",
      "figmaSubmitButton": "Submit",
      "thanks": {
        "title": "Thanks for your review!",
        "subtitle": "You help build a more <strong>trusted</strong> community",
        "negativeSubtitle": "We're sorry the experience wasn't positive. We'll review your feedback in detail.",
        "button": "Done",
        "editButton": "Edit my review"
      },
      "reciprocity": {
        "title": "Your turn to share",
        "description": "Did your loan go well? Post the items you rarely use and help the community in return.",
        "publish": "Post my items",
        "later": "Later"
      },
      "badges": {
        "lender": {
          "assetQuality": {
            "negative": "Returned in poor condition",
            "neutral": "Handled the item with care",
            "positive": "Handled the item with care"
          },
          "logisticsReliability": {
            "neutral": "Punctuality",
            "negative": "Punctuality",
            "medium": "Punctuality",
            "positive": "Punctuality"
          },
          "communityTrust": {
            "neutral": "Courtesy",
            "negative": "Courtesy",
            "medium": "Courtesy",
            "positive": "Courtesy"
          }
        },
        "borrower": {
          "assetQuality": {
            "negative": "Item not as described",
            "neutral": "Item match",
            "positive": "Item match"
          },
          "logisticsReliability": {
            "neutral": "Punctuality",
            "negative": "Punctuality",
            "medium": "Punctuality",
            "positive": "Punctuality"
          },
          "communityTrust": {
            "neutral": "Courtesy",
            "negative": "Courtesy",
            "medium": "Courtesy",
            "positive": "Courtesy"
          }
        }
      }
    }
  },
  "reset-password": {
    "codeFieldLabel": "Confirmation code received",
    "codeFieldPlaceholder": "eg: 123456",
    "details": "A Confirmation code was sent to your email address. Enter it below, then choose a new password.",
    "passwordFieldLabel": "Your new password",
    "passwordFieldPlaceholder": "Choose a new password",
    "primaryButtonText": "Change my password",
    "title": "Create a new password"
  },
  "settingsPrompt": {
    "camera": {
      "title": "Allow camera permission",
      "text": "To allow our app to access your camera, simply access your phone's settings and grant permission for Camera."
    },
    "notification": {
      "title": "Enable Notifications",
      "text": "To start receiving push notifications from our app, simply access your phone's settings and grant permission for Notifications."
    },
    "primaryButtonText": "Go to Settings",
    "secondaryButtonText": "Cancel"
  },
  "signup": {
    "guestTitle": "Join {{appName}}!",
    "guestCreateAccount": "Create an account",
    "title": "Create your account",
    "alreadyHaveAccountPrefix": "Already registered ?",
    "alreadyHaveAccount": "Sign in",
    "signUpWithEmail": "Sign up using email",
    "signUpWithApple": "Sign up using Apple",
    "signUpWithFacebook": "Sign up using Facebook",
    "signUpWithGoogle": "Sign up using Google",
    "continueWithApple": "Continue with Apple",
    "continueWithFacebook": "Continue with Facebook",
    "continueWithGoogle": "Continue with Google",
    "enterValidationCode": "Enter validation code"
  },
  "splash": {
    "poweredBy": "Powered by"
  },
  "presentPartageClub": {
    "headerTitle": "Welcome to Partage Club",
    "title": "Welcome to Partage Club",
    "community": {
      "headerText": "Partage Club is the application for <strong>sharing objects</strong> between neighbors.",
      "footerText": "Enjoy life <strong>fully</strong>, without limiting yourself to what you own."
    },
    "accessMore": {
      "headerText": "With Partage Club, you access an <strong>abundance of objects</strong>.",
      "footerText": "Sports equipment, tools, games for children, etc.: here, you truly <strong>find everything.</strong>"
    },
    "offerMore": {
      "headerText": "With Partage Club, your <strong>generosity</strong> makes a real <strong>difference</strong>.",
      "footerText": "Let others <strong>benefit</strong> from your underutilized objects. It feels good."
    },
    "button": {
      "noAccountYet": "Join the community",
      "alreadyHaveAnAccount": "I already have an account"
    }
  },
  "presentCommunity": {
    "headerTitle": "Welcome to the community",
    "title": "Present community",
    "newFlow": {
      "continue": "Continue",
      "continueWithoutArrow": "Continue",
      "startSharing": "Start sharing!",
      "continueFree": "Continue for free",
      "subscribeNow": "Subscribe now",
      "yearlyPrice": "{{annualPrice}}/year ({{monthlyPrice}}/month). Cancel anytime",
      "includedToday": "What's included today:",
      "includedWith": "What's included with",
      "unlimitedLending": "Unlimited lending",
      "unlimitedLendingDescription": "Post offers and lend your items to neighbours as often as you like",
      "oneFreeBorrow": "1 free borrow",
      "oneFreeBorrowPrefix": "1 free",
      "oneFreeBorrowHighlight": "borrow",
      "oneFreeBorrowDescription": "Borrow your first item from a neighbour for free",
      "unlimitedBorrowing": "Unlimited borrowing",
      "damageCoverage": "Coverage for shared items",
      "learnMore": "Learn more",
      "coverageFootnote": "*Partage Club Responsibility covers up to $300 for items that are lent or borrowed.",
      "free": {
        "title": "Start for free!",
        "subtitle": "Discover the joy of sharing at no cost."
      },
      "sponsored": {
        "title": "Your subscription\nis free!",
        "subtitle": "Enjoy the full experience thanks to",
        "offeredBy": "Offered by:"
      },
      "upsell": {
        "title": "Share\nwith peace of mind",
        "subtitle": "Subscribe to activate coverage for your shared items.",
        "withSubscription": "By subscribing to",
        "damageCoverageDescription": "For items that are lent and borrowed"
      },
      "success": {
        "title": "Thank you, {{name}}!",
        "subtitle": "Your subscription is active and you now have access to the full experience",
        "yourSubscription": "Your subscription",
        "currentPlan": {
          "monthly": "You currently have a monthly subscription.",
          "yearly": "You currently have a yearly subscription.",
          "no": "Your subscription is active."
        },
        "billingNote": {
          "monthly": "*You will be billed {{price}} / month on the renewal date. Cancel up to 24 hours before your next payment date.",
          "yearly": "*You will be billed {{price}} / year on the renewal date. Cancel up to 24 hours before your next payment date."
        },
        "nextPayment": "Next payment",
        "cancelAnytime": "Cancel anytime",
        "cancellationDescription": "You can cancel your subscription up to 24 hours before the date of your next payment. Your subscription will renew each year."
      }
    },
    "congratulation": {
      "congratulation": "Congratulations!",
      "text1": "{{name}}, you are officially a sharer.",
      "text2": "You have received a free subscription",
      "text3": "Thanks to {{name}}, your subscription is free. 🎉\n\n",
      "text4": "Take the opportunity to share as much as you want with the community.",
      "freeTrial": {
        "text1": "You now have \naccess to the community.",
        "text2": "1 free borrow",
        "text3": "Lending? Always free.",
        "text4": "Afterwards, if you want to continue borrowing, choose your subscription:",
        "text5": "We don’t charge anything without your consent.",
        "price": {
          "yearly": {
            "CAD": "$60 (yearly, save $36)",
            "EUR": "€72 (yearly, save €36)",
            "USD": "72 USD (yearly, save 36 USD)"
          }
        }
      },
      "buttonText": "Next"
    },
    "responsibility": {
      "headerText": "Partage Club is <strong>responsible</strong>!",
      "footerText": "Thanks to your subscription, if an item worth $25 or more is damaged during a loan, we compensate you <strong>up to $300 per year.</strong>"
    },
    "respect": {
      "headerText": "A <strong>caring</strong> and <strong>respectful</strong> community!",
      "footerText": "<strong>Less than 1%</strong> of borrowed items are damaged. And often, they come back even cleaner. It’s magical."
    },
    "transaction": {
      "headerText": "With Partage Club, there is <strong>no exchange of money</strong>",
      "footerText": "Sharing is not renting. Here, we <strong>help each other</strong>. We <strong>lend</strong>. \nWe <strong>borrow</strong>."
    },
    "trust": {
      "headerText": "With Partage Club, <strong>trust</strong> comes <strong>first</strong>",
      "footerText": "We prioritize <strong>exchanges in public places</strong> and use a recommendation system to keep you <strong>safe</strong>."
    },
    "free": {
      "headerText": "With Partage Club, <strong>trust</strong> comes <strong>first</strong>",
      "footerText": "And if you’re the type to help often, we can even recognize you as an <strong>ambassador</strong> and give you your subscription."
    },
    "button": {
      "next": "Next",
      "previous": "Previous",
      "skip": "Skip"
    }
  },
  "quickInterest": {
    "headerTitle": "Interests",
    "title": "What are your interests?",
    "subtitle": "Personalize your recommendations and get notified of new offers.",
    "instruction": "Select one or more interests:",
    "nothingSelectedError": {
      "buttonText": "Back",
      "text": "You must select at least one interest to continue.",
      "title": "Select 1+ interest(s)"
    },
    "button": {
      "confirm": "Confirm",
      "skip": "Maybe later"
    }
  },
  "borrowerNext": {
    "headerTitle": "Borrow",
    "title": "What would you like to do now?",
    "searchLabel": "Search for a specific item",
    "searchPlaceholder": "Waffle maker, carpet cleaner…",
    "inspirationButton": "I need inspiration"
  },
  "lenderNext": {
    "headerTitle": "Lend",
    "title": "What would you like to do now?",
    "specificObjectButton": "I have a specific item to lend",
    "inspirationButton": "I need inspiration"
  },
  "interests": {
    "headerTitle": "Interests",
    "title": "Interests",
    "nothingSelectedError": {
      "buttonText": "Back",
      "text": "You must select at least one item to continue.",
      "title": "Select 1+ item(s)"
    },
    "explain": {
      "title": {
        "borrower": "Dear borrower!",
        "lender": "Dear lender!",
        "both": "Dear borrower!"
      },
      "subtitle": {
        "borrower": "Tell us what you like and what you dream of trying so we can suggest items made for you.",
        "lender": "Show other members what you have to offer. \n\nNeed inspiration? \nTell us a bit about yourself and we’ll suggest ideas for items to lend.",
        "both": "Tell us what you like and what you dream of trying so we can suggest items made for you."
      }
    },
    "chooseTag": {
      "title": {
        "borrower": "What are your interests?",
        "lender": "Choose the categories of items you own",
        "both": "What are your interests?"
      },
      "subtitle": {
        "borrower": "Do you like camping or board games? Add your interests to your profile and let us show you what might appeal to you.",
        "lender": "This will help us suggest ideas for items you could lend.",
        "both": "Do you like camping or board games? Add your interests to your profile and let us show you what might appeal to you."
      }
    },
    "chooseListing": {
      "title": {
        "borrower": "{{name}}",
        "lender": "{{name}}",
        "both": "{{name}}"
      },
      "subtitle": {
        "borrower": "We spotted items that match your interests! Add them to your favorites.",
        "lender": "We found items that are often requested that you could lend.",
        "both": "We spotted items that match your interests! Add them to your favorites."
      },
      "aggregateTitle": {
        "borrower": "Based on the categories you chose, here are items you might like.",
        "lender": "Based on the categories you chose, we found often-requested items you could lend.",
        "both": "Based on the categories you chose, here are items you might like."
      }
    },
    "button": {
      "continue": "Continue",
      "completeProfile": "Complete my profile",
      "skip": "Maybe later",
      "modifyInterests": "Edit my interests",
      "pass": "Skip"
    },
    "loading": "Loading suggestions...",
    "noListingsFound": "Unfortunately, no items were found for this category."
  },
  "ambassador": {
    "title": "Ambassador Space",
    "banner": {
      "title": "Make sharing shine!",
      "subtitle": "Become an Ambassador and grow the community"
    },
    "subtitle": {
      "isAmbassador": "You are an\n<strong>Ambassador</strong>",
      "notYetAmbassador": "Become an\n<strong>Ambassador</strong>"
    },
    "description": {
      "isAmbassador": "An ambassador is an engaged member who <strong>actively contributes to bringing sharing to life in their community</strong>.\n\nThey act as a <strong>local landmark</strong>, facilitate exchanges and help Partage Club grow in a human and authentic way.",
      "notYetAmbassador": "An ambassador is an engaged member who <strong>actively contributes to bringing sharing to life in their community</strong>.\n\nThey act as a <strong>local landmark</strong>, facilitate exchanges and help Partage Club grow in a human and authentic way."
    },
    "showMore": "see more",
    "showLess": "see less",
    "ctaButton": "Become an Ambassador",
    "channelDiscussion": "Discussion Channel",
    "advantages": {
      "titleIsAmbassador": "Your advantages",
      "titleNotYet": "The advantages",
      "advantage1": {
        "title": "Be part of a community",
        "body": "People in your neighbourhood who, like you, want to build local resilience"
      },
      "advantage2": {
        "title": "Free subscriptions",
        "body": "Your subscription is free and we can provide extras when you organise events"
      },
      "advantage3": {
        "title": "Decision-making power",
        "body": "Share your opinion on future priorities and projects for Partage Club and the ambassador program"
      },
      "advantage4": {
        "title": "Special Partage Club event invitations",
        "body": "Join annual gatherings bringing together ambassadors from the area"
      },
      "advantage5": {
        "title": "Access to items provided by Partage Club",
        "body": "Keep items in foster care and benefit from access to them"
      },
      "advantage6": {
        "title": "Special promotions at sharing venues (coming soon)",
        "body": "Enjoy promotions offered by sharing venues near you: discounts, gifts and more..."
      }
    },
    "mission": {
      "title": "The mission",
      "description": "<strong>Being an Ambassador...</strong>\nIs spreading the sharing mission at your scale, in the way that suits you. Everyone gets involved according to their time, desires and strengths.",
      "mission1": "Represent the brand authentically",
      "mission2": "Inspire and mobilise your community: encourage sharing, lead by example and create a ripple effect in your neighbourhood",
      "mission3": "Recruit new members",
      "mission4": "Share items",
      "concreteTitle": "Concretely, this can mean:",
      "concreteIntro": "",
      "concrete1": "Spread the word about Partage Club",
      "concrete2": "Keep items in foster care at home",
      "concrete3": "Organise activities and sharing moments",
      "concrete4": "Participate in content creation",
      "concrete5": "Propose your own ideas...",
      "learnMore": "Learn more"
    }
  },
  "streak": {
    "headerTitle": "Neighbourhood streak",
    "headerTitleDaily": "Daily streak",
    "title": "Neighbourhood streak",
    "thisMonth": "This month",
    "monthlyStreak": "Monthly streak",
    "members": "Members",
    "membersCount_one": "{{displayCount}} member",
    "membersCount_other": "{{displayCount}} members",
    "noMembers": "No members are part of this neighbourhood streak yet.",
    "objective": "Objective this month",
    "shares": "shares",
    "daysRemaining_one": "{{count}} day remaining",
    "daysRemaining_other": "{{count}} days remaining",
    "myContribution": "My contribution: {{count}}",
    "savedThisMonth": "saved this month",
    "viewMyImpact": "View my impact",
    "objectiveDetailsTitle": "Objective details",
    "objectiveDetails": "The objective for the month is determined based on the number of sharing neighbours around you and the maturity of your neighbourhood.",
    "seriesDetailsTitle": "Monthly streak",
    "seriesDetails": "To keep the sharing flame alive, you and your neighbours must reach the indicated sharing goal for the month.",
    "dailyContributions": "Daily contributions",
    "contributionDetailsTitle": "Daily contribution",
    "contributionDetails": "Contributions are all actions that promote sharing, such as posting offers/requests, adding offers to favourites, and responding to requests.",
    "currentStreakLabel": "Current streak",
    "days": "days",
    "day": "Day {{day}}",
    "contributeDailyTitle": "Contribute daily to keep your flame alive!",
    "makeMyDailyContribution": "Make today's contribution",
    "alreadyContributedToday": "Today's contribution done ✓",
    "myProgress": "How to make my first sharing action?",
    "tips": {
      "publishRequest": {
        "title": "Post a request to borrow",
        "description": "Need an item? Members around you will try to help."
      },
      "browseCatalog": {
        "title": "Browse the catalogue",
        "description": "Explore the catalogue and propose borrowing dates."
      },
      "helpNeighbours": {
        "title": "Try to help your neighbours",
        "description": "Browse requests from members around you; you can hide those you can't help with."
      },
      "publishOffer": {
        "title": "Post an offer to lend",
        "description": "Share a specific item or pick from the suggested ones."
      }
    },
    "neighbourhoodFirstShare": "In your neighbourhood, <strong>{{percent}}% of your neighbours</strong> made their first share <strong>in less than a week</strong>",
    "empty": {
      "title": "Start your streak and contribute now!",
      "cta": "Light the sharing flame"
    },
    "contributions": {
      "add_avatar": {
        "title": "Add a photo",
        "description": "A profile picture reassures your neighbours and makes you recognisable in the community.",
        "cta": "Add my photo"
      },
      "add_bio": {
        "title": "Add a bio",
        "description": "Introduce yourself in a few words to make other members want to lend to you and borrow from you.",
        "cta": "Add my bio"
      },
      "publish_offer": {
        "title": "Publish an offer",
        "description": "Publish a specific item, or choose from suggested items already shared by our neighbours!",
        "cta": "Publish an offer"
      },
      "publish_request": {
        "title": "Publish a need",
        "description": "Need an item? Publish a need and members around you will try to help.",
        "cta": "Publish a need"
      },
      "dismiss_request": {
        "title": "Try to help your neighbours",
        "description": "Explore the needs of members around you; you can hide those you can't respond to.",
        "cta": "Explore needs"
      },
      "send_message": {
        "title": "Send a message",
        "description": "Break the ice! Write to a neighbour to offer help or learn more about a listing.",
        "cta": "Go to my conversations"
      },
      "add_favourite": {
        "title": "Save offers to favourites",
        "description": "Browse the catalogue and save relevant offers to come back to them later.",
        "cta": "Explore offers"
      }
    },
    "skip": "See another suggestion"
  },
  "superPartageur": {
    "title": "Super Sharer",
    "subtitle": {
      "isSuper": "You are a\n<strong>Super Sharer</strong>",
      "notYetSuper": "Become a\n<strong>Super Sharer</strong>"
    },
    "requirements": {
      "trustPoints": {
        "emoji": "👍",
        "title": "{{value}} Recommendations",
        "description": "Out of {{requiredValue}} required"
      },
      "responseRate": {
        "emoji": "🛎️",
        "title": "{{value}}% Response Rate",
        "description": "Must be greater than {{requiredValue}}%"
      },
      "lastActiveDays": {
        "emoji": "⏱️",
        "title": "Active",
        "description": "In the last {{requiredValue}} days"
      }
    },
    "learnMore": "Criteria details"
  },
  "superPartageurDetails": {
    "title": "Criteria details",
    "title2": "Super Sharer",
    "description": "What’s a Super Sharer?\nA sharer who consistently engages with the community.\n\nGood news: anyone can become one!\nThe criteria are simple and automatically evaluated every day.\n\nTo earn your badge, just meet these 3 conditions:",
    "requirements": {
      "trustPoints": {
        "title": "Recommendations",
        "description": "Receive <strong>{{requiredValue}} positive recommendations (👍)</strong> from members after sharing, either by lending or borrowing."
      },
      "responseRate": {
        "title": "Response rate",
        "description": "Don't ghost! 👻\n\nMaintain a response rate to member messages <strong>greater than {{requiredValue}}%</strong>."
      },
      "lastActiveDays": {
        "title": "Active",
        "description": "Have opened the app <strong>at least once in the last {{requiredValue}} days</strong>."
      }
    }
  },
  "superPartageurNotification": {
    "title": {
      "isSuper": "Congratulations\n{{name}}!",
      "lostSuper": "Your badge is gone? Don’t worry — it’s completely normal."
    },
    "description": {
      "lostSuper": "We’ve updated the Super Sharer badge criteria. It’s no longer just about sharing—your badge evolves with your activity, recommendations, and response rate.",
      "keptSuper": "You're still a <strong>Super Sharer</strong> — even with the new criteria!",
      "isNowSuper": "You are now a\n<strong>Super Sharer</strong>."
    },
    "progress": {
      "one": "<strong>Great, you’re on the right track.</strong>",
      "two": "<strong>Great, you’re almost there!</strong>"
    },
    "goToDetailsButton": "See details"
  },
  "trialPromo": {
    "title": "Help grow the Partage Club catalog and win your subscription!",
    "details": "Help grow the <strong>Partage Club</strong> catalog! Publish 5 offers and win your <strong>annual subscription</strong>! 🥳",
    "primaryButtonText": "Create an offer!",
    "numCreated0": "{{numOffersCreated}}/5 offers created",
    "numCreated1": "{{numOffersCreated}}/5 offer created",
    "numCreated": "{{numOffersCreated}}/5 offers created"
  },
  "tutorial": {
    "guardian": {
      "step1": {
        "title": "New",
        "text": "Entrust your item to its borrower for as long as you wish by designating them as guardian. They can use it and lend it to others.",
        "cta": "Got it"
      }
    },
    "finish": "Complete",
    "stepIndicator": "Step {{current}} of {{total}}",
    "back": "Back",
    "chatCreation": {
      "step1": {
        "title": "New",
        "text": "Tap here to create a private conversation with another member or a group conversation",
        "cta": "Got it"
      }
    },
    "firstConversation": {
      "step1": {
        "title": "Introduce yourself",
        "text": "You should first send a quick message to the member to introduce yourself, and express your interest.",
        "cta": "Got it"
      }
    },
    "chatIntro": {
      "step1": {
        "title": "👋 Introduce yourself",
        "text": "Send a quick message to the member to introduce yourself and express your interest.",
        "cta": "Next"
      },
      "step2": {
        "title": "Propose borrowing dates",
        "text": "Tap here to open the calendar and choose a start and end date for the loan. The lender can then accept or decline it.",
        "cta": "Got it"
      },
      "step2AltRequest": {
        "title": "Propose lending dates",
        "text": "Tap here to open the calendar and choose a start and end date for the loan. The borrower can then accept or decline it.",
        "cta": "Got it"
      }
    },
    "firstMessageSent": {
      "step1": {
        "title": "Suggest dates",
        "text": "Once agreed upon, don't forget to suggest dates for this loan.",
        "cta": "Got it"
      }
    },
    "next": "Next",
    "multipleOffers": {
      "step1": {
        "title": "Publish your first item",
        "text": "By offering your items, you even encourage your shyest neighbors to ask."
      }
    },
    "publishOffers": {
      "step1": {
        "title": "Take care of items",
        "text": "Here, <strong>trust</strong> prevails. All members commit to respecting the golden rules.\n\nIn case of any problem, <strong>the Partage Club team</strong> is at your service at any time. (1/5)"
      },
      "step2": {
        "title": "Take the first step",
        "text": "By offering your items, you even encourage <strong>your shyest neighbors</strong> to ask. You can always lend your items, even <strong>without a subscription</strong>.\n\nTap the icon to continue. (2/5)"
      },
      "step2AltCorp": {
        "title": "Take the first step",
        "text": "By offering your items, you even encourage <strong>your shyest neighbors</strong> to ask.\n\nTap the icon to continue. (2/5)"
      },
      "step3": {
        "title": "2 ways to offer your items for sharing",
        "text": "Publish one item at a time or multiple item at once, with a single click. <strong>Select multiple offers</strong> to continue. (3/5)"
      },
      "step4": {
        "title": "Your listing is published",
        "text": "You can modify your listings at any time. (4/5)"
      },
      "step4AltPlural": {
        "title": "Your listings are published",
        "text": "You can modify your listings at any time. (4/5)"
      },
      "step5": {
        "title": "Publish one item at a time",
        "text": "You can publish an individual offer at any time by taking a photo of your item. (5/5)"
      },
      "stepFinal": {
        "title": "Congratulations!",
        "text": "You now master the art of sharing items.\n\nBy publishing your first offer, you have increased your impact. You have reached a new level: Contributor."
      }
    },
    "conciergerie": {
      "step1": {
        "title": "New",
        "text": "When the assistant contacts a member and they respond, the conversation is marked with a symbol to help you spot it."
      }
    },
    "homeExplore": {
      "stepIndicator": "Step {{current}} of {{total}}",
      "back": "Back",
      "step1": {
        "title": "Search for an item",
        "text": "Use the search bar and filters to find an item and make a loan request.",
        "cta": "Next"
      },
      "step2": {
        "title": "Publish an offer or a need",
        "text": "Use this quick button to publish a lending offer for a specific item or choose from offers we have already prepared. You can also ask the community for help by posting a need.",
        "cta": "Next"
      },
      "step3": {
        "title": "How does it work?",
        "text": "Click here to get help with the sharing process.",
        "cta": "Got it"
      }
    },
    "contactMember": {
      "step1": {
        "title": "Almost there! Contact them",
        "text": "Take a moment to review the listing details. If it matches your needs, tap here to get in touch with the lender.",
        "cta": "Got it"
      }
    }
  },
  "tutorialModal": {
    "publishOffers": {
      "ctaButton": "Start (2 min)",
      "text": "<strong>How to offer your items for sharing</strong>",
      "title": "Learn the art of sharing"
    }
  },
  "listing-activity": {
    "headerTitle": "Activity",
    "wantToHelp_one": "{{count}} member wants to help",
    "wantToHelp": "{{count}} members want to help",
    "wantedToHelp_one": "{{count}} member wanted to help",
    "wantedToHelp": "{{count}} members wanted to help",
    "leaveAMessage": "left a message",
    "hasLent": "has lent"
  },
  "posts": {
    "newPost": {
      "title": "Share your experience",
      "intro": "Your experience can help other members get started. What did you enjoy about this exchange?",
      "loading": "Loading your exchange...",
      "exchangeLabel": "Your exchange",
      "exchangeHint": "Your post will be visible on this item’s page.",
      "unavailableTitle": "This exchange isn’t available",
      "unavailableText": "Posts can only be created by the borrower, once per exchange.",
      "goBack": "Go back",
      "addPhotos": "Add photos",
      "optional": "Optional",
      "publicBadge": "Public post",
      "publicHint": "This will appear in your community feed. It is not a private rating.",
      "dismissPublicHint": "Dismiss public post notice",
      "storyTitle": "Share your story",
      "storyHint": "Share what happened, what you loved, or a helpful detail for others.",
      "textPlaceholder": "I was able to repair my bike in an afternoon thanks to this tool…",
      "photoHint": "Add up to 10 photos to bring your story to life.",
      "submitButton": "Publish my experience"
    },
    "editPost": {
      "listingLabel": "Related listing",
      "title": "Edit review",
      "intro": "You can edit the message you shared about this exchange. Remember, this message is public and visible to your community.",
      "addPhotos": "Add photos",
      "publicBadge": "Public post",
      "publicHint": "This will appear in your community feed. It is not a private rating.",
      "storyTitle": "Tell the story",
      "storyHint": "Share what happened, what you loved, or a helpful detail for others.",
      "textPlaceholder": "Tell us about your experience...",
      "submitButton": "Save changes"
    },
    "banner": {
      "lender": "Lender",
      "borrower": "Borrower"
    },
    "reviews": {
      "readMore": "Read more",
      "loading": "Loading reviews...",
      "trustedMember": "{{count}} trusted member review",
      "trustedMember_plural": "{{count}} trusted member reviews",
      "count": "{{count}} review",
      "count_plural": "{{count}} reviews"
    },
    "feed": {
      "endOfFeed": {
        "status": "You’re all caught up!",
        "title": "Your turn to tell the next story.",
        "description": "A borrowed item, a new connection…\nShare your story with the neighbourhood.",
        "action": "Tell my story",
        "actionHint": "Choose a past borrowing to share your story."
      },
      "loading": "Loading posts...",
      "timeAgo": "{{time}} ago",
      "emptyTitle": "No posts yet",
      "emptyText": "Community stories will appear here after a completed exchange.",
      "readMore": "Read more",
      "readLess": "See less",
      "likes_one": "{{count}} like",
      "likes_other": "{{count}} likes",
      "comments_one": "{{count}} comment",
      "comments_other": "{{count}} comments",
      "aboutItem": "About {{item}}",
      "listingLabel": "Listing",
      "likeAction": "Like post",
      "unlikeAction": "Unlike post",
      "photoPosition": "Photo {{current}} of {{total}}",
      "openPhoto": "Open photo {{current}} of {{total}}",
      "postOptions": "Post options",
      "lenderLabel": "Lender",
      "lentBy": "Lent by {{name}}",
      "loanContext": "{{lenderName}} lent {{listingName}} to {{borrowerName}}",
      "loanContextShort": "Loan of {{listingName}}",
      "shareAction": "Share post",
      "editAction": "Edit post",
      "reportAction": "Report post",
      "cancel": "Cancel",
      "shareCopied": "Post details copied",
      "reportPostPrompt": "Hi, I'd like to report a post from {{name}} about {{item}} because it seems inappropriate. Could you review it?\n\nThank you."
    },
    "comments": {
      "title": "Comments",
      "emptyTitle": "Start the conversation",
      "empty": "Be the first to leave a thoughtful comment.",
      "count_one": "1 comment",
      "count_other": "{{count}} comments",
      "send": "Send",
      "placeholder": "Write a thoughtful comment…",
      "postBy": "Post by {{name}}",
      "aboutItem": "About {{item}}",
      "showPost": "View full post",
      "showLess": "Show less",
      "publicHint": "Visible to the community",
      "loadError": "Unable to load comments.",
      "submitError": "Unable to post your comment. Please try again."
    },
    "storyComposer": {
      "addPhotos": "Add a moment in pictures",
      "publicHint": "Shared publicly with your community.",
      "storyTitle": "Your story",
      "textPlaceholder": "Thanks to this borrowing, I…",
      "photoHint": "Optional · up to 10 photos",
      "submitButton": "Share my story",
      "composeTitle": "Bring that moment to life.",
      "composeHint": "A project, a discovery, a little kindness. Tell it your way.",
      "changeMemory": "Another borrowing",
      "neighbour": "a neighbour",
      "borrowedFrom": "Borrowed from {{name}}",
      "borrowedOn": "Borrowed on {{date}}",
      "timeAgo": "Ended {{time}} ago",
      "shortStoryHint": "A few words are enough",
      "starterHint": "Need a starting point?",
      "prompts": {
        "made": "Made something",
        "tried": "Tried something",
        "thanks": "Say thanks"
      },
      "starters": {
        "made": "Thanks to this borrowing, I made ",
        "tried": "This was my first time trying ",
        "thanks": "A big thank-you to {{name}} for "
      },
      "dismissPublicHint": "Dismiss public post notice",
      "discardTitle": "Discard this story?",
      "discardMessage": "Choosing another borrowing will discard the text and photos in this draft.",
      "keepWriting": "Keep writing",
      "discardStory": "Discard story"
    }
  },
  "unavailable": {
    "clearButtonLabel": "Clear",
    "clearHint": "Remove this range if you are available again.",
    "selectRangeHint": "Select a start date, then an end date (tap the same day again for a single day).",
    "singleDayRangeHint": "One day selected: you will be unavailable for that full day.",
    "title": "Report me unavailable",
    "topInformation": "I am unavailable during this period...",
    "suspendNotificationsLabel": "Suspend notifications?",
    "saveButtonLabel": "Save"
  },
  "listing-comments": {
    "title_zero": "Comments",
    "title_one": "1 comment",
    "title_other": "{{count}} comments",
    "title": "Comments",
    "placeholder": "Add a comment...",
    "send": "Send",
    "delete": "Delete",
    "empty": "No comments yet. Be the first to ask a question!",
    "loginToComment": "Log in to leave a comment.",
    "showMore": "Show {{count}} more comment(s)",
    "showLess": "Show less"
  },
  "new-conversation": {
    "title": "New message",
    "searchPlaceholder": "Enter a name",
    "dmChat": "Private chat (only 2 people)",
    "groupChat": "Group chat (3+ people)",
    "noResults": "No users found"
  },
  "new-group-chat": {
    "title": "New group",
    "groupNamePlaceholder": "Group name (optional)",
    "addMembers_one": "Add member ({{count}})",
    "addMembers": "Add members ({{count}})",
    "minimumMembersError": "Add at least 2 members to create a group conversation.",
    "searchPlaceholder": "Search a member",
    "next": "Next",
    "noResults": "No users found",
    "defaultGroupName_one": "Group ({{count}} member)",
    "defaultGroupName": "Group ({{count}} members)",
    "choosePhoto": "Choose photo",
    "choosePhotoHint": "Choose a picture to personalize your group chat"
  },
  "add-chat-members": {
    "title": "Add members",
    "addButton": "Add ({{count}})",
    "searchPlaceholder": "Search a member",
    "noResults": "No users found",
    "alreadyMember": "Already a member",
    "forbiddenTitle": "Only admins can add members",
    "forbiddenBody": "You need to be a group admin to add members to this conversation.",
    "backButton": "Back"
  },
  "web-footer": {
    "apps": "Apps",
    "openingHours": {
      "title": "Opening hours",
      "weekdays": "Monday to Friday",
      "hours": "9 a.m. to 5 p.m."
    },
    "follow": {
      "title": "Follow us"
    },
    "about": {
      "title": "About",
      "fundraising": "Fundraising",
      "pressKit": "Press kit",
      "joinTeam": "Join our team",
      "myCity": "My city",
      "faq": "FAQ",
      "terms": "Terms and conditions",
      "privacy": "Privacy policy"
    },
    "community": {
      "title": "Community",
      "gift": "Give as a gift",
      "ambassador": "Become an ambassador",
      "neighbourhood": "Your neighbourhood"
    }
  },
  "offer-hub": {
    "completedLists_one": "List completed",
    "completedLists_other": "Lists completed",
    "title": "Offer hub",
    "heading": "Got it? Share it.",
    "explanation": "Swipe right or tap “I have this” to publish instantly.",
    "accept": "I have this",
    "reject": "I don’t have it",
    "visibility": "Sharing with {{destinations}}",
    "noDestinations": "no destinations selected",
    "editVisibility": "Change where I share",
    "doneEditing": "Done",
    "selectDestination": "Select at least one neighbourhood or club to publish offers.",
    "loading": "Getting things ready…",
    "retryLoading": "Try loading again",
    "storageError": "Some choices could not be saved on this device. Keep the app open and retry to protect them.",
    "retry": "Retry",
    "loadError": "Unable to load your suggestions. Please try again.",
    "progress": "{{current}} / {{total}}",
    "encouragement": "A few choices. More to share.",
    "completeTitle": "Nicely done!",
    "completeDescription": "Every choice helps. Thanks for taking a look around.",
    "caughtUp": "All caught up!",
    "caughtUpDescription": "Let’s find your next share at home.",
    "more_one": "Try 1 more",
    "more_other": "Try {{count}} more",
    "challenge": "Find 3 things worth sharing.",
    "challengeDescription": "Everyday things can make someone’s day. Take a look in…",
    "viewOffers": "View my offers",
    "failedTitle": "These choices need attention",
    "otherWays": "Have something else in mind?",
    "single": "Create an offer",
    "photos": "A few photos",
    "donate": "Donate an item",
    "edit": "Edit",
    "lastItem": "Last one — you’re almost there!",
    "roundProgress": "Items reviewed",
    "acceptHint": "Publishes an offer to your selected neighbourhoods and clubs.",
    "published_one": "offer published",
    "published_other": "offers published",
    "pending_one": "choice saving",
    "pending_other": "choices saving",
    "failed_one": "needs review",
    "failed_other": "need review",
    "pendingDescription": "Your choices are saving. You can keep exploring.",
    "singleDescription": "Add an item of your own.",
    "photosDescription": "Create several offers.",
    "eyebrow": "QUICK OFFERS",
    "challengeEyebrow": "A LITTLE TREASURE HUNT",
    "huntCupboard": "Kitchen",
    "huntLivingRoom": "Living room",
    "huntGarage": "Garage",
    "startHunt": "Find my 3 gems",
    "huntPhotos": "We’ll help turn the photos into offers.",
    "huntSingle": "Start with one item. You can add more later.",
    "remaining_one": "One left",
    "remaining_other": "{{count}} left",
    "chooseRoom": "Where shall we look first?",
    "roomPrompt": "Anything here ringing a bell?",
    "kitchenIdeas": "A waffle maker, a cake tin, a blender…",
    "livingIdeas": "A board game, a projector, a yoga mat…",
    "garageIdeas": "A drill, a stepladder, a bike pump…",
    "photographFinds": "Photograph my finds",
    "tabs": {
      "suggestions": "Suggestions",
      "photos": "Photos",
      "manual": "Manual",
      "stories": "Stories"
    },
    "help": "Replay tutorial",
    "close": "Close",
    "backToHub": "Back to suggestions",
    "listRemaining": "{{count}} remaining",
    "beginTutorial": "Get started!",
    "startList": "Start a list",
    "quickSignal_one": "Publish 1 item in {{seconds}} seconds!",
    "quickSignal_other": "Publish {{count}} items in {{seconds}} seconds!",
    "quickTitle": "Publish items",
    "quickCardStart": "Start",
    "whyPublish": "Why publish offers?",
    "benefitReciprocity": "It makes others want to return the favor",
    "benefitTrust": "Others will trust you more",
    "benefitKarma": "It’s good karma",
    "resumeList": "Resume the list",
    "startTitle": "Do you have these items?",
    "startDescription": "Go through a list of items ready to publish instantly",
    "resumeTitle": "You’re almost there!",
    "resumeDescription": "Finish your current list",
    "listComplete": "You finished this list!",
    "lifetimeStats": "Your statistics since you created your account",
    "publishedLabel": "Offer(s) published",
    "manageOffers": "Manage my offers",
    "finish": "Finish",
    "restart": "Restart",
    "swipeTutorial": {
      "0": {
        "title": "Ready to publish\nquickly?",
        "description": "Go through a list of items ready to publish instantly"
      },
      "1": {
        "title": "Have the item? Swipe right",
        "description": "You can edit the details later"
      },
      "2": {
        "title": "Don't have the item? Swipe left",
        "description": "You won’t see this item in the list again"
      },
      "3": {
        "title": "You’re all set!",
        "description": "You know everything you need to start your first list"
      }
    },
    "tutorial": {
      "step": "Step {{current}} of {{total}}",
      "back": "Back",
      "next": "Next",
      "finish": "Finish",
      "close": "Close tutorial",
      "steps": {
        "suggestions": {
          "title": "Suggested quick offers",
          "description": "Browse a list of pre-existing offers to publish instantly"
        },
        "photos": {
          "title": "Publish in bulk",
          "description": "Take photos of several items. We generate the descriptions so all you have to do is review them before publishing the offers"
        },
        "manual": {
          "title": "Manual entry",
          "description": "Create your offer for one specific item"
        }
      }
    },
    "listingTypes": {
      "offer": "Offer",
      "request": "Need"
    },
    "object": "Item",
    "storyLoadingError": "Unable to load your listings.",
    "storyPickTitle": "What did borrowing make possible?",
    "storyPickHint": "Behind every borrowed item is a moment worth sharing. Revisit a past borrowing to start your story.",
    "storyMemories": "Your past borrowings",
    "storyLoading": "Finding your sharing memories…",
    "storyEmpty": "Your next story is still ahead. Once you’ve finished a borrowing, you can share the moment here."
  },
  "featurePresentations": {
    "title": "What’s new",
    "close": "Close",
    "guardian": {
      "title": "You can now leave your items with a guardian!",
      "description": "If you lend to the same borrower <strong>regularly</strong>, you can leave your item in their <strong>care</strong> for as long as you like.\n\nWith your permission, they can also lend your item to other members.\n\nFind this option in the loan details."
    }
  },
  "guardian": {
    "badge": "In guardianship",
    "action": "Designate {{name}} as guardian",
    "confirmation": "Confirmation",
    "confirmAssign": "You are about to designate {{name}} as guardian of your item.\n\nYour offer will be marked “In guardianship”. Contact {{name}} from the offer details whenever you want to arrange its return.",
    "endsLoan": "This action will complete the current loan",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "member": "this member",
    "reclaim": "I’ve retrieved my item",
    "confirmReclaim": "Have you retrieved your item? Confirming ends guardianship. The guardian will no longer be able to lend it.",
    "history": "{{name}} designated guardian on {{date}}. Loan completed.",
    "banner": "Item entrusted to a guardian {{ago}} ago",
    "guardian": "🪽 Guardian",
    "since": "for {{ago}}",
    "contact": "Contact the 🪽 guardian",
    "lastActive": "Active {{ago}} ago",
    "owner": "👑 Owner",
    "contactOwner": "Contact the 👑 owner",
    "manageOffer": "Edit offer"
  },
  "support-profile": {
    "title": "Help & Support",
    "officialTeam": "Official team",
    "welcomeTitle": "Need help?",
    "welcomeDescription": "The {{team}} team is here to help with your exchanges and using the app.",
    "loanGuide": "How does a loan work?",
    "compensation": "Breakage/theft coverage and compensation",
    "managePlan": "Manage my Partage+ subscription",
    "manageAccount": "Manage my account",
    "helpCenter": "Visit the full help center",
    "resourcesTitle": "Find an answer",
    "email": "Email support",
    "contactSupport": "Contact support",
    "faq": "View our online FAQ"
  }
}
